export const administrativeAreas = {
  hot: [
    {
      NUM: '11',
      NAME: '北京'
    },
    {
      NUM: '31',
      NAME: '上海'
    },
    {
      NUM: '12',
      NAME: '天津'
    },
    {
      NUM: '50',
      NAME: '重庆'
    },
    {
      NUM: '4401',
      NAME: '广州'
    }
  ],
  normal: [
    {
      NAME: '安徽',
      NUM: '34',
      CODE: 'A',
      children: [
        {
          NAME: '安庆',
          NUM: '3408',
          children: [
            {
              NAME: '安徽安庆经济开发区',
              NUM: '340871',
              children: []
            },
            {
              NAME: '大观区',
              NUM: '340803',
              children: []
            },
            {
              NAME: '怀宁县',
              NUM: '340822',
              children: []
            },
            {
              NAME: '潜山市',
              NUM: '340882',
              children: []
            },
            {
              NAME: '宿松县',
              NUM: '340826',
              children: []
            },
            {
              NAME: '太湖县',
              NUM: '340825',
              children: []
            },
            {
              NAME: '桐城市',
              NUM: '340881',
              children: []
            },
            {
              NAME: '望江县',
              NUM: '340827',
              children: []
            },
            {
              NAME: '迎江区',
              NUM: '340802',
              children: []
            },
            {
              NAME: '宜秀区',
              NUM: '340811',
              children: []
            },
            {
              NAME: '岳西县',
              NUM: '340828',
              children: []
            }
          ]
        },
        {
          NAME: '蚌埠',
          NUM: '3403',
          children: [
            {
              NAME: '蚌山区',
              NUM: '340303',
              children: []
            },
            {
              NAME: '蚌埠市高新技术开发区',
              NUM: '340371',
              children: []
            },
            {
              NAME: '蚌埠市经济开发区',
              NUM: '340372',
              children: []
            },
            {
              NAME: '固镇县',
              NUM: '340323',
              children: []
            },
            {
              NAME: '淮上区',
              NUM: '340311',
              children: []
            },
            {
              NAME: '怀远县',
              NUM: '340321',
              children: []
            },
            {
              NAME: '龙子湖区',
              NUM: '340302',
              children: []
            },
            {
              NAME: '五河县',
              NUM: '340322',
              children: []
            },
            {
              NAME: '禹会区',
              NUM: '340304',
              children: []
            }
          ]
        },
        {
          NAME: '亳州',
          NUM: '3416',
          children: [
            {
              NAME: '利辛县',
              NUM: '341623',
              children: []
            },
            {
              NAME: '蒙城县',
              NUM: '341622',
              children: []
            },
            {
              NAME: '谯城区',
              NUM: '341602',
              children: []
            },
            {
              NAME: '涡阳县',
              NUM: '341621',
              children: []
            }
          ]
        },
        {
          NAME: '池州',
          NUM: '3417',
          children: [
            {
              NAME: '东至县',
              NUM: '341721',
              children: []
            },
            {
              NAME: '贵池区',
              NUM: '341702',
              children: []
            },
            {
              NAME: '青阳县',
              NUM: '341723',
              children: []
            },
            {
              NAME: '石台县',
              NUM: '341722',
              children: []
            }
          ]
        },
        {
          NAME: '滁州',
          NUM: '3411',
          children: [
            {
              NAME: '滁州经济技术开发区',
              NUM: '341172',
              children: []
            },
            {
              NAME: '定远县',
              NUM: '341125',
              children: []
            },
            {
              NAME: '凤阳县',
              NUM: '341126',
              children: []
            },
            {
              NAME: '来安县',
              NUM: '341122',
              children: []
            },
            {
              NAME: '琅琊区',
              NUM: '341102',
              children: []
            },
            {
              NAME: '明光市',
              NUM: '341182',
              children: []
            },
            {
              NAME: '南谯区',
              NUM: '341103',
              children: []
            },
            {
              NAME: '全椒县',
              NUM: '341124',
              children: []
            },
            {
              NAME: '天长市',
              NUM: '341181',
              children: []
            },
            {
              NAME: '中新苏滁高新技术产业开发区',
              NUM: '341171',
              children: []
            }
          ]
        },
        {
          NAME: '阜阳',
          NUM: '3412',
          children: [
            {
              NAME: '阜南县',
              NUM: '341225',
              children: []
            },
            {
              NAME: '阜阳合肥现代产业园区',
              NUM: '341271',
              children: []
            },
            {
              NAME: '阜阳经济技术开发区',
              NUM: '341272',
              children: []
            },
            {
              NAME: '界首市',
              NUM: '341282',
              children: []
            },
            {
              NAME: '临泉县',
              NUM: '341221',
              children: []
            },
            {
              NAME: '太和县',
              NUM: '341222',
              children: []
            },
            {
              NAME: '颍东区',
              NUM: '341203',
              children: []
            },
            {
              NAME: '颍泉区',
              NUM: '341204',
              children: []
            },
            {
              NAME: '颍上县',
              NUM: '341226',
              children: []
            },
            {
              NAME: '颍州区',
              NUM: '341202',
              children: []
            }
          ]
        },
        {
          NAME: '合肥',
          NUM: '3401',
          children: [
            {
              NAME: '包河区',
              NUM: '340111',
              children: []
            },
            {
              NAME: '巢湖市',
              NUM: '340181',
              children: []
            },
            {
              NAME: '肥东县',
              NUM: '340122',
              children: []
            },
            {
              NAME: '肥西县',
              NUM: '340123',
              children: []
            },
            {
              NAME: '合肥高新技术产业开发区',
              NUM: '340176',
              children: []
            },
            {
              NAME: '合肥经济技术开发区',
              NUM: '340177',
              children: []
            },
            {
              NAME: '合肥新站高新技术产业开发区',
              NUM: '340178',
              children: []
            },
            {
              NAME: '庐江县',
              NUM: '340124',
              children: []
            },
            {
              NAME: '庐阳区',
              NUM: '340103',
              children: []
            },
            {
              NAME: '蜀山区',
              NUM: '340104',
              children: []
            },
            {
              NAME: '瑶海区',
              NUM: '340102',
              children: []
            },
            {
              NAME: '长丰县',
              NUM: '340121',
              children: []
            }
          ]
        },
        {
          NAME: '淮北',
          NUM: '3406',
          children: [
            {
              NAME: '杜集区',
              NUM: '340602',
              children: []
            },
            {
              NAME: '烈山区',
              NUM: '340604',
              children: []
            },
            {
              NAME: '濉溪县',
              NUM: '340621',
              children: []
            },
            {
              NAME: '相山区',
              NUM: '340603',
              children: []
            }
          ]
        },
        {
          NAME: '淮南',
          NUM: '3404',
          children: [
            {
              NAME: '八公山区',
              NUM: '340405',
              children: []
            },
            {
              NAME: '大通区',
              NUM: '340402',
              children: []
            },
            {
              NAME: '凤台县',
              NUM: '340421',
              children: []
            },
            {
              NAME: '潘集区',
              NUM: '340406',
              children: []
            },
            {
              NAME: '寿县',
              NUM: '340422',
              children: []
            },
            {
              NAME: '田家庵区',
              NUM: '340403',
              children: []
            },
            {
              NAME: '谢家集区',
              NUM: '340404',
              children: []
            }
          ]
        },
        {
          NAME: '黄山',
          NUM: '3410',
          children: [
            {
              NAME: '黄山区',
              NUM: '341003',
              children: []
            },
            {
              NAME: '徽州区',
              NUM: '341004',
              children: []
            },
            {
              NAME: '祁门县',
              NUM: '341024',
              children: []
            },
            {
              NAME: '歙县',
              NUM: '341021',
              children: []
            },
            {
              NAME: '屯溪区',
              NUM: '341002',
              children: []
            },
            {
              NAME: '休宁县',
              NUM: '341022',
              children: []
            },
            {
              NAME: '黟县',
              NUM: '341023',
              children: []
            }
          ]
        },
        {
          NAME: '六安',
          NUM: '3415',
          children: [
            {
              NAME: '霍邱县',
              NUM: '341522',
              children: []
            },
            {
              NAME: '霍山县',
              NUM: '341525',
              children: []
            },
            {
              NAME: '金安区',
              NUM: '341502',
              children: []
            },
            {
              NAME: '金寨县',
              NUM: '341524',
              children: []
            },
            {
              NAME: '舒城县',
              NUM: '341523',
              children: []
            },
            {
              NAME: '叶集区',
              NUM: '341504',
              children: []
            },
            {
              NAME: '裕安区',
              NUM: '341503',
              children: []
            }
          ]
        },
        {
          NAME: '马鞍山',
          NUM: '3405',
          children: [
            {
              NAME: '博望区',
              NUM: '340506',
              children: []
            },
            {
              NAME: '当涂县',
              NUM: '340521',
              children: []
            },
            {
              NAME: '含山县',
              NUM: '340522',
              children: []
            },
            {
              NAME: '和县',
              NUM: '340523',
              children: []
            },
            {
              NAME: '花山区',
              NUM: '340503',
              children: []
            },
            {
              NAME: '雨山区',
              NUM: '340504',
              children: []
            }
          ]
        },
        {
          NAME: '宿州',
          NUM: '3413',
          children: [
            {
              NAME: '砀山县',
              NUM: '341321',
              children: []
            },
            {
              NAME: '灵璧县',
              NUM: '341323',
              children: []
            },
            {
              NAME: '泗县',
              NUM: '341324',
              children: []
            },
            {
              NAME: '宿州经济技术开发区',
              NUM: '341372',
              children: []
            },
            {
              NAME: '宿州马鞍山现代产业园区',
              NUM: '341371',
              children: []
            },
            {
              NAME: '萧县',
              NUM: '341322',
              children: []
            },
            {
              NAME: '埇桥区',
              NUM: '341302',
              children: []
            }
          ]
        },
        {
          NAME: '铜陵',
          NUM: '3407',
          children: [
            {
              NAME: '郊区',
              NUM: '340711',
              children: []
            },
            {
              NAME: '铜官区',
              NUM: '340705',
              children: []
            },
            {
              NAME: '义安区',
              NUM: '340706',
              children: []
            },
            {
              NAME: '枞阳县',
              NUM: '340722',
              children: []
            }
          ]
        },
        {
          NAME: '芜湖',
          NUM: '3402',
          children: [
            {
              NAME: '安徽芜湖三山经济开发区',
              NUM: '340272',
              children: []
            },
            {
              NAME: '繁昌区',
              NUM: '340212',
              children: []
            },
            {
              NAME: '镜湖区',
              NUM: '340202',
              children: []
            },
            {
              NAME: '鸠江区',
              NUM: '340207',
              children: []
            },
            {
              NAME: '南陵县',
              NUM: '340223',
              children: []
            },
            {
              NAME: '湾沚区',
              NUM: '340210',
              children: []
            },
            {
              NAME: '芜湖经济技术开发区',
              NUM: '340271',
              children: []
            },
            {
              NAME: '无为市',
              NUM: '340281',
              children: []
            },
            {
              NAME: '弋江区',
              NUM: '340209',
              children: []
            }
          ]
        },
        {
          NAME: '宣城',
          NUM: '3418',
          children: [
            {
              NAME: '广德市',
              NUM: '341882',
              children: []
            },
            {
              NAME: '旌德县',
              NUM: '341825',
              children: []
            },
            {
              NAME: '泾县',
              NUM: '341823',
              children: []
            },
            {
              NAME: '绩溪县',
              NUM: '341824',
              children: []
            },
            {
              NAME: '郎溪县',
              NUM: '341821',
              children: []
            },
            {
              NAME: '宁国市',
              NUM: '341881',
              children: []
            },
            {
              NAME: '宣城市经济开发区',
              NUM: '341871',
              children: []
            },
            {
              NAME: '宣州区',
              NUM: '341802',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '北京',
      NUM: '11',
      CODE: 'B',
      children: [
        {
          NAME: '北京',
          NUM: '1101',
          children: [
            {
              NAME: '昌平区',
              NUM: '110114',
              children: []
            },
            {
              NAME: '朝阳区',
              NUM: '110105',
              children: []
            },
            {
              NAME: '大兴区',
              NUM: '110115',
              children: []
            },
            {
              NAME: '东城区',
              NUM: '110101',
              children: []
            },
            {
              NAME: '房山区',
              NUM: '110111',
              children: []
            },
            {
              NAME: '丰台区',
              NUM: '110106',
              children: []
            },
            {
              NAME: '海淀区',
              NUM: '110108',
              children: []
            },
            {
              NAME: '怀柔区',
              NUM: '110116',
              children: []
            },
            {
              NAME: '门头沟区',
              NUM: '110109',
              children: []
            },
            {
              NAME: '密云区',
              NUM: '110118',
              children: []
            },
            {
              NAME: '平谷区',
              NUM: '110117',
              children: []
            },
            {
              NAME: '石景山区',
              NUM: '110107',
              children: []
            },
            {
              NAME: '顺义区',
              NUM: '110113',
              children: []
            },
            {
              NAME: '通州区',
              NUM: '110112',
              children: []
            },
            {
              NAME: '西城区',
              NUM: '110102',
              children: []
            },
            {
              NAME: '延庆区',
              NUM: '110119',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '重庆',
      NUM: '50',
      CODE: 'C',
      children: [
        {
          NAME: '重庆',
          NUM: '5001',
          children: [
            {
              NAME: '巴南区',
              NUM: '500113',
              children: []
            },
            {
              NAME: '北碚区',
              NUM: '500109',
              children: []
            },
            {
              NAME: '璧山区',
              NUM: '500120',
              children: []
            },
            {
              NAME: '长寿区',
              NUM: '500115',
              children: []
            },
            {
              NAME: '城口县',
              NUM: '500229',
              children: []
            },
            {
              NAME: '大渡口区',
              NUM: '500104',
              children: []
            },
            {
              NAME: '大足区',
              NUM: '500111',
              children: []
            },
            {
              NAME: '垫江县',
              NUM: '500231',
              children: []
            },
            {
              NAME: '丰都县',
              NUM: '500230',
              children: []
            },
            {
              NAME: '奉节县',
              NUM: '500236',
              children: []
            },
            {
              NAME: '涪陵区',
              NUM: '500102',
              children: []
            },
            {
              NAME: '合川区',
              NUM: '500117',
              children: []
            },
            {
              NAME: '江北区',
              NUM: '500105',
              children: []
            },
            {
              NAME: '江津区',
              NUM: '500116',
              children: []
            },
            {
              NAME: '九龙坡区',
              NUM: '500107',
              children: []
            },
            {
              NAME: '开州区',
              NUM: '500154',
              children: []
            },
            {
              NAME: '梁平区',
              NUM: '500155',
              children: []
            },
            {
              NAME: '南岸区',
              NUM: '500108',
              children: []
            },
            {
              NAME: '南川区',
              NUM: '500119',
              children: []
            },
            {
              NAME: '彭水苗族土家族自治县',
              NUM: '500243',
              children: []
            },
            {
              NAME: '黔江区',
              NUM: '500114',
              children: []
            },
            {
              NAME: '綦江区',
              NUM: '500110',
              children: []
            },
            {
              NAME: '荣昌区',
              NUM: '500153',
              children: []
            },
            {
              NAME: '沙坪坝区',
              NUM: '500106',
              children: []
            },
            {
              NAME: '石柱土家族自治县',
              NUM: '500240',
              children: []
            },
            {
              NAME: '铜梁区',
              NUM: '500151',
              children: []
            },
            {
              NAME: '潼南区',
              NUM: '500152',
              children: []
            },
            {
              NAME: '万州区',
              NUM: '500101',
              children: []
            },
            {
              NAME: '武隆区',
              NUM: '500156',
              children: []
            },
            {
              NAME: '巫山县',
              NUM: '500237',
              children: []
            },
            {
              NAME: '巫溪县',
              NUM: '500238',
              children: []
            },
            {
              NAME: '秀山土家族苗族自治县',
              NUM: '500241',
              children: []
            },
            {
              NAME: '永川区',
              NUM: '500118',
              children: []
            },
            {
              NAME: '酉阳土家族苗族自治县',
              NUM: '500242',
              children: []
            },
            {
              NAME: '渝北区',
              NUM: '500112',
              children: []
            },
            {
              NAME: '云阳县',
              NUM: '500235',
              children: []
            },
            {
              NAME: '渝中区',
              NUM: '500103',
              children: []
            },
            {
              NAME: '忠县',
              NUM: '500233',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '福建',
      NUM: '35',
      CODE: 'F',
      children: [
        {
          NAME: '福州',
          NUM: '3501',
          children: [
            {
              NAME: '仓山区',
              NUM: '350104',
              children: []
            },
            {
              NAME: '长乐区',
              NUM: '350112',
              children: []
            },
            {
              NAME: '福清市',
              NUM: '350181',
              children: []
            },
            {
              NAME: '鼓楼区',
              NUM: '350102',
              children: []
            },
            {
              NAME: '晋安区',
              NUM: '350111',
              children: []
            },
            {
              NAME: '连江县',
              NUM: '350122',
              children: []
            },
            {
              NAME: '罗源县',
              NUM: '350123',
              children: []
            },
            {
              NAME: '马尾区',
              NUM: '350105',
              children: []
            },
            {
              NAME: '闽侯县',
              NUM: '350121',
              children: []
            },
            {
              NAME: '闽清县',
              NUM: '350124',
              children: []
            },
            {
              NAME: '平潭县',
              NUM: '350128',
              children: []
            },
            {
              NAME: '台江区',
              NUM: '350103',
              children: []
            },
            {
              NAME: '永泰县',
              NUM: '350125',
              children: []
            }
          ]
        },
        {
          NAME: '龙岩',
          NUM: '3508',
          children: [
            {
              NAME: '长汀县',
              NUM: '350821',
              children: []
            },
            {
              NAME: '连城县',
              NUM: '350825',
              children: []
            },
            {
              NAME: '上杭县',
              NUM: '350823',
              children: []
            },
            {
              NAME: '武平县',
              NUM: '350824',
              children: []
            },
            {
              NAME: '新罗区',
              NUM: '350802',
              children: []
            },
            {
              NAME: '永定区',
              NUM: '350803',
              children: []
            },
            {
              NAME: '漳平市',
              NUM: '350881',
              children: []
            }
          ]
        },
        {
          NAME: '南平',
          NUM: '3507',
          children: [
            {
              NAME: '光泽县',
              NUM: '350723',
              children: []
            },
            {
              NAME: '建瓯市',
              NUM: '350783',
              children: []
            },
            {
              NAME: '建阳区',
              NUM: '350703',
              children: []
            },
            {
              NAME: '浦城县',
              NUM: '350722',
              children: []
            },
            {
              NAME: '邵武市',
              NUM: '350781',
              children: []
            },
            {
              NAME: '顺昌县',
              NUM: '350721',
              children: []
            },
            {
              NAME: '松溪县',
              NUM: '350724',
              children: []
            },
            {
              NAME: '武夷山市',
              NUM: '350782',
              children: []
            },
            {
              NAME: '延平区',
              NUM: '350702',
              children: []
            },
            {
              NAME: '政和县',
              NUM: '350725',
              children: []
            }
          ]
        },
        {
          NAME: '宁德',
          NUM: '3509',
          children: [
            {
              NAME: '福安市',
              NUM: '350981',
              children: []
            },
            {
              NAME: '福鼎市',
              NUM: '350982',
              children: []
            },
            {
              NAME: '古田县',
              NUM: '350922',
              children: []
            },
            {
              NAME: '蕉城区',
              NUM: '350902',
              children: []
            },
            {
              NAME: '屏南县',
              NUM: '350923',
              children: []
            },
            {
              NAME: '寿宁县',
              NUM: '350924',
              children: []
            },
            {
              NAME: '霞浦县',
              NUM: '350921',
              children: []
            },
            {
              NAME: '柘荣县',
              NUM: '350926',
              children: []
            },
            {
              NAME: '周宁县',
              NUM: '350925',
              children: []
            }
          ]
        },
        {
          NAME: '莆田',
          NUM: '3503',
          children: [
            {
              NAME: '城厢区',
              NUM: '350302',
              children: []
            },
            {
              NAME: '涵江区',
              NUM: '350303',
              children: []
            },
            {
              NAME: '荔城区',
              NUM: '350304',
              children: []
            },
            {
              NAME: '仙游县',
              NUM: '350322',
              children: []
            },
            {
              NAME: '秀屿区',
              NUM: '350305',
              children: []
            }
          ]
        },
        {
          NAME: '泉州',
          NUM: '3505',
          children: [
            {
              NAME: '安溪县',
              NUM: '350524',
              children: []
            },
            {
              NAME: '德化县',
              NUM: '350526',
              children: []
            },
            {
              NAME: '丰泽区',
              NUM: '350503',
              children: []
            },
            {
              NAME: '惠安县',
              NUM: '350521',
              children: []
            },
            {
              NAME: '晋江市',
              NUM: '350582',
              children: []
            },
            {
              NAME: '金门县',
              NUM: '350527',
              children: []
            },
            {
              NAME: '鲤城区',
              NUM: '350502',
              children: []
            },
            {
              NAME: '洛江区',
              NUM: '350504',
              children: []
            },
            {
              NAME: '南安市',
              NUM: '350583',
              children: []
            },
            {
              NAME: '泉港区',
              NUM: '350505',
              children: []
            },
            {
              NAME: '石狮市',
              NUM: '350581',
              children: []
            },
            {
              NAME: '永春县',
              NUM: '350525',
              children: []
            }
          ]
        },
        {
          NAME: '三明',
          NUM: '3504',
          children: [
            {
              NAME: '大田县',
              NUM: '350425',
              children: []
            },
            {
              NAME: '将乐县',
              NUM: '350428',
              children: []
            },
            {
              NAME: '建宁县',
              NUM: '350430',
              children: []
            },
            {
              NAME: '明溪县',
              NUM: '350421',
              children: []
            },
            {
              NAME: '宁化县',
              NUM: '350424',
              children: []
            },
            {
              NAME: '清流县',
              NUM: '350423',
              children: []
            },
            {
              NAME: '三元区',
              NUM: '350404',
              children: []
            },
            {
              NAME: '沙县区',
              NUM: '350405',
              children: []
            },
            {
              NAME: '泰宁县',
              NUM: '350429',
              children: []
            },
            {
              NAME: '永安市',
              NUM: '350481',
              children: []
            },
            {
              NAME: '尤溪县',
              NUM: '350426',
              children: []
            }
          ]
        },
        {
          NAME: '厦门',
          NUM: '3502',
          children: [
            {
              NAME: '海沧区',
              NUM: '350205',
              children: []
            },
            {
              NAME: '湖里区',
              NUM: '350206',
              children: []
            },
            {
              NAME: '集美区',
              NUM: '350211',
              children: []
            },
            {
              NAME: '思明区',
              NUM: '350203',
              children: []
            },
            {
              NAME: '同安区',
              NUM: '350212',
              children: []
            },
            {
              NAME: '翔安区',
              NUM: '350213',
              children: []
            }
          ]
        },
        {
          NAME: '漳州',
          NUM: '3506',
          children: [
            {
              NAME: '东山县',
              NUM: '350626',
              children: []
            },
            {
              NAME: '华安县',
              NUM: '350629',
              children: []
            },
            {
              NAME: '龙海区',
              NUM: '350604',
              children: []
            },
            {
              NAME: '龙文区',
              NUM: '350603',
              children: []
            },
            {
              NAME: '南靖县',
              NUM: '350627',
              children: []
            },
            {
              NAME: '平和县',
              NUM: '350628',
              children: []
            },
            {
              NAME: '芗城区',
              NUM: '350602',
              children: []
            },
            {
              NAME: '云霄县',
              NUM: '350622',
              children: []
            },
            {
              NAME: '漳浦县',
              NUM: '350623',
              children: []
            },
            {
              NAME: '长泰区',
              NUM: '350605',
              children: []
            },
            {
              NAME: '诏安县',
              NUM: '350624',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '甘肃',
      NUM: '62',
      CODE: 'G',
      children: [
        {
          NAME: '白银',
          NUM: '6204',
          children: [
            {
              NAME: '白银区',
              NUM: '620402',
              children: []
            },
            {
              NAME: '会宁县',
              NUM: '620422',
              children: []
            },
            {
              NAME: '景泰县',
              NUM: '620423',
              children: []
            },
            {
              NAME: '靖远县',
              NUM: '620421',
              children: []
            },
            {
              NAME: '平川区',
              NUM: '620403',
              children: []
            }
          ]
        },
        {
          NAME: '定西',
          NUM: '6211',
          children: [
            {
              NAME: '安定区',
              NUM: '621102',
              children: []
            },
            {
              NAME: '临洮县',
              NUM: '621124',
              children: []
            },
            {
              NAME: '陇西县',
              NUM: '621122',
              children: []
            },
            {
              NAME: '岷县',
              NUM: '621126',
              children: []
            },
            {
              NAME: '通渭县',
              NUM: '621121',
              children: []
            },
            {
              NAME: '渭源县',
              NUM: '621123',
              children: []
            },
            {
              NAME: '漳县',
              NUM: '621125',
              children: []
            }
          ]
        },
        {
          NAME: '甘南藏族自治州',
          NUM: '6230',
          children: [
            {
              NAME: '迭部县',
              NUM: '623024',
              children: []
            },
            {
              NAME: '合作市',
              NUM: '623001',
              children: []
            },
            {
              NAME: '临潭县',
              NUM: '623021',
              children: []
            },
            {
              NAME: '碌曲县',
              NUM: '623026',
              children: []
            },
            {
              NAME: '玛曲县',
              NUM: '623025',
              children: []
            },
            {
              NAME: '夏河县',
              NUM: '623027',
              children: []
            },
            {
              NAME: '舟曲县',
              NUM: '623023',
              children: []
            },
            {
              NAME: '卓尼县',
              NUM: '623022',
              children: []
            }
          ]
        },
        {
          NAME: '嘉峪关',
          NUM: '6202',
          children: []
        },
        {
          NAME: '金昌',
          NUM: '6203',
          children: [
            {
              NAME: '金川区',
              NUM: '620302',
              children: []
            },
            {
              NAME: '永昌县',
              NUM: '620321',
              children: []
            }
          ]
        },
        {
          NAME: '酒泉',
          NUM: '6209',
          children: [
            {
              NAME: '阿克塞哈萨克族自治县',
              NUM: '620924',
              children: []
            },
            {
              NAME: '敦煌市',
              NUM: '620982',
              children: []
            },
            {
              NAME: '瓜州县',
              NUM: '620922',
              children: []
            },
            {
              NAME: '金塔县',
              NUM: '620921',
              children: []
            },
            {
              NAME: '肃北蒙古族自治县',
              NUM: '620923',
              children: []
            },
            {
              NAME: '肃州区',
              NUM: '620902',
              children: []
            },
            {
              NAME: '玉门市',
              NUM: '620981',
              children: []
            }
          ]
        },
        {
          NAME: '兰州',
          NUM: '6201',
          children: [
            {
              NAME: '安宁区',
              NUM: '620105',
              children: []
            },
            {
              NAME: '城关区',
              NUM: '620102',
              children: []
            },
            {
              NAME: '皋兰县',
              NUM: '620122',
              children: []
            },
            {
              NAME: '红古区',
              NUM: '620111',
              children: []
            },
            {
              NAME: '兰州新区',
              NUM: '620171',
              children: []
            },
            {
              NAME: '七里河区',
              NUM: '620103',
              children: []
            },
            {
              NAME: '西固区',
              NUM: '620104',
              children: []
            },
            {
              NAME: '永登县',
              NUM: '620121',
              children: []
            },
            {
              NAME: '榆中县',
              NUM: '620123',
              children: []
            }
          ]
        },
        {
          NAME: '临夏回族自治州',
          NUM: '6229',
          children: [
            {
              NAME: '东乡族自治县',
              NUM: '622926',
              children: []
            },
            {
              NAME: '广河县',
              NUM: '622924',
              children: []
            },
            {
              NAME: '和政县',
              NUM: '622925',
              children: []
            },
            {
              NAME: '积石山保安族东乡族撒拉族自治县',
              NUM: '622927',
              children: []
            },
            {
              NAME: '康乐县',
              NUM: '622922',
              children: []
            },
            {
              NAME: '临夏市',
              NUM: '622901',
              children: []
            },
            {
              NAME: '临夏县',
              NUM: '622921',
              children: []
            },
            {
              NAME: '永靖县',
              NUM: '622923',
              children: []
            }
          ]
        },
        {
          NAME: '陇南',
          NUM: '6212',
          children: [
            {
              NAME: '成县',
              NUM: '621221',
              children: []
            },
            {
              NAME: '宕昌县',
              NUM: '621223',
              children: []
            },
            {
              NAME: '徽县',
              NUM: '621227',
              children: []
            },
            {
              NAME: '康县',
              NUM: '621224',
              children: []
            },
            {
              NAME: '两当县',
              NUM: '621228',
              children: []
            },
            {
              NAME: '礼县',
              NUM: '621226',
              children: []
            },
            {
              NAME: '文县',
              NUM: '621222',
              children: []
            },
            {
              NAME: '武都区',
              NUM: '621202',
              children: []
            },
            {
              NAME: '西和县',
              NUM: '621225',
              children: []
            }
          ]
        },
        {
          NAME: '平凉',
          NUM: '6208',
          children: [
            {
              NAME: '崇信县',
              NUM: '620823',
              children: []
            },
            {
              NAME: '华亭市',
              NUM: '620881',
              children: []
            },
            {
              NAME: '泾川县',
              NUM: '620821',
              children: []
            },
            {
              NAME: '静宁县',
              NUM: '620826',
              children: []
            },
            {
              NAME: '崆峒区',
              NUM: '620802',
              children: []
            },
            {
              NAME: '灵台县',
              NUM: '620822',
              children: []
            },
            {
              NAME: '庄浪县',
              NUM: '620825',
              children: []
            }
          ]
        },
        {
          NAME: '庆阳',
          NUM: '6210',
          children: [
            {
              NAME: '合水县',
              NUM: '621024',
              children: []
            },
            {
              NAME: '华池县',
              NUM: '621023',
              children: []
            },
            {
              NAME: '环县',
              NUM: '621022',
              children: []
            },
            {
              NAME: '宁县',
              NUM: '621026',
              children: []
            },
            {
              NAME: '庆城县',
              NUM: '621021',
              children: []
            },
            {
              NAME: '西峰区',
              NUM: '621002',
              children: []
            },
            {
              NAME: '正宁县',
              NUM: '621025',
              children: []
            },
            {
              NAME: '镇原县',
              NUM: '621027',
              children: []
            }
          ]
        },
        {
          NAME: '天水',
          NUM: '6205',
          children: [
            {
              NAME: '甘谷县',
              NUM: '620523',
              children: []
            },
            {
              NAME: '麦积区',
              NUM: '620503',
              children: []
            },
            {
              NAME: '秦安县',
              NUM: '620522',
              children: []
            },
            {
              NAME: '清水县',
              NUM: '620521',
              children: []
            },
            {
              NAME: '秦州区',
              NUM: '620502',
              children: []
            },
            {
              NAME: '武山县',
              NUM: '620524',
              children: []
            },
            {
              NAME: '张家川回族自治县',
              NUM: '620525',
              children: []
            }
          ]
        },
        {
          NAME: '武威',
          NUM: '6206',
          children: [
            {
              NAME: '古浪县',
              NUM: '620622',
              children: []
            },
            {
              NAME: '凉州区',
              NUM: '620602',
              children: []
            },
            {
              NAME: '民勤县',
              NUM: '620621',
              children: []
            },
            {
              NAME: '天祝藏族自治县',
              NUM: '620623',
              children: []
            }
          ]
        },
        {
          NAME: '张掖',
          NUM: '6207',
          children: [
            {
              NAME: '甘州区',
              NUM: '620702',
              children: []
            },
            {
              NAME: '高台县',
              NUM: '620724',
              children: []
            },
            {
              NAME: '临泽县',
              NUM: '620723',
              children: []
            },
            {
              NAME: '民乐县',
              NUM: '620722',
              children: []
            },
            {
              NAME: '山丹县',
              NUM: '620725',
              children: []
            },
            {
              NAME: '肃南裕固族自治县',
              NUM: '620721',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '广东',
      NUM: '44',
      CODE: '',
      children: [
        {
          NAME: '潮州',
          NUM: '4451',
          children: [
            {
              NAME: '潮安区',
              NUM: '445103',
              children: []
            },
            {
              NAME: '饶平县',
              NUM: '445122',
              children: []
            },
            {
              NAME: '湘桥区',
              NUM: '445102',
              children: []
            }
          ]
        },
        {
          NAME: '东莞',
          NUM: '4419',
          children: []
        },
        {
          NAME: '佛山',
          NUM: '4406',
          children: [
            {
              NAME: '禅城区',
              NUM: '440604',
              children: []
            },
            {
              NAME: '高明区',
              NUM: '440608',
              children: []
            },
            {
              NAME: '南海区',
              NUM: '440605',
              children: []
            },
            {
              NAME: '三水区',
              NUM: '440607',
              children: []
            },
            {
              NAME: '顺德区',
              NUM: '440606',
              children: []
            }
          ]
        },
        {
          NAME: '广州',
          NUM: '4401',
          children: [
            {
              NAME: '白云区',
              NUM: '440111',
              children: []
            },
            {
              NAME: '从化区',
              NUM: '440117',
              children: []
            },
            {
              NAME: '海珠区',
              NUM: '440105',
              children: []
            },
            {
              NAME: '花都区',
              NUM: '440114',
              children: []
            },
            {
              NAME: '黄埔区',
              NUM: '440112',
              children: []
            },
            {
              NAME: '荔湾区',
              NUM: '440103',
              children: []
            },
            {
              NAME: '南沙区',
              NUM: '440115',
              children: []
            },
            {
              NAME: '番禺区',
              NUM: '440113',
              children: []
            },
            {
              NAME: '天河区',
              NUM: '440106',
              children: []
            },
            {
              NAME: '越秀区',
              NUM: '440104',
              children: []
            },
            {
              NAME: '增城区',
              NUM: '440118',
              children: []
            }
          ]
        },
        {
          NAME: '河源',
          NUM: '4416',
          children: [
            {
              NAME: '东源县',
              NUM: '441625',
              children: []
            },
            {
              NAME: '和平县',
              NUM: '441624',
              children: []
            },
            {
              NAME: '连平县',
              NUM: '441623',
              children: []
            },
            {
              NAME: '龙川县',
              NUM: '441622',
              children: []
            },
            {
              NAME: '源城区',
              NUM: '441602',
              children: []
            },
            {
              NAME: '紫金县',
              NUM: '441621',
              children: []
            }
          ]
        },
        {
          NAME: '惠州',
          NUM: '4413',
          children: [
            {
              NAME: '博罗县',
              NUM: '441322',
              children: []
            },
            {
              NAME: '惠城区',
              NUM: '441302',
              children: []
            },
            {
              NAME: '惠东县',
              NUM: '441323',
              children: []
            },
            {
              NAME: '惠阳区',
              NUM: '441303',
              children: []
            },
            {
              NAME: '龙门县',
              NUM: '441324',
              children: []
            }
          ]
        },
        {
          NAME: '江门',
          NUM: '4407',
          children: [
            {
              NAME: '恩平市',
              NUM: '440785',
              children: []
            },
            {
              NAME: '鹤山市',
              NUM: '440784',
              children: []
            },
            {
              NAME: '江海区',
              NUM: '440704',
              children: []
            },
            {
              NAME: '开平市',
              NUM: '440783',
              children: []
            },
            {
              NAME: '蓬江区',
              NUM: '440703',
              children: []
            },
            {
              NAME: '台山市',
              NUM: '440781',
              children: []
            },
            {
              NAME: '新会区',
              NUM: '440705',
              children: []
            }
          ]
        },
        {
          NAME: '揭阳',
          NUM: '4452',
          children: [
            {
              NAME: '惠来县',
              NUM: '445224',
              children: []
            },
            {
              NAME: '揭东区',
              NUM: '445203',
              children: []
            },
            {
              NAME: '揭西县',
              NUM: '445222',
              children: []
            },
            {
              NAME: '普宁市',
              NUM: '445281',
              children: []
            },
            {
              NAME: '榕城区',
              NUM: '445202',
              children: []
            }
          ]
        },
        {
          NAME: '茂名',
          NUM: '4409',
          children: [
            {
              NAME: '电白区',
              NUM: '440904',
              children: []
            },
            {
              NAME: '高州市',
              NUM: '440981',
              children: []
            },
            {
              NAME: '化州市',
              NUM: '440982',
              children: []
            },
            {
              NAME: '茂南区',
              NUM: '440902',
              children: []
            },
            {
              NAME: '信宜市',
              NUM: '440983',
              children: []
            }
          ]
        },
        {
          NAME: '梅州',
          NUM: '4414',
          children: [
            {
              NAME: '大埔县',
              NUM: '441422',
              children: []
            },
            {
              NAME: '丰顺县',
              NUM: '441423',
              children: []
            },
            {
              NAME: '蕉岭县',
              NUM: '441427',
              children: []
            },
            {
              NAME: '梅江区',
              NUM: '441402',
              children: []
            },
            {
              NAME: '梅县区',
              NUM: '441403',
              children: []
            },
            {
              NAME: '平远县',
              NUM: '441426',
              children: []
            },
            {
              NAME: '五华县',
              NUM: '441424',
              children: []
            },
            {
              NAME: '兴宁市',
              NUM: '441481',
              children: []
            }
          ]
        },
        {
          NAME: '清远',
          NUM: '4418',
          children: [
            {
              NAME: '佛冈县',
              NUM: '441821',
              children: []
            },
            {
              NAME: '连南瑶族自治县',
              NUM: '441826',
              children: []
            },
            {
              NAME: '连山壮族瑶族自治县',
              NUM: '441825',
              children: []
            },
            {
              NAME: '连州市',
              NUM: '441882',
              children: []
            },
            {
              NAME: '清城区',
              NUM: '441802',
              children: []
            },
            {
              NAME: '清新区',
              NUM: '441803',
              children: []
            },
            {
              NAME: '阳山县',
              NUM: '441823',
              children: []
            },
            {
              NAME: '英德市',
              NUM: '441881',
              children: []
            }
          ]
        },
        {
          NAME: '汕头',
          NUM: '4405',
          children: [
            {
              NAME: '潮南区',
              NUM: '440514',
              children: []
            },
            {
              NAME: '潮阳区',
              NUM: '440513',
              children: []
            },
            {
              NAME: '澄海区',
              NUM: '440515',
              children: []
            },
            {
              NAME: '濠江区',
              NUM: '440512',
              children: []
            },
            {
              NAME: '金平区',
              NUM: '440511',
              children: []
            },
            {
              NAME: '龙湖区',
              NUM: '440507',
              children: []
            },
            {
              NAME: '南澳县',
              NUM: '440523',
              children: []
            }
          ]
        },
        {
          NAME: '汕尾',
          NUM: '4415',
          children: [
            {
              NAME: '城区',
              NUM: '441502',
              children: []
            },
            {
              NAME: '海丰县',
              NUM: '441521',
              children: []
            },
            {
              NAME: '陆丰市',
              NUM: '441581',
              children: []
            },
            {
              NAME: '陆河县',
              NUM: '441523',
              children: []
            }
          ]
        },
        {
          NAME: '韶关',
          NUM: '4402',
          children: [
            {
              NAME: '乐昌市',
              NUM: '440281',
              children: []
            },
            {
              NAME: '南雄市',
              NUM: '440282',
              children: []
            },
            {
              NAME: '曲江区',
              NUM: '440205',
              children: []
            },
            {
              NAME: '仁化县',
              NUM: '440224',
              children: []
            },
            {
              NAME: '乳源瑶族自治县',
              NUM: '440232',
              children: []
            },
            {
              NAME: '始兴县',
              NUM: '440222',
              children: []
            },
            {
              NAME: '翁源县',
              NUM: '440229',
              children: []
            },
            {
              NAME: '武江区',
              NUM: '440203',
              children: []
            },
            {
              NAME: '新丰县',
              NUM: '440233',
              children: []
            },
            {
              NAME: '浈江区',
              NUM: '440204',
              children: []
            }
          ]
        },
        {
          NAME: '深圳',
          NUM: '4403',
          children: [
            {
              NAME: '宝安区',
              NUM: '440306',
              children: []
            },
            {
              NAME: '福田区',
              NUM: '440304',
              children: []
            },
            {
              NAME: '光明区',
              NUM: '440311',
              children: []
            },
            {
              NAME: '龙岗区',
              NUM: '440307',
              children: []
            },
            {
              NAME: '龙华区',
              NUM: '440309',
              children: []
            },
            {
              NAME: '罗湖区',
              NUM: '440303',
              children: []
            },
            {
              NAME: '南山区',
              NUM: '440305',
              children: []
            },
            {
              NAME: '坪山区',
              NUM: '440310',
              children: []
            },
            {
              NAME: '盐田区',
              NUM: '440308',
              children: []
            }
          ]
        },
        {
          NAME: '阳江',
          NUM: '4417',
          children: [
            {
              NAME: '江城区',
              NUM: '441702',
              children: []
            },
            {
              NAME: '阳春市',
              NUM: '441781',
              children: []
            },
            {
              NAME: '阳东区',
              NUM: '441704',
              children: []
            },
            {
              NAME: '阳西县',
              NUM: '441721',
              children: []
            }
          ]
        },
        {
          NAME: '云浮',
          NUM: '4453',
          children: [
            {
              NAME: '罗定市',
              NUM: '445381',
              children: []
            },
            {
              NAME: '新兴县',
              NUM: '445321',
              children: []
            },
            {
              NAME: '云安区',
              NUM: '445303',
              children: []
            },
            {
              NAME: '郁南县',
              NUM: '445322',
              children: []
            },
            {
              NAME: '云城区',
              NUM: '445302',
              children: []
            }
          ]
        },
        {
          NAME: '湛江',
          NUM: '4408',
          children: [
            {
              NAME: '赤坎区',
              NUM: '440802',
              children: []
            },
            {
              NAME: '雷州市',
              NUM: '440882',
              children: []
            },
            {
              NAME: '廉江市',
              NUM: '440881',
              children: []
            },
            {
              NAME: '麻章区',
              NUM: '440811',
              children: []
            },
            {
              NAME: '坡头区',
              NUM: '440804',
              children: []
            },
            {
              NAME: '遂溪县',
              NUM: '440823',
              children: []
            },
            {
              NAME: '吴川市',
              NUM: '440883',
              children: []
            },
            {
              NAME: '霞山区',
              NUM: '440803',
              children: []
            },
            {
              NAME: '徐闻县',
              NUM: '440825',
              children: []
            }
          ]
        },
        {
          NAME: '肇庆',
          NUM: '4412',
          children: [
            {
              NAME: '德庆县',
              NUM: '441226',
              children: []
            },
            {
              NAME: '鼎湖区',
              NUM: '441203',
              children: []
            },
            {
              NAME: '端州区',
              NUM: '441202',
              children: []
            },
            {
              NAME: '封开县',
              NUM: '441225',
              children: []
            },
            {
              NAME: '高要区',
              NUM: '441204',
              children: []
            },
            {
              NAME: '广宁县',
              NUM: '441223',
              children: []
            },
            {
              NAME: '怀集县',
              NUM: '441224',
              children: []
            },
            {
              NAME: '四会市',
              NUM: '441284',
              children: []
            }
          ]
        },
        {
          NAME: '中山',
          NUM: '4420',
          children: []
        },
        {
          NAME: '珠海',
          NUM: '4404',
          children: [
            {
              NAME: '斗门区',
              NUM: '440403',
              children: []
            },
            {
              NAME: '金湾区',
              NUM: '440404',
              children: []
            },
            {
              NAME: '香洲区',
              NUM: '440402',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '广西',
      NUM: '45',
      CODE: '',
      children: [
        {
          NAME: '百色',
          NUM: '4510',
          children: [
            {
              NAME: '德保县',
              NUM: '451024',
              children: []
            },
            {
              NAME: '靖西市',
              NUM: '451081',
              children: []
            },
            {
              NAME: '乐业县',
              NUM: '451028',
              children: []
            },
            {
              NAME: '凌云县',
              NUM: '451027',
              children: []
            },
            {
              NAME: '隆林各族自治县',
              NUM: '451031',
              children: []
            },
            {
              NAME: '那坡县',
              NUM: '451026',
              children: []
            },
            {
              NAME: '平果市',
              NUM: '451082',
              children: []
            },
            {
              NAME: '田东县',
              NUM: '451022',
              children: []
            },
            {
              NAME: '田林县',
              NUM: '451029',
              children: []
            },
            {
              NAME: '田阳区',
              NUM: '451003',
              children: []
            },
            {
              NAME: '西林县',
              NUM: '451030',
              children: []
            },
            {
              NAME: '右江区',
              NUM: '451002',
              children: []
            }
          ]
        },
        {
          NAME: '北海',
          NUM: '4505',
          children: [
            {
              NAME: '海城区',
              NUM: '450502',
              children: []
            },
            {
              NAME: '合浦县',
              NUM: '450521',
              children: []
            },
            {
              NAME: '铁山港区',
              NUM: '450512',
              children: []
            },
            {
              NAME: '银海区',
              NUM: '450503',
              children: []
            }
          ]
        },
        {
          NAME: '崇左',
          NUM: '4514',
          children: [
            {
              NAME: '大新县',
              NUM: '451424',
              children: []
            },
            {
              NAME: '扶绥县',
              NUM: '451421',
              children: []
            },
            {
              NAME: '江州区',
              NUM: '451402',
              children: []
            },
            {
              NAME: '龙州县',
              NUM: '451423',
              children: []
            },
            {
              NAME: '宁明县',
              NUM: '451422',
              children: []
            },
            {
              NAME: '凭祥市',
              NUM: '451481',
              children: []
            },
            {
              NAME: '天等县',
              NUM: '451425',
              children: []
            }
          ]
        },
        {
          NAME: '防城港',
          NUM: '4506',
          children: [
            {
              NAME: '东兴市',
              NUM: '450681',
              children: []
            },
            {
              NAME: '防城区',
              NUM: '450603',
              children: []
            },
            {
              NAME: '港口区',
              NUM: '450602',
              children: []
            },
            {
              NAME: '上思县',
              NUM: '450621',
              children: []
            }
          ]
        },
        {
          NAME: '贵港',
          NUM: '4508',
          children: [
            {
              NAME: '港北区',
              NUM: '450802',
              children: []
            },
            {
              NAME: '港南区',
              NUM: '450803',
              children: []
            },
            {
              NAME: '桂平市',
              NUM: '450881',
              children: []
            },
            {
              NAME: '平南县',
              NUM: '450821',
              children: []
            },
            {
              NAME: '覃塘区',
              NUM: '450804',
              children: []
            }
          ]
        },
        {
          NAME: '桂林',
          NUM: '4503',
          children: [
            {
              NAME: '叠彩区',
              NUM: '450303',
              children: []
            },
            {
              NAME: '恭城瑶族自治县',
              NUM: '450332',
              children: []
            },
            {
              NAME: '灌阳县',
              NUM: '450327',
              children: []
            },
            {
              NAME: '灵川县',
              NUM: '450323',
              children: []
            },
            {
              NAME: '临桂区',
              NUM: '450312',
              children: []
            },
            {
              NAME: '荔浦市',
              NUM: '450381',
              children: []
            },
            {
              NAME: '龙胜各族自治县',
              NUM: '450328',
              children: []
            },
            {
              NAME: '平乐县',
              NUM: '450330',
              children: []
            },
            {
              NAME: '七星区',
              NUM: '450305',
              children: []
            },
            {
              NAME: '全州县',
              NUM: '450324',
              children: []
            },
            {
              NAME: '象山区',
              NUM: '450304',
              children: []
            },
            {
              NAME: '兴安县',
              NUM: '450325',
              children: []
            },
            {
              NAME: '秀峰区',
              NUM: '450302',
              children: []
            },
            {
              NAME: '阳朔县',
              NUM: '450321',
              children: []
            },
            {
              NAME: '雁山区',
              NUM: '450311',
              children: []
            },
            {
              NAME: '永福县',
              NUM: '450326',
              children: []
            },
            {
              NAME: '资源县',
              NUM: '450329',
              children: []
            }
          ]
        },
        {
          NAME: '河池',
          NUM: '4512',
          children: [
            {
              NAME: '巴马瑶族自治县',
              NUM: '451227',
              children: []
            },
            {
              NAME: '大化瑶族自治县',
              NUM: '451229',
              children: []
            },
            {
              NAME: '东兰县',
              NUM: '451224',
              children: []
            },
            {
              NAME: '都安瑶族自治县',
              NUM: '451228',
              children: []
            },
            {
              NAME: '凤山县',
              NUM: '451223',
              children: []
            },
            {
              NAME: '环江毛南族自治县',
              NUM: '451226',
              children: []
            },
            {
              NAME: '金城江区',
              NUM: '451202',
              children: []
            },
            {
              NAME: '罗城仫佬族自治县',
              NUM: '451225',
              children: []
            },
            {
              NAME: '南丹县',
              NUM: '451221',
              children: []
            },
            {
              NAME: '天峨县',
              NUM: '451222',
              children: []
            },
            {
              NAME: '宜州区',
              NUM: '451203',
              children: []
            }
          ]
        },
        {
          NAME: '贺州',
          NUM: '4511',
          children: [
            {
              NAME: '八步区',
              NUM: '451102',
              children: []
            },
            {
              NAME: '富川瑶族自治县',
              NUM: '451123',
              children: []
            },
            {
              NAME: '平桂区',
              NUM: '451103',
              children: []
            },
            {
              NAME: '昭平县',
              NUM: '451121',
              children: []
            },
            {
              NAME: '钟山县',
              NUM: '451122',
              children: []
            }
          ]
        },
        {
          NAME: '来宾',
          NUM: '4513',
          children: [
            {
              NAME: '合山市',
              NUM: '451381',
              children: []
            },
            {
              NAME: '金秀瑶族自治县',
              NUM: '451324',
              children: []
            },
            {
              NAME: '武宣县',
              NUM: '451323',
              children: []
            },
            {
              NAME: '象州县',
              NUM: '451322',
              children: []
            },
            {
              NAME: '忻城县',
              NUM: '451321',
              children: []
            },
            {
              NAME: '兴宾区',
              NUM: '451302',
              children: []
            }
          ]
        },
        {
          NAME: '柳州',
          NUM: '4502',
          children: [
            {
              NAME: '城中区',
              NUM: '450202',
              children: []
            },
            {
              NAME: '柳北区',
              NUM: '450205',
              children: []
            },
            {
              NAME: '柳城县',
              NUM: '450222',
              children: []
            },
            {
              NAME: '柳江区',
              NUM: '450206',
              children: []
            },
            {
              NAME: '柳南区',
              NUM: '450204',
              children: []
            },
            {
              NAME: '鹿寨县',
              NUM: '450223',
              children: []
            },
            {
              NAME: '融安县',
              NUM: '450224',
              children: []
            },
            {
              NAME: '融水苗族自治县',
              NUM: '450225',
              children: []
            },
            {
              NAME: '三江侗族自治县',
              NUM: '450226',
              children: []
            },
            {
              NAME: '鱼峰区',
              NUM: '450203',
              children: []
            }
          ]
        },
        {
          NAME: '南宁',
          NUM: '4501',
          children: [
            {
              NAME: '宾阳县',
              NUM: '450126',
              children: []
            },
            {
              NAME: '横州市',
              NUM: '450181',
              children: []
            },
            {
              NAME: '江南区',
              NUM: '450105',
              children: []
            },
            {
              NAME: '良庆区',
              NUM: '450108',
              children: []
            },
            {
              NAME: '隆安县',
              NUM: '450123',
              children: []
            },
            {
              NAME: '马山县',
              NUM: '450124',
              children: []
            },
            {
              NAME: '青秀区',
              NUM: '450103',
              children: []
            },
            {
              NAME: '上林县',
              NUM: '450125',
              children: []
            },
            {
              NAME: '武鸣区',
              NUM: '450110',
              children: []
            },
            {
              NAME: '兴宁区',
              NUM: '450102',
              children: []
            },
            {
              NAME: '西乡塘区',
              NUM: '450107',
              children: []
            },
            {
              NAME: '邕宁区',
              NUM: '450109',
              children: []
            }
          ]
        },
        {
          NAME: '钦州',
          NUM: '4507',
          children: [
            {
              NAME: '灵山县',
              NUM: '450721',
              children: []
            },
            {
              NAME: '浦北县',
              NUM: '450722',
              children: []
            },
            {
              NAME: '钦北区',
              NUM: '450703',
              children: []
            },
            {
              NAME: '钦南区',
              NUM: '450702',
              children: []
            }
          ]
        },
        {
          NAME: '梧州',
          NUM: '4504',
          children: [
            {
              NAME: '苍梧县',
              NUM: '450421',
              children: []
            },
            {
              NAME: '岑溪市',
              NUM: '450481',
              children: []
            },
            {
              NAME: '龙圩区',
              NUM: '450406',
              children: []
            },
            {
              NAME: '蒙山县',
              NUM: '450423',
              children: []
            },
            {
              NAME: '藤县',
              NUM: '450422',
              children: []
            },
            {
              NAME: '万秀区',
              NUM: '450403',
              children: []
            },
            {
              NAME: '长洲区',
              NUM: '450405',
              children: []
            }
          ]
        },
        {
          NAME: '玉林',
          NUM: '4509',
          children: [
            {
              NAME: '北流市',
              NUM: '450981',
              children: []
            },
            {
              NAME: '博白县',
              NUM: '450923',
              children: []
            },
            {
              NAME: '福绵区',
              NUM: '450903',
              children: []
            },
            {
              NAME: '陆川县',
              NUM: '450922',
              children: []
            },
            {
              NAME: '容县',
              NUM: '450921',
              children: []
            },
            {
              NAME: '兴业县',
              NUM: '450924',
              children: []
            },
            {
              NAME: '玉州区',
              NUM: '450902',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '贵州',
      NUM: '52',
      CODE: '',
      children: [
        {
          NAME: '安顺',
          NUM: '5204',
          children: [
            {
              NAME: '关岭布依族苗族自治县',
              NUM: '520424',
              children: []
            },
            {
              NAME: '平坝区',
              NUM: '520403',
              children: []
            },
            {
              NAME: '普定县',
              NUM: '520422',
              children: []
            },
            {
              NAME: '西秀区',
              NUM: '520402',
              children: []
            },
            {
              NAME: '镇宁布依族苗族自治县',
              NUM: '520423',
              children: []
            },
            {
              NAME: '紫云苗族布依族自治县',
              NUM: '520425',
              children: []
            }
          ]
        },
        {
          NAME: '毕节',
          NUM: '5205',
          children: [
            {
              NAME: '大方县',
              NUM: '520521',
              children: []
            },
            {
              NAME: '赫章县',
              NUM: '520527',
              children: []
            },
            {
              NAME: '金沙县',
              NUM: '520523',
              children: []
            },
            {
              NAME: '纳雍县',
              NUM: '520525',
              children: []
            },
            {
              NAME: '黔西市',
              NUM: '520581',
              children: []
            },
            {
              NAME: '七星关区',
              NUM: '520502',
              children: []
            },
            {
              NAME: '威宁彝族回族苗族自治县',
              NUM: '520526',
              children: []
            },
            {
              NAME: '织金县',
              NUM: '520524',
              children: []
            }
          ]
        },
        {
          NAME: '贵安新区',
          NUM: '5209',
          children: []
        },
        {
          NAME: '贵阳',
          NUM: '5201',
          children: [
            {
              NAME: '白云区',
              NUM: '520113',
              children: []
            },
            {
              NAME: '观山湖区',
              NUM: '520115',
              children: []
            },
            {
              NAME: '花溪区',
              NUM: '520111',
              children: []
            },
            {
              NAME: '开阳县',
              NUM: '520121',
              children: []
            },
            {
              NAME: '南明区',
              NUM: '520102',
              children: []
            },
            {
              NAME: '清镇市',
              NUM: '520181',
              children: []
            },
            {
              NAME: '乌当区',
              NUM: '520112',
              children: []
            },
            {
              NAME: '息烽县',
              NUM: '520122',
              children: []
            },
            {
              NAME: '修文县',
              NUM: '520123',
              children: []
            },
            {
              NAME: '云岩区',
              NUM: '520103',
              children: []
            }
          ]
        },
        {
          NAME: '六盘水',
          NUM: '5202',
          children: [
            {
              NAME: '六枝特区',
              NUM: '520203',
              children: []
            },
            {
              NAME: '盘州市',
              NUM: '520281',
              children: []
            },
            {
              NAME: '水城区',
              NUM: '520204',
              children: []
            },
            {
              NAME: '钟山区',
              NUM: '520201',
              children: []
            }
          ]
        },
        {
          NAME: '黔东南苗族侗族自治州',
          NUM: '5226',
          children: [
            {
              NAME: '岑巩县',
              NUM: '522626',
              children: []
            },
            {
              NAME: '从江县',
              NUM: '522633',
              children: []
            },
            {
              NAME: '丹寨县',
              NUM: '522636',
              children: []
            },
            {
              NAME: '黄平县',
              NUM: '522622',
              children: []
            },
            {
              NAME: '剑河县',
              NUM: '522629',
              children: []
            },
            {
              NAME: '锦屏县',
              NUM: '522628',
              children: []
            },
            {
              NAME: '凯里市',
              NUM: '522601',
              children: []
            },
            {
              NAME: '雷山县',
              NUM: '522634',
              children: []
            },
            {
              NAME: '黎平县',
              NUM: '522631',
              children: []
            },
            {
              NAME: '麻江县',
              NUM: '522635',
              children: []
            },
            {
              NAME: '榕江县',
              NUM: '522632',
              children: []
            },
            {
              NAME: '三穗县',
              NUM: '522624',
              children: []
            },
            {
              NAME: '施秉县',
              NUM: '522623',
              children: []
            },
            {
              NAME: '台江县',
              NUM: '522630',
              children: []
            },
            {
              NAME: '天柱县',
              NUM: '522627',
              children: []
            },
            {
              NAME: '镇远县',
              NUM: '522625',
              children: []
            }
          ]
        },
        {
          NAME: '黔南布依族苗族自治州',
          NUM: '5227',
          children: [
            {
              NAME: '都匀市',
              NUM: '522701',
              children: []
            },
            {
              NAME: '独山县',
              NUM: '522726',
              children: []
            },
            {
              NAME: '福泉市',
              NUM: '522702',
              children: []
            },
            {
              NAME: '贵定县',
              NUM: '522723',
              children: []
            },
            {
              NAME: '惠水县',
              NUM: '522731',
              children: []
            },
            {
              NAME: '荔波县',
              NUM: '522722',
              children: []
            },
            {
              NAME: '龙里县',
              NUM: '522730',
              children: []
            },
            {
              NAME: '罗甸县',
              NUM: '522728',
              children: []
            },
            {
              NAME: '平塘县',
              NUM: '522727',
              children: []
            },
            {
              NAME: '三都水族自治县',
              NUM: '522732',
              children: []
            },
            {
              NAME: '瓮安县',
              NUM: '522725',
              children: []
            },
            {
              NAME: '长顺县',
              NUM: '522729',
              children: []
            }
          ]
        },
        {
          NAME: '黔西南布依族苗族自治州',
          NUM: '5223',
          children: [
            {
              NAME: '安龙县',
              NUM: '522328',
              children: []
            },
            {
              NAME: '册亨县',
              NUM: '522327',
              children: []
            },
            {
              NAME: '普安县',
              NUM: '522323',
              children: []
            },
            {
              NAME: '晴隆县',
              NUM: '522324',
              children: []
            },
            {
              NAME: '望谟县',
              NUM: '522326',
              children: []
            },
            {
              NAME: '兴仁市',
              NUM: '522302',
              children: []
            },
            {
              NAME: '兴义市',
              NUM: '522301',
              children: []
            },
            {
              NAME: '贞丰县',
              NUM: '522325',
              children: []
            }
          ]
        },
        {
          NAME: '铜仁',
          NUM: '5206',
          children: [
            {
              NAME: '碧江区',
              NUM: '520602',
              children: []
            },
            {
              NAME: '德江县',
              NUM: '520626',
              children: []
            },
            {
              NAME: '江口县',
              NUM: '520621',
              children: []
            },
            {
              NAME: '石阡县',
              NUM: '520623',
              children: []
            },
            {
              NAME: '思南县',
              NUM: '520624',
              children: []
            },
            {
              NAME: '松桃苗族自治县',
              NUM: '520628',
              children: []
            },
            {
              NAME: '万山区',
              NUM: '520603',
              children: []
            },
            {
              NAME: '沿河土家族自治县',
              NUM: '520627',
              children: []
            },
            {
              NAME: '印江土家族苗族自治县',
              NUM: '520625',
              children: []
            },
            {
              NAME: '玉屏侗族自治县',
              NUM: '520622',
              children: []
            }
          ]
        },
        {
          NAME: '遵义',
          NUM: '5203',
          children: [
            {
              NAME: '播州区',
              NUM: '520304',
              children: []
            },
            {
              NAME: '赤水市',
              NUM: '520381',
              children: []
            },
            {
              NAME: '道真仡佬族苗族自治县',
              NUM: '520325',
              children: []
            },
            {
              NAME: '凤冈县',
              NUM: '520327',
              children: []
            },
            {
              NAME: '红花岗区',
              NUM: '520302',
              children: []
            },
            {
              NAME: '汇川区',
              NUM: '520303',
              children: []
            },
            {
              NAME: '湄潭县',
              NUM: '520328',
              children: []
            },
            {
              NAME: '仁怀市',
              NUM: '520382',
              children: []
            },
            {
              NAME: '绥阳县',
              NUM: '520323',
              children: []
            },
            {
              NAME: '桐梓县',
              NUM: '520322',
              children: []
            },
            {
              NAME: '务川仡佬族苗族自治县',
              NUM: '520326',
              children: []
            },
            {
              NAME: '习水县',
              NUM: '520330',
              children: []
            },
            {
              NAME: '余庆县',
              NUM: '520329',
              children: []
            },
            {
              NAME: '正安县',
              NUM: '520324',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '海南',
      NUM: '46',
      CODE: 'H',
      children: [
        {
          NAME: '白沙黎族自治县',
          NUM: '469025',
          children: []
        },
        {
          NAME: '保亭黎族苗族自治县',
          NUM: '469029',
          children: []
        },
        {
          NAME: '昌江黎族自治县',
          NUM: '469026',
          children: []
        },
        {
          NAME: '澄迈县',
          NUM: '469023',
          children: []
        },
        {
          NAME: '儋州',
          NUM: '4604',
          children: []
        },
        {
          NAME: '定安县',
          NUM: '469021',
          children: []
        },
        {
          NAME: '东方',
          NUM: '469007',
          children: []
        },
        {
          NAME: '海口',
          NUM: '4601',
          children: [
            {
              NAME: '龙华区',
              NUM: '460106',
              children: []
            },
            {
              NAME: '美兰区',
              NUM: '460108',
              children: []
            },
            {
              NAME: '琼山区',
              NUM: '460107',
              children: []
            },
            {
              NAME: '秀英区',
              NUM: '460105',
              children: []
            }
          ]
        },
        {
          NAME: '乐东黎族自治县',
          NUM: '469027',
          children: []
        },
        {
          NAME: '临高县',
          NUM: '469024',
          children: [],
          children: []
        },
        {
          NAME: '陵水黎族自治县',
          NUM: '469028',
          children: []
        },
        {
          NAME: '琼海',
          NUM: '469002',
          children: []
        },
        {
          NAME: '琼中黎族苗族自治县',
          NUM: '469030',
          children: []
        },
        {
          NAME: '三沙',
          NUM: '4603',
          children: [
            {
              NAME: '南沙群岛',
              NUM: '460322',
              children: []
            },
            {
              NAME: '西沙群岛',
              NUM: '460321',
              children: []
            },
            {
              NAME: '中沙群岛的岛礁及其海域',
              NUM: '460323',
              children: []
            }
          ]
        },
        {
          NAME: '三亚',
          NUM: '4602',
          children: [
            {
              NAME: '海棠区',
              NUM: '460202',
              children: []
            },
            {
              NAME: '吉阳区',
              NUM: '460203',
              children: []
            },
            {
              NAME: '天涯区',
              NUM: '460204',
              children: []
            },
            {
              NAME: '崖州区',
              NUM: '460205',
              children: []
            }
          ]
        },
        {
          NAME: '屯昌县',
          NUM: '469022',
          children: []
        },
        {
          NAME: '万宁',
          NUM: '469006',
          children: []
        },
        {
          NAME: '文昌',
          NUM: '469005',
          children: []
        },
        {
          NAME: '五指山',
          NUM: '469001',
          children: []
        }
      ]
    },
    {
      NAME: '河北',
      NUM: '13',
      CODE: '',
      children: [
        {
          NAME: '保定',
          NUM: '1306',
          children: [
            {
              NAME: '安国市',
              NUM: '130683',
              children: []
            },
            {
              NAME: '安新县',
              NUM: '130632',
              children: []
            },
            {
              NAME: '保定白沟新城',
              NUM: '130672',
              children: []
            },
            {
              NAME: '保定高新技术产业开发区',
              NUM: '130671',
              children: []
            },
            {
              NAME: '博野县',
              NUM: '130637',
              children: []
            },
            {
              NAME: '定兴县',
              NUM: '130626',
              children: []
            },
            {
              NAME: '定州市',
              NUM: '130682',
              children: []
            },
            {
              NAME: '阜平县',
              NUM: '130624',
              children: []
            },
            {
              NAME: '高碑店市',
              NUM: '130684',
              children: []
            },
            {
              NAME: '高阳县',
              NUM: '130628',
              children: []
            },
            {
              NAME: '竞秀区',
              NUM: '130602',
              children: []
            },
            {
              NAME: '涞水县',
              NUM: '130623',
              children: []
            },
            {
              NAME: '涞源县',
              NUM: '130630',
              children: []
            },
            {
              NAME: '莲池区',
              NUM: '130606',
              children: []
            },
            {
              NAME: '蠡县',
              NUM: '130635',
              children: []
            },
            {
              NAME: '满城区',
              NUM: '130607',
              children: []
            },
            {
              NAME: '清苑区',
              NUM: '130608',
              children: []
            },
            {
              NAME: '曲阳县',
              NUM: '130634',
              children: []
            },
            {
              NAME: '容城县',
              NUM: '130629',
              children: []
            },
            {
              NAME: '顺平县',
              NUM: '130636',
              children: []
            },
            {
              NAME: '唐县',
              NUM: '130627',
              children: []
            },
            {
              NAME: '望都县',
              NUM: '130631',
              children: []
            },
            {
              NAME: '雄县',
              NUM: '130638',
              children: []
            },
            {
              NAME: '徐水区',
              NUM: '130609',
              children: []
            },
            {
              NAME: '易县',
              NUM: '130633',
              children: []
            },
            {
              NAME: '涿州市',
              NUM: '130681',
              children: []
            }
          ]
        },
        {
          NAME: '沧州',
          NUM: '1309',
          children: [
            {
              NAME: '沧县',
              NUM: '130921',
              children: []
            },
            {
              NAME: '沧州渤海新区',
              NUM: '130973',
              children: []
            },
            {
              NAME: '沧州高新技术产业开发区',
              NUM: '130972',
              children: []
            },
            {
              NAME: '东光县',
              NUM: '130923',
              children: []
            },
            {
              NAME: '海兴县',
              NUM: '130924',
              children: []
            },
            {
              NAME: '河北沧州经济开发区',
              NUM: '130971',
              children: []
            },
            {
              NAME: '河间市',
              NUM: '130984',
              children: []
            },
            {
              NAME: '黄骅市',
              NUM: '130983',
              children: []
            },
            {
              NAME: '孟村回族自治县',
              NUM: '130930',
              children: []
            },
            {
              NAME: '南皮县',
              NUM: '130927',
              children: []
            },
            {
              NAME: '泊头市',
              NUM: '130981',
              children: []
            },
            {
              NAME: '青县',
              NUM: '130922',
              children: []
            },
            {
              NAME: '任丘市',
              NUM: '130982',
              children: []
            },
            {
              NAME: '肃宁县',
              NUM: '130926',
              children: []
            },
            {
              NAME: '吴桥县',
              NUM: '130928',
              children: []
            },
            {
              NAME: '献县',
              NUM: '130929',
              children: []
            },
            {
              NAME: '新华区',
              NUM: '130902',
              children: []
            },
            {
              NAME: '盐山县',
              NUM: '130925',
              children: []
            },
            {
              NAME: '运河区',
              NUM: '130903',
              children: []
            }
          ]
        },
        {
          NAME: '承德',
          NUM: '1308',
          children: [
            {
              NAME: '承德高新技术产业开发区',
              NUM: '130871',
              children: []
            },
            {
              NAME: '承德县',
              NUM: '130821',
              children: []
            },
            {
              NAME: '丰宁满族自治县',
              NUM: '130826',
              children: []
            },
            {
              NAME: '宽城满族自治县',
              NUM: '130827',
              children: []
            },
            {
              NAME: '隆化县',
              NUM: '130825',
              children: []
            },
            {
              NAME: '滦平县',
              NUM: '130824',
              children: []
            },
            {
              NAME: '平泉市',
              NUM: '130881',
              children: []
            },
            {
              NAME: '双滦区',
              NUM: '130803',
              children: []
            },
            {
              NAME: '双桥区',
              NUM: '130802',
              children: []
            },
            {
              NAME: '围场满族蒙古族自治县',
              NUM: '130828',
              children: []
            },
            {
              NAME: '兴隆县',
              NUM: '130822',
              children: []
            },
            {
              NAME: '鹰手营子矿区',
              NUM: '130804',
              children: []
            }
          ]
        },
        {
          NAME: '邯郸',
          NUM: '1304',
          children: [
            {
              NAME: '成安县',
              NUM: '130424',
              children: []
            },
            {
              NAME: '磁县',
              NUM: '130427',
              children: []
            },
            {
              NAME: '丛台区',
              NUM: '130403',
              children: []
            },
            {
              NAME: '大名县',
              NUM: '130425',
              children: []
            },
            {
              NAME: '肥乡区',
              NUM: '130407',
              children: []
            },
            {
              NAME: '峰峰矿区',
              NUM: '130406',
              children: []
            },
            {
              NAME: '复兴区',
              NUM: '130404',
              children: []
            },
            {
              NAME: '广平县',
              NUM: '130432',
              children: []
            },
            {
              NAME: '馆陶县',
              NUM: '130433',
              children: []
            },
            {
              NAME: '邯郸冀南新区',
              NUM: '130473',
              children: []
            },
            {
              NAME: '邯郸经济技术开发区',
              NUM: '130471',
              children: []
            },
            {
              NAME: '邯山区',
              NUM: '130402',
              children: []
            },
            {
              NAME: '鸡泽县',
              NUM: '130431',
              children: []
            },
            {
              NAME: '临漳县',
              NUM: '130423',
              children: []
            },
            {
              NAME: '邱县',
              NUM: '130430',
              children: []
            },
            {
              NAME: '曲周县',
              NUM: '130435',
              children: []
            },
            {
              NAME: '涉县',
              NUM: '130426',
              children: []
            },
            {
              NAME: '魏县',
              NUM: '130434',
              children: []
            },
            {
              NAME: '武安市',
              NUM: '130481',
              children: []
            },
            {
              NAME: '永年区',
              NUM: '130408',
              children: []
            }
          ]
        },
        {
          NAME: '衡水',
          NUM: '1311',
          children: [
            {
              NAME: '安平县',
              NUM: '131125',
              children: []
            },
            {
              NAME: '阜城县',
              NUM: '131128',
              children: []
            },
            {
              NAME: '故城县',
              NUM: '131126',
              children: []
            },
            {
              NAME: '河北衡水高新技术产业开发区',
              NUM: '131171',
              children: []
            },
            {
              NAME: '衡水滨湖新区',
              NUM: '131172',
              children: []
            },
            {
              NAME: '景县',
              NUM: '131127',
              children: []
            },
            {
              NAME: '冀州区',
              NUM: '131103',
              children: []
            },
            {
              NAME: '饶阳县',
              NUM: '131124',
              children: []
            },
            {
              NAME: '深州市',
              NUM: '131182',
              children: []
            },
            {
              NAME: '桃城区',
              NUM: '131102',
              children: []
            },
            {
              NAME: '武强县',
              NUM: '131123',
              children: []
            },
            {
              NAME: '武邑县',
              NUM: '131122',
              children: []
            },
            {
              NAME: '枣强县',
              NUM: '131121',
              children: []
            }
          ]
        },
        {
          NAME: '廊坊',
          NUM: '1310',
          children: [
            {
              NAME: '安次区',
              NUM: '131002',
              children: []
            },
            {
              NAME: '霸州市',
              NUM: '131081',
              children: []
            },
            {
              NAME: '大厂回族自治县',
              NUM: '131028',
              children: []
            },
            {
              NAME: '大城县',
              NUM: '131025',
              children: []
            },
            {
              NAME: '广阳区',
              NUM: '131003',
              children: []
            },
            {
              NAME: '固安县',
              NUM: '131022',
              children: []
            },
            {
              NAME: '廊坊经济技术开发区',
              NUM: '131071',
              children: []
            },
            {
              NAME: '三河市',
              NUM: '131082',
              children: []
            },
            {
              NAME: '文安县',
              NUM: '131026',
              children: []
            },
            {
              NAME: '香河县',
              NUM: '131024',
              children: []
            },
            {
              NAME: '永清县',
              NUM: '131023',
              children: []
            }
          ]
        },
        {
          NAME: '秦皇岛',
          NUM: '1303',
          children: [
            {
              NAME: '北戴河区',
              NUM: '130304',
              children: []
            },
            {
              NAME: '北戴河新区',
              NUM: '130372',
              children: []
            },
            {
              NAME: '昌黎县',
              NUM: '130322',
              children: []
            },
            {
              NAME: '抚宁区',
              NUM: '130306',
              children: []
            },
            {
              NAME: '海港区',
              NUM: '130302',
              children: []
            },
            {
              NAME: '卢龙县',
              NUM: '130324',
              children: []
            },
            {
              NAME: '青龙满族自治县',
              NUM: '130371',
              children: []
            },
            {
              NAME: '秦皇岛市经济技术开发区',
              NUM: '130321',
              children: []
            },
            {
              NAME: '山海关区',
              NUM: '130303',
              children: []
            }
          ]
        },
        {
          NAME: '石家庄',
          NUM: '1301',
          children: [
            {
              NAME: '长安区',
              NUM: '130102',
              children: []
            },
            {
              NAME: '藁城区',
              NUM: '130109',
              children: []
            },
            {
              NAME: '高邑县',
              NUM: '130127',
              children: []
            },
            {
              NAME: '井陉矿区',
              NUM: '130107',
              children: []
            },
            {
              NAME: '井陉县',
              NUM: '130121',
              children: []
            },
            {
              NAME: '晋州市',
              NUM: '130183',
              children: []
            },
            {
              NAME: '灵寿县',
              NUM: '130126',
              children: []
            },
            {
              NAME: '栾城区',
              NUM: '130111',
              children: []
            },
            {
              NAME: '鹿泉区',
              NUM: '130110',
              children: []
            },
            {
              NAME: '平山县',
              NUM: '130131',
              children: []
            },
            {
              NAME: '桥西区',
              NUM: '130104',
              children: []
            },
            {
              NAME: '深泽县',
              NUM: '130128',
              children: []
            },
            {
              NAME: '石家庄高新技术产业开发区',
              NUM: '130171',
              children: []
            },
            {
              NAME: '石家庄循环化工园区',
              NUM: '130172',
              children: []
            },
            {
              NAME: '无极县',
              NUM: '130130',
              children: []
            },
            {
              NAME: '行唐县',
              NUM: '130125',
              children: []
            },
            {
              NAME: '新华区',
              NUM: '130105',
              children: []
            },
            {
              NAME: '辛集市',
              NUM: '130181',
              children: []
            },
            {
              NAME: '新乐市',
              NUM: '130184',
              children: []
            },
            {
              NAME: '元氏县',
              NUM: '130132',
              children: []
            },
            {
              NAME: '裕华区',
              NUM: '130108',
              children: []
            },
            {
              NAME: '赞皇县',
              NUM: '130129',
              children: []
            },
            {
              NAME: '赵县',
              NUM: '130133',
              children: []
            },
            {
              NAME: '正定县',
              NUM: '130123',
              children: []
            }
          ]
        },
        {
          NAME: '唐山',
          NUM: '1302',
          children: [
            {
              NAME: '曹妃甸区',
              NUM: '130209',
              children: []
            },
            {
              NAME: '丰南区',
              NUM: '130207',
              children: []
            },
            {
              NAME: '丰润区',
              NUM: '130208',
              children: []
            },
            {
              NAME: '古冶区',
              NUM: '130204',
              children: []
            },
            {
              NAME: '河北唐山海港经济开发区',
              NUM: '130274',
              children: []
            },
            {
              NAME: '河北唐山芦台经济开发区',
              NUM: '130271',
              children: []
            },
            {
              NAME: '开平区',
              NUM: '130205',
              children: []
            },
            {
              NAME: '乐亭县',
              NUM: '130225',
              children: []
            },
            {
              NAME: '滦南县',
              NUM: '130224',
              children: []
            },
            {
              NAME: '滦州市',
              NUM: '130284',
              children: []
            },
            {
              NAME: '路北区',
              NUM: '130203',
              children: []
            },
            {
              NAME: '路南区',
              NUM: '130202',
              children: []
            },
            {
              NAME: '迁安市',
              NUM: '130283',
              children: []
            },
            {
              NAME: '迁西县',
              NUM: '130227',
              children: []
            },
            {
              NAME: '唐山高新技术产业开发区',
              NUM: '130273',
              children: []
            },
            {
              NAME: '唐山市汉沽管理区',
              NUM: '130272',
              children: []
            },
            {
              NAME: '玉田县',
              NUM: '130229',
              children: []
            },
            {
              NAME: '遵化市',
              NUM: '130281',
              children: []
            }
          ]
        },
        {
          NAME: '邢台',
          NUM: '1305',
          children: [
            {
              NAME: '柏乡县',
              NUM: '130524',
              children: []
            },
            {
              NAME: '广宗县',
              NUM: '130531',
              children: []
            },
            {
              NAME: '河北邢台经济开发区',
              NUM: '130571',
              children: []
            },
            {
              NAME: '巨鹿县',
              NUM: '130529',
              children: []
            },
            {
              NAME: '临城县',
              NUM: '130522',
              children: []
            },
            {
              NAME: '临西县',
              NUM: '130535',
              children: []
            },
            {
              NAME: '隆尧县',
              NUM: '130525',
              children: []
            },
            {
              NAME: '南宫市',
              NUM: '130581',
              children: []
            },
            {
              NAME: '南和区',
              NUM: '130506',
              children: []
            },
            {
              NAME: '内丘县',
              NUM: '130523',
              children: []
            },
            {
              NAME: '宁晋县',
              NUM: '130528',
              children: []
            },
            {
              NAME: '平乡县',
              NUM: '130532',
              children: []
            },
            {
              NAME: '襄都区',
              NUM: '130502',
              children: []
            },
            {
              NAME: '信都区',
              NUM: '130503',
              children: []
            },
            {
              NAME: '清河县',
              NUM: '130534',
              children: []
            },
            {
              NAME: '任泽区',
              NUM: '130505',
              children: []
            },
            {
              NAME: '沙河市',
              NUM: '130582',
              children: []
            },
            {
              NAME: '威县',
              NUM: '130533',
              children: []
            },
            {
              NAME: '新河县',
              NUM: '130530',
              children: []
            }
          ]
        },
        {
          NAME: '雄安新区',
          NUM: '1331',
          children: []
        },
        {
          NAME: '张家口',
          NUM: '1307',
          children: [
            {
              NAME: '赤城县',
              NUM: '130732',
              children: []
            },
            {
              NAME: '崇礼区',
              NUM: '130709',
              children: []
            },
            {
              NAME: '沽源县',
              NUM: '130724',
              children: []
            },
            {
              NAME: '怀安县',
              NUM: '130728',
              children: []
            },
            {
              NAME: '怀来县',
              NUM: '130730',
              children: []
            },
            {
              NAME: '康保县',
              NUM: '130723',
              children: []
            },
            {
              NAME: '桥东区',
              NUM: '130702',
              children: []
            },
            {
              NAME: '桥西区',
              NUM: '130703',
              children: []
            },
            {
              NAME: '尚义县',
              NUM: '130725',
              children: []
            },
            {
              NAME: '万全区',
              NUM: '130708',
              children: []
            },
            {
              NAME: '下花园区',
              NUM: '130706',
              children: []
            },
            {
              NAME: '宣化区',
              NUM: '130705',
              children: []
            },
            {
              NAME: '阳原县',
              NUM: '130727',
              children: []
            },
            {
              NAME: '蔚县',
              NUM: '130726',
              children: []
            },
            {
              NAME: '张北县',
              NUM: '130722',
              children: []
            },
            {
              NAME: '张家口经济开发区',
              NUM: '130771',
              children: []
            },
            {
              NAME: '张家口市察北管理区',
              NUM: '130772',
              children: []
            },
            {
              NAME: '张家口市塞北管理区',
              NUM: '130773',
              children: []
            },
            {
              NAME: '涿鹿县',
              NUM: '130731',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '黑龙江',
      NUM: '23',
      CODE: '',
      children: [
        {
          NAME: '大庆',
          NUM: '2306',
          children: [
            {
              NAME: '大庆高新技术产业开发区',
              NUM: '230671',
              children: []
            },
            {
              NAME: '大同区',
              NUM: '230606',
              children: []
            },
            {
              NAME: '杜尔伯特蒙古族自治县',
              NUM: '230624',
              children: []
            },
            {
              NAME: '红岗区',
              NUM: '230605',
              children: []
            },
            {
              NAME: '林甸县',
              NUM: '230623',
              children: []
            },
            {
              NAME: '龙凤区',
              NUM: '230603',
              children: []
            },
            {
              NAME: '让胡路区',
              NUM: '230604',
              children: []
            },
            {
              NAME: '萨尔图区',
              NUM: '230602',
              children: []
            },
            {
              NAME: '肇源县',
              NUM: '230622',
              children: []
            },
            {
              NAME: '肇州县',
              NUM: '230621',
              children: []
            }
          ]
        },
        {
          NAME: '大兴安岭地区',
          NUM: '2327',
          children: [
            {
              NAME: '呼玛县',
              NUM: '232721',
              children: []
            },
            {
              NAME: '呼中区',
              NUM: '232764',
              children: []
            },
            {
              NAME: '加格达奇区',
              NUM: '232761',
              children: []
            },
            {
              NAME: '漠河市',
              NUM: '232701',
              children: []
            },
            {
              NAME: '松岭区',
              NUM: '232762',
              children: []
            },
            {
              NAME: '塔河县',
              NUM: '232722',
              children: []
            },
            {
              NAME: '新林区',
              NUM: '232763',
              children: []
            }
          ]
        },
        {
          NAME: '哈尔滨',
          NUM: '2301',
          children: [
            {
              NAME: '阿城区',
              NUM: '230112',
              children: []
            },
            {
              NAME: '巴彦县',
              NUM: '230126',
              children: []
            },
            {
              NAME: '宾县',
              NUM: '230125',
              children: []
            },
            {
              NAME: '道里区',
              NUM: '230102',
              children: []
            },
            {
              NAME: '道外区',
              NUM: '230104',
              children: []
            },
            {
              NAME: '方正县',
              NUM: '230124',
              children: []
            },
            {
              NAME: '呼兰区',
              NUM: '230111',
              children: []
            },
            {
              NAME: '木兰县',
              NUM: '230127',
              children: []
            },
            {
              NAME: '南岗区',
              NUM: '230103',
              children: []
            },
            {
              NAME: '平房区',
              NUM: '230108',
              children: []
            },
            {
              NAME: '尚志市',
              NUM: '230183',
              children: []
            },
            {
              NAME: '双城区',
              NUM: '230113',
              children: []
            },
            {
              NAME: '松北区',
              NUM: '230109',
              children: []
            },
            {
              NAME: '通河县',
              NUM: '230128',
              children: []
            },
            {
              NAME: '五常市',
              NUM: '230184',
              children: []
            },
            {
              NAME: '香坊区',
              NUM: '230110',
              children: []
            },
            {
              NAME: '延寿县',
              NUM: '230129',
              children: []
            },
            {
              NAME: '依兰县',
              NUM: '230123',
              children: []
            }
          ]
        },
        {
          NAME: '鹤岗',
          NUM: '2304',
          children: [
            {
              NAME: '东山区',
              NUM: '230406',
              children: []
            },
            {
              NAME: '工农区',
              NUM: '230403',
              children: []
            },
            {
              NAME: '萝北县',
              NUM: '230421',
              children: []
            },
            {
              NAME: '南山区',
              NUM: '230404',
              children: []
            },
            {
              NAME: '绥滨县',
              NUM: '230422',
              children: []
            },
            {
              NAME: '向阳区',
              NUM: '230402',
              children: []
            },
            {
              NAME: '兴安区',
              NUM: '230405',
              children: []
            },
            {
              NAME: '兴山区',
              NUM: '230407',
              children: []
            }
          ]
        },
        {
          NAME: '黑河',
          NUM: '2311',
          children: [
            {
              NAME: '爱辉区',
              NUM: '231102',
              children: []
            },
            {
              NAME: '北安市',
              NUM: '231181',
              children: []
            },
            {
              NAME: '嫩江市',
              NUM: '231183',
              children: []
            },
            {
              NAME: '孙吴县',
              NUM: '231124',
              children: []
            },
            {
              NAME: '五大连池市',
              NUM: '231182',
              children: []
            },
            {
              NAME: '逊克县',
              NUM: '231123',
              children: []
            }
          ]
        },
        {
          NAME: '佳木斯',
          NUM: '2308',
          children: [
            {
              NAME: '东风区',
              NUM: '230805',
              children: []
            },
            {
              NAME: '富锦市',
              NUM: '230882',
              children: []
            },
            {
              NAME: '抚远市',
              NUM: '230883',
              children: []
            },
            {
              NAME: '桦川县',
              NUM: '230826',
              children: []
            },
            {
              NAME: '桦南县',
              NUM: '230822',
              children: []
            },
            {
              NAME: '郊区',
              NUM: '230811',
              children: []
            },
            {
              NAME: '前进区',
              NUM: '230804',
              children: []
            },
            {
              NAME: '汤原县',
              NUM: '230828',
              children: []
            },
            {
              NAME: '同江市',
              NUM: '230881',
              children: []
            },
            {
              NAME: '向阳区',
              NUM: '230803',
              children: []
            }
          ]
        },
        {
          NAME: '鸡西',
          NUM: '2303',
          children: [
            {
              NAME: '城子河区',
              NUM: '230306',
              children: []
            },
            {
              NAME: '滴道区',
              NUM: '230304',
              children: []
            },
            {
              NAME: '恒山区',
              NUM: '230303',
              children: []
            },
            {
              NAME: '虎林市',
              NUM: '230381',
              children: []
            },
            {
              NAME: '鸡东县',
              NUM: '230321',
              children: []
            },
            {
              NAME: '鸡冠区',
              NUM: '230302',
              children: []
            },
            {
              NAME: '梨树区',
              NUM: '230305',
              children: []
            },
            {
              NAME: '麻山区',
              NUM: '230307',
              children: []
            },
            {
              NAME: '密山市',
              NUM: '230382',
              children: []
            }
          ]
        },
        {
          NAME: '牡丹江',
          NUM: '2310',
          children: [
            {
              NAME: '爱民区',
              NUM: '231004',
              children: []
            },
            {
              NAME: '东安区',
              NUM: '231002',
              children: []
            },
            {
              NAME: '东宁市',
              NUM: '231086',
              children: []
            },
            {
              NAME: '海林市',
              NUM: '231083',
              children: []
            },
            {
              NAME: '林口县',
              NUM: '231025',
              children: []
            },
            {
              NAME: '穆棱市',
              NUM: '231085',
              children: []
            },
            {
              NAME: '宁安市',
              NUM: '231084',
              children: []
            },
            {
              NAME: '绥芬河市',
              NUM: '231081',
              children: []
            },
            {
              NAME: '西安区',
              NUM: '231005',
              children: []
            },
            {
              NAME: '阳明区',
              NUM: '231003',
              children: []
            }
          ]
        },
        {
          NAME: '齐齐哈尔',
          NUM: '2302',
          children: [
            {
              NAME: '昂昂溪区',
              NUM: '230205',
              children: []
            },
            {
              NAME: '拜泉县',
              NUM: '230231',
              children: []
            },
            {
              NAME: '富拉尔基区',
              NUM: '230206',
              children: []
            },
            {
              NAME: '富裕县',
              NUM: '230227',
              children: []
            },
            {
              NAME: '甘南县',
              NUM: '230225',
              children: []
            },
            {
              NAME: '建华区',
              NUM: '230203',
              children: []
            },
            {
              NAME: '克东县',
              NUM: '230230',
              children: []
            },
            {
              NAME: '克山县',
              NUM: '230229',
              children: []
            },
            {
              NAME: '龙江县',
              NUM: '230221',
              children: []
            },
            {
              NAME: '龙沙区',
              NUM: '230202',
              children: []
            },
            {
              NAME: '梅里斯达斡尔族区',
              NUM: '230208',
              children: []
            },
            {
              NAME: '讷河市',
              NUM: '230281',
              children: []
            },
            {
              NAME: '碾子山区',
              NUM: '230207',
              children: []
            },
            {
              NAME: '泰来县',
              NUM: '230224',
              children: []
            },
            {
              NAME: '铁锋区',
              NUM: '230204',
              children: []
            },
            {
              NAME: '依安县',
              NUM: '230223',
              children: []
            }
          ]
        },
        {
          NAME: '七台河',
          NUM: '2309',
          children: [
            {
              NAME: '勃利县',
              NUM: '230921',
              children: []
            },
            {
              NAME: '茄子河区',
              NUM: '230904',
              children: []
            },
            {
              NAME: '桃山区',
              NUM: '230903',
              children: []
            },
            {
              NAME: '新兴区',
              NUM: '230902',
              children: []
            }
          ]
        },
        {
          NAME: '双鸭山',
          NUM: '2305',
          children: [
            {
              NAME: '宝清县',
              NUM: '230523',
              children: []
            },
            {
              NAME: '宝山区',
              NUM: '230506',
              children: []
            },
            {
              NAME: '尖山区',
              NUM: '230502',
              children: []
            },
            {
              NAME: '集贤县',
              NUM: '230521',
              children: []
            },
            {
              NAME: '岭东区',
              NUM: '230503',
              children: []
            },
            {
              NAME: '饶河县',
              NUM: '230524',
              children: []
            },
            {
              NAME: '四方台区',
              NUM: '230505',
              children: []
            },
            {
              NAME: '友谊县',
              NUM: '230522',
              children: []
            }
          ]
        },
        {
          NAME: '绥化',
          NUM: '2312',
          children: [
            {
              NAME: '安达市',
              NUM: '231281',
              children: []
            },
            {
              NAME: '北林区',
              NUM: '231202',
              children: []
            },
            {
              NAME: '海伦市',
              NUM: '231283',
              children: []
            },
            {
              NAME: '兰西县',
              NUM: '231222',
              children: []
            },
            {
              NAME: '明水县',
              NUM: '231225',
              children: []
            },
            {
              NAME: '庆安县',
              NUM: '231224',
              children: []
            },
            {
              NAME: '青冈县',
              NUM: '231223',
              children: []
            },
            {
              NAME: '绥棱县',
              NUM: '231226',
              children: []
            },
            {
              NAME: '望奎县',
              NUM: '231221',
              children: []
            },
            {
              NAME: '肇东市',
              NUM: '231282',
              children: []
            }
          ]
        },
        {
          NAME: '伊春',
          NUM: '2307',
          children: [
            {
              NAME: '大箐山县',
              NUM: '230725',
              children: []
            },
            {
              NAME: '丰林县',
              NUM: '230724',
              children: []
            },
            {
              NAME: '嘉荫县',
              NUM: '230722',
              children: []
            },
            {
              NAME: '金林区',
              NUM: '230751',
              children: []
            },
            {
              NAME: '南岔县',
              NUM: '230726',
              children: []
            },
            {
              NAME: '汤旺县',
              NUM: '230723',
              children: []
            },
            {
              NAME: '铁力市',
              NUM: '230781',
              children: []
            },
            {
              NAME: '乌翠区',
              NUM: '230718',
              children: []
            },
            {
              NAME: '伊美区',
              NUM: '230717',
              children: []
            },
            {
              NAME: '友好区',
              NUM: '230719',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '河南',
      NUM: '41',
      CODE: '',
      children: [
        {
          NAME: '安阳',
          NUM: '4105',
          children: [
            {
              NAME: '安阳高新技术产业开发区',
              NUM: '410571',
              children: []
            },
            {
              NAME: '安阳县',
              NUM: '410522',
              children: []
            },
            {
              NAME: '北关区',
              NUM: '410503',
              children: []
            },
            {
              NAME: '滑县',
              NUM: '410526',
              children: []
            },
            {
              NAME: '林州市',
              NUM: '410581',
              children: []
            },
            {
              NAME: '龙安区',
              NUM: '410506',
              children: []
            },
            {
              NAME: '内黄县',
              NUM: '410527',
              children: []
            },
            {
              NAME: '汤阴县',
              NUM: '410523',
              children: []
            },
            {
              NAME: '文峰区',
              NUM: '410502',
              children: []
            },
            {
              NAME: '殷都区',
              NUM: '410505',
              children: []
            }
          ]
        },
        {
          NAME: '鹤壁',
          NUM: '4106',
          children: [
            {
              NAME: '鹤壁经济技术开发区',
              NUM: '410671',
              children: []
            },
            {
              NAME: '鹤山区',
              NUM: '410602',
              children: []
            },
            {
              NAME: '浚县',
              NUM: '410621',
              children: []
            },
            {
              NAME: '淇滨区',
              NUM: '410611',
              children: []
            },
            {
              NAME: '淇县',
              NUM: '410622',
              children: []
            },
            {
              NAME: '山城区',
              NUM: '410603',
              children: []
            }
          ]
        },
        {
          NAME: '焦作',
          NUM: '4108',
          children: [
            {
              NAME: '博爱县',
              NUM: '410822',
              children: []
            },
            {
              NAME: '焦作城乡一体化示范区',
              NUM: '410871',
              children: []
            },
            {
              NAME: '解放区',
              NUM: '410802',
              children: []
            },
            {
              NAME: '马村区',
              NUM: '410804',
              children: []
            },
            {
              NAME: '孟州市',
              NUM: '410883',
              children: []
            },
            {
              NAME: '沁阳市',
              NUM: '410882',
              children: []
            },
            {
              NAME: '山阳区',
              NUM: '410811',
              children: []
            },
            {
              NAME: '温县',
              NUM: '410825',
              children: []
            },
            {
              NAME: '武陟县',
              NUM: '410823',
              children: []
            },
            {
              NAME: '修武县',
              NUM: '410821',
              children: []
            },
            {
              NAME: '中站区',
              NUM: '410803',
              children: []
            }
          ]
        },
        {
          NAME: '济源',
          NUM: '419001',
          children: []
        },
        {
          NAME: '开封',
          NUM: '4102',
          children: [
            {
              NAME: '鼓楼区',
              NUM: '410204',
              children: []
            },
            {
              NAME: '兰考县',
              NUM: '410225',
              children: []
            },
            {
              NAME: '龙亭区',
              NUM: '410202',
              children: []
            },
            {
              NAME: '杞县',
              NUM: '410221',
              children: []
            },
            {
              NAME: '顺河回族区',
              NUM: '410203',
              children: []
            },
            {
              NAME: '通许县',
              NUM: '410222',
              children: []
            },
            {
              NAME: '尉氏县',
              NUM: '410223',
              children: []
            },
            {
              NAME: '祥符区',
              NUM: '410212',
              children: []
            },
            {
              NAME: '禹王台区',
              NUM: '410205',
              children: []
            }
          ]
        },
        {
          NAME: '洛阳',
          NUM: '4103',
          children: [
            {
              NAME: '瀍河回族区',
              NUM: '410304',
              children: []
            },
            {
              NAME: '涧西区',
              NUM: '410305',
              children: []
            },
            {
              NAME: '老城区',
              NUM: '410302',
              children: []
            },
            {
              NAME: '栾川县',
              NUM: '410324',
              children: []
            },
            {
              NAME: '洛龙区',
              NUM: '410311',
              children: []
            },
            {
              NAME: '洛宁县',
              NUM: '410328',
              children: []
            },
            {
              NAME: '孟津区',
              NUM: '410308',
              children: []
            },
            {
              NAME: '汝阳县',
              NUM: '410326',
              children: []
            },
            {
              NAME: '嵩县',
              NUM: '410325',
              children: []
            },
            {
              NAME: '西工区',
              NUM: '410303',
              children: []
            },
            {
              NAME: '新安县',
              NUM: '410323',
              children: []
            },
            {
              NAME: '偃师区',
              NUM: '410307',
              children: []
            },
            {
              NAME: '伊川县',
              NUM: '410329',
              children: []
            },
            {
              NAME: '宜阳县',
              NUM: '410327',
              children: []
            },
            {
              NAME: '洛阳高新技术产业开发区',
              NUM: '410371',
              children: []
            }
          ]
        },
        {
          NAME: '南阳',
          NUM: '4113',
          children: [
            {
              NAME: '邓州市',
              NUM: '411381',
              children: []
            },
            {
              NAME: '方城县',
              NUM: '411322',
              children: []
            },
            {
              NAME: '南阳高新技术产业开发区',
              NUM: '411371',
              children: []
            },
            {
              NAME: '南阳市城乡一体化示范区',
              NUM: '411372',
              children: []
            },
            {
              NAME: '南召县',
              NUM: '411321',
              children: []
            },
            {
              NAME: '内乡县',
              NUM: '411325',
              children: []
            },
            {
              NAME: '社旗县',
              NUM: '411327',
              children: []
            },
            {
              NAME: '唐河县',
              NUM: '411328',
              children: []
            },
            {
              NAME: '桐柏县',
              NUM: '411330',
              children: []
            },
            {
              NAME: '宛城区',
              NUM: '411302',
              children: []
            },
            {
              NAME: '卧龙区',
              NUM: '411303',
              children: []
            },
            {
              NAME: '淅川县',
              NUM: '411326',
              children: []
            },
            {
              NAME: '新野县',
              NUM: '411329',
              children: []
            },
            {
              NAME: '西峡县',
              NUM: '411323',
              children: []
            },
            {
              NAME: '镇平县',
              NUM: '411324',
              children: []
            }
          ]
        },
        {
          NAME: '平顶山',
          NUM: '4104',
          children: [
            {
              NAME: '宝丰县',
              NUM: '410421',
              children: []
            },
            {
              NAME: '郏县',
              NUM: '410425',
              children: []
            },
            {
              NAME: '鲁山县',
              NUM: '410423',
              children: []
            },
            {
              NAME: '平顶山高新技术产业开发区',
              NUM: '410471',
              children: []
            },
            {
              NAME: '平顶山市城乡一体化示范区',
              NUM: '410472',
              children: []
            },
            {
              NAME: '汝州市',
              NUM: '410482',
              children: []
            },
            {
              NAME: '石龙区',
              NUM: '410404',
              children: []
            },
            {
              NAME: '卫东区',
              NUM: '410403',
              children: []
            },
            {
              NAME: '舞钢市',
              NUM: '410481',
              children: []
            },
            {
              NAME: '新华区',
              NUM: '410402',
              children: []
            },
            {
              NAME: '叶县',
              NUM: '410422',
              children: []
            },
            {
              NAME: '湛河区',
              NUM: '410411',
              children: []
            }
          ]
        },
        {
          NAME: '濮阳',
          NUM: '4109',
          children: [
            {
              NAME: '范县',
              NUM: '410926',
              children: []
            },
            {
              NAME: '河南濮阳工业园区',
              NUM: '410971',
              children: []
            },
            {
              NAME: '华龙区',
              NUM: '410902',
              children: []
            },
            {
              NAME: '南乐县',
              NUM: '410923',
              children: []
            },
            {
              NAME: '濮阳经济技术开发区',
              NUM: '410972',
              children: []
            },
            {
              NAME: '濮阳县',
              NUM: '410928',
              children: []
            },
            {
              NAME: '清丰县',
              NUM: '410922',
              children: []
            },
            {
              NAME: '台前县',
              NUM: '410927',
              children: []
            }
          ]
        },
        {
          NAME: '三门峡',
          NUM: '4112',
          children: [
            {
              NAME: '河南三门峡经济开发区',
              NUM: '411271',
              children: []
            },
            {
              NAME: '湖滨区',
              NUM: '411202',
              children: []
            },
            {
              NAME: '灵宝市',
              NUM: '411282',
              children: []
            },
            {
              NAME: '卢氏县',
              NUM: '411224',
              children: []
            },
            {
              NAME: '渑池县',
              NUM: '411221',
              children: []
            },
            {
              NAME: '陕州区',
              NUM: '411203',
              children: []
            },
            {
              NAME: '义马市',
              NUM: '411281',
              children: []
            }
          ]
        },
        {
          NAME: '商丘',
          NUM: '4114',
          children: [
            {
              NAME: '河南商丘经济开发区',
              NUM: '411472',
              children: []
            },
            {
              NAME: '梁园区',
              NUM: '411402',
              children: []
            },
            {
              NAME: '民权县',
              NUM: '411421',
              children: []
            },
            {
              NAME: '宁陵县',
              NUM: '411423',
              children: []
            },
            {
              NAME: '睢县',
              NUM: '411422',
              children: []
            },
            {
              NAME: '睢阳区',
              NUM: '411403',
              children: []
            },
            {
              NAME: '夏邑县',
              NUM: '411426',
              children: []
            },
            {
              NAME: '永城市',
              NUM: '411481',
              children: []
            },
            {
              NAME: '虞城县',
              NUM: '411425',
              children: []
            },
            {
              NAME: '豫东综合物流产业聚集区',
              NUM: '411471',
              children: []
            },
            {
              NAME: '柘城县',
              NUM: '411424',
              children: []
            }
          ]
        },
        {
          NAME: '漯河',
          NUM: '4111',
          children: [
            {
              NAME: '临颍县',
              NUM: '411122',
              children: []
            },
            {
              NAME: '漯河经济技术开发区',
              NUM: '411171',
              children: []
            },
            {
              NAME: '舞阳县',
              NUM: '411121',
              children: []
            },
            {
              NAME: '郾城区',
              NUM: '411103',
              children: []
            },
            {
              NAME: '源汇区',
              NUM: '411102',
              children: []
            },
            {
              NAME: '召陵区',
              NUM: '411104',
              children: []
            }
          ]
        },
        {
          NAME: '新乡',
          NUM: '4107',
          children: [
            {
              NAME: '封丘县',
              NUM: '410727',
              children: []
            },
            {
              NAME: '凤泉区',
              NUM: '410704',
              children: []
            },
            {
              NAME: '红旗区',
              NUM: '410702',
              children: []
            },
            {
              NAME: '辉县市',
              NUM: '410782',
              children: []
            },
            {
              NAME: '获嘉县',
              NUM: '410724',
              children: []
            },
            {
              NAME: '牧野区',
              NUM: '410711',
              children: []
            },
            {
              NAME: '卫滨区',
              NUM: '410703',
              children: []
            },
            {
              NAME: '卫辉市',
              NUM: '410781',
              children: []
            },
            {
              NAME: '新乡高新技术产业开发区',
              NUM: '410771',
              children: []
            },
            {
              NAME: '新乡经济技术开发区',
              NUM: '410772',
              children: []
            },
            {
              NAME: '新乡市平原城乡一体化示范区',
              NUM: '410773',
              children: []
            },
            {
              NAME: '新乡县',
              NUM: '410721',
              children: []
            },
            {
              NAME: '延津县',
              NUM: '410726',
              children: []
            },
            {
              NAME: '原阳县',
              NUM: '410725',
              children: []
            },
            {
              NAME: '长垣市',
              NUM: '410783',
              children: []
            }
          ]
        },
        {
          NAME: '信阳',
          NUM: '4115',
          children: [
            {
              NAME: '光山县',
              NUM: '411522',
              children: []
            },
            {
              NAME: '固始县',
              NUM: '411525',
              children: []
            },
            {
              NAME: '淮滨县',
              NUM: '411527',
              children: []
            },
            {
              NAME: '潢川县',
              NUM: '411526',
              children: []
            },
            {
              NAME: '罗山县',
              NUM: '411521',
              children: []
            },
            {
              NAME: '平桥区',
              NUM: '411503',
              children: []
            },
            {
              NAME: '商城县',
              NUM: '411524',
              children: []
            },
            {
              NAME: '浉河区',
              NUM: '411502',
              children: []
            },
            {
              NAME: '新县',
              NUM: '411523',
              children: []
            },
            {
              NAME: '信阳高新技术产业开发区',
              NUM: '411571',
              children: []
            },
            {
              NAME: '息县',
              NUM: '411528',
              children: []
            }
          ]
        },
        {
          NAME: '许昌',
          NUM: '4110',
          children: [
            {
              NAME: '建安区',
              NUM: '411003',
              children: []
            },
            {
              NAME: '魏都区',
              NUM: '411002',
              children: []
            },
            {
              NAME: '襄城县',
              NUM: '411025',
              children: []
            },
            {
              NAME: '许昌经济技术开发区',
              NUM: '411071',
              children: []
            },
            {
              NAME: '鄢陵县',
              NUM: '411024',
              children: []
            },
            {
              NAME: '禹州市',
              NUM: '411081',
              children: []
            },
            {
              NAME: '长葛市',
              NUM: '411082',
              children: []
            }
          ]
        },
        {
          NAME: '郑州',
          NUM: '4101',
          children: [
            {
              NAME: '登封市',
              NUM: '410185',
              children: []
            },
            {
              NAME: '二七区',
              NUM: '410103',
              children: []
            },
            {
              NAME: '巩义市',
              NUM: '410181',
              children: []
            },
            {
              NAME: '管城回族区',
              NUM: '410104',
              children: []
            },
            {
              NAME: '惠济区',
              NUM: '410108',
              children: []
            },
            {
              NAME: '金水区',
              NUM: '410105',
              children: []
            },
            {
              NAME: '上街区',
              NUM: '410106',
              children: []
            },
            {
              NAME: '荥阳市',
              NUM: '410182',
              children: []
            },
            {
              NAME: '新密市',
              NUM: '410183',
              children: []
            },
            {
              NAME: '新郑市',
              NUM: '410184',
              children: []
            },
            {
              NAME: '郑州高新技术产业开发区',
              NUM: '410172',
              children: []
            },
            {
              NAME: '郑州航空港经济综合实验区',
              NUM: '410173',
              children: []
            },
            {
              NAME: '郑州经济技术开发区',
              NUM: '410171',
              children: []
            },
            {
              NAME: '中牟县',
              NUM: '410122',
              children: []
            },
            {
              NAME: '中原区',
              NUM: '410102',
              children: []
            }
          ]
        },
        {
          NAME: '周口',
          NUM: '4116',
          children: [
            {
              NAME: '川汇区',
              NUM: '411602',
              children: []
            },
            {
              NAME: '郸城县',
              NUM: '411625',
              children: []
            },
            {
              NAME: '扶沟县',
              NUM: '411621',
              children: []
            },
            {
              NAME: '淮阳区',
              NUM: '411603',
              children: []
            },
            {
              NAME: '鹿邑县',
              NUM: '411628',
              children: []
            },
            {
              NAME: '商水县',
              NUM: '411623',
              children: []
            },
            {
              NAME: '沈丘县',
              NUM: '411624',
              children: []
            },
            {
              NAME: '太康县',
              NUM: '411627',
              children: []
            },
            {
              NAME: '项城市',
              NUM: '411681',
              children: []
            },
            {
              NAME: '西华县',
              NUM: '411622',
              children: []
            },
            {
              NAME: '周口临港开发区',
              NUM: '411671',
              children: []
            }
          ]
        },
        {
          NAME: '驻马店',
          NUM: '4117',
          children: [
            {
              NAME: '泌阳县',
              NUM: '411726',
              children: []
            },
            {
              NAME: '河南驻马店经济开发区',
              NUM: '411771',
              children: []
            },
            {
              NAME: '平舆县',
              NUM: '411723',
              children: []
            },
            {
              NAME: '确山县',
              NUM: '411725',
              children: []
            },
            {
              NAME: '汝南县',
              NUM: '411727',
              children: []
            },
            {
              NAME: '上蔡县',
              NUM: '411722',
              children: []
            },
            {
              NAME: '遂平县',
              NUM: '411728',
              children: []
            },
            {
              NAME: '新蔡县',
              NUM: '411729',
              children: []
            },
            {
              NAME: '西平县',
              NUM: '411721',
              children: []
            },
            {
              NAME: '驿城区',
              NUM: '411702',
              children: []
            },
            {
              NAME: '正阳县',
              NUM: '411724',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '湖北',
      NUM: '42',
      CODE: '',
      children: [
        {
          NAME: '恩施土家族苗族自治州',
          NUM: '4228',
          children: [
            {
              NAME: '巴东县',
              NUM: '422823',
              children: []
            },
            {
              NAME: '恩施市',
              NUM: '422801',
              children: []
            },
            {
              NAME: '鹤峰县',
              NUM: '422828',
              children: []
            },
            {
              NAME: '建始县',
              NUM: '422822',
              children: []
            },
            {
              NAME: '来凤县',
              NUM: '422827',
              children: []
            },
            {
              NAME: '利川市',
              NUM: '422802',
              children: []
            },
            {
              NAME: '咸丰县',
              NUM: '422826',
              children: []
            },
            {
              NAME: '宣恩县',
              NUM: '422825',
              children: []
            }
          ]
        },
        {
          NAME: '鄂州',
          NUM: '4207',
          children: [
            {
              NAME: '鄂城区',
              NUM: '420704',
              children: []
            },
            {
              NAME: '华容区',
              NUM: '420703',
              children: []
            },
            {
              NAME: '梁子湖区',
              NUM: '420702',
              children: []
            }
          ]
        },
        {
          NAME: '黄冈',
          NUM: '4211',
          children: [
            {
              NAME: '红安县',
              NUM: '421122',
              children: []
            },
            {
              NAME: '黄梅县',
              NUM: '421127',
              children: []
            },
            {
              NAME: '黄州区',
              NUM: '421102',
              children: []
            },
            {
              NAME: '龙感湖管理区',
              NUM: '421171',
              children: []
            },
            {
              NAME: '罗田县',
              NUM: '421123',
              children: []
            },
            {
              NAME: '麻城市',
              NUM: '421181',
              children: []
            },
            {
              NAME: '蕲春县',
              NUM: '421126',
              children: []
            },
            {
              NAME: '团风县',
              NUM: '421121',
              children: []
            },
            {
              NAME: '武穴市',
              NUM: '421182',
              children: []
            },
            {
              NAME: '浠水县',
              NUM: '421125',
              children: []
            },
            {
              NAME: '英山县',
              NUM: '421124',
              children: []
            }
          ]
        },
        {
          NAME: '黄石',
          NUM: '4202',
          children: [
            {
              NAME: '大冶市',
              NUM: '420281',
              children: []
            },
            {
              NAME: '黄石港区',
              NUM: '420202',
              children: []
            },
            {
              NAME: '铁山区',
              NUM: '420205',
              children: []
            },
            {
              NAME: '下陆区',
              NUM: '420204',
              children: []
            },
            {
              NAME: '西塞山区',
              NUM: '420203',
              children: []
            },
            {
              NAME: '阳新县',
              NUM: '420222',
              children: []
            }
          ]
        },
        {
          NAME: '荆门',
          NUM: '4208',
          children: [
            {
              NAME: '东宝区',
              NUM: '420802',
              children: []
            },
            {
              NAME: '掇刀区',
              NUM: '420804',
              children: []
            },
            {
              NAME: '京山市',
              NUM: '420882',
              children: []
            },
            {
              NAME: '沙洋县',
              NUM: '420822',
              children: []
            },
            {
              NAME: '钟祥市',
              NUM: '420881',
              children: []
            }
          ]
        },
        {
          NAME: '荆州',
          NUM: '4210',
          children: [
            {
              NAME: '公安县',
              NUM: '421022',
              children: []
            },
            {
              NAME: '洪湖市',
              NUM: '421083',
              children: []
            },
            {
              NAME: '江陵县',
              NUM: '421024',
              children: []
            },
            {
              NAME: '监利市',
              NUM: '421088',
              children: []
            },
            {
              NAME: '荆州经济技术开发区',
              NUM: '421071',
              children: []
            },
            {
              NAME: '荆州区',
              NUM: '421003',
              children: []
            },
            {
              NAME: '沙市区',
              NUM: '421002',
              children: []
            },
            {
              NAME: '石首市',
              NUM: '421081',
              children: []
            },
            {
              NAME: '松滋市',
              NUM: '421087',
              children: []
            }
          ]
        },
        {
          NAME: '潜江',
          NUM: '429005',
          children: []
        },
        {
          NAME: '神农架林区',
          NUM: '429021',
          children: []
        },
        {
          NAME: '十堰',
          NUM: '4203',
          children: [
            {
              NAME: '丹江口市',
              NUM: '420381',
              children: []
            },
            {
              NAME: '房县',
              NUM: '420325',
              children: []
            },
            {
              NAME: '茅箭区',
              NUM: '420302',
              children: []
            },
            {
              NAME: '郧西县',
              NUM: '420322',
              children: []
            },
            {
              NAME: '郧阳区',
              NUM: '420304',
              children: []
            },
            {
              NAME: '张湾区',
              NUM: '420303',
              children: []
            },
            {
              NAME: '竹山县',
              NUM: '420323',
              children: []
            },
            {
              NAME: '竹溪县',
              NUM: '420324',
              children: []
            }
          ]
        },
        {
          NAME: '随州',
          NUM: '4213',
          children: [
            {
              NAME: '曾都区',
              NUM: '421303',
              children: []
            },
            {
              NAME: '广水市',
              NUM: '421381',
              children: []
            },
            {
              NAME: '随县',
              NUM: '421321',
              children: []
            }
          ]
        },
        {
          NAME: '天门',
          NUM: '429006',
          children: []
        },
        {
          NAME: '武汉',
          NUM: '4201',
          children: [
            {
              NAME: '蔡甸区',
              NUM: '420114',
              children: []
            },
            {
              NAME: '东西湖区',
              NUM: '420112',
              children: []
            },
            {
              NAME: '汉南区',
              NUM: '420113',
              children: []
            },
            {
              NAME: '汉阳区',
              NUM: '420105',
              children: []
            },
            {
              NAME: '洪山区',
              NUM: '420111',
              children: []
            },
            {
              NAME: '黄陂区',
              NUM: '420116',
              children: []
            },
            {
              NAME: '江岸区',
              NUM: '420102',
              children: []
            },
            {
              NAME: '江汉区',
              NUM: '420103',
              children: []
            },
            {
              NAME: '江夏区',
              NUM: '420115',
              children: []
            },
            {
              NAME: '硚口区',
              NUM: '420104',
              children: []
            },
            {
              NAME: '青山区',
              NUM: '420107',
              children: []
            },
            {
              NAME: '武昌区',
              NUM: '420106',
              children: []
            },
            {
              NAME: '新洲区',
              NUM: '420117',
              children: []
            }
          ]
        },
        {
          NAME: '襄阳',
          NUM: '4206',
          children: [
            {
              NAME: '保康县',
              NUM: '420626',
              children: []
            },
            {
              NAME: '樊城区',
              NUM: '420606',
              children: []
            },
            {
              NAME: '谷城县',
              NUM: '420625',
              children: []
            },
            {
              NAME: '老河口市',
              NUM: '420682',
              children: []
            },
            {
              NAME: '南漳县',
              NUM: '420624',
              children: []
            },
            {
              NAME: '襄城区',
              NUM: '420602',
              children: []
            },
            {
              NAME: '襄州区',
              NUM: '420607',
              children: []
            },
            {
              NAME: '宜城市',
              NUM: '420684',
              children: []
            },
            {
              NAME: '枣阳市',
              NUM: '420683',
              children: []
            }
          ]
        },
        {
          NAME: '咸宁',
          NUM: '4212',
          children: [
            {
              NAME: '赤壁市',
              NUM: '421281',
              children: []
            },
            {
              NAME: '崇阳县',
              NUM: '421223',
              children: []
            },
            {
              NAME: '嘉鱼县',
              NUM: '421221',
              children: []
            },
            {
              NAME: '通城县',
              NUM: '421222',
              children: []
            },
            {
              NAME: '通山县',
              NUM: '421224',
              children: []
            },
            {
              NAME: '咸安区',
              NUM: '421202',
              children: []
            }
          ]
        },
        {
          NAME: '仙桃',
          NUM: '429004',
          children: []
        },
        {
          NAME: '孝感',
          NUM: '4209',
          children: [
            {
              NAME: '安陆市',
              NUM: '420982',
              children: []
            },
            {
              NAME: '大悟县',
              NUM: '420922',
              children: []
            },
            {
              NAME: '汉川市',
              NUM: '420984',
              children: []
            },
            {
              NAME: '孝昌县',
              NUM: '420921',
              children: []
            },
            {
              NAME: '孝南区',
              NUM: '420902',
              children: []
            },
            {
              NAME: '应城市',
              NUM: '420981',
              children: []
            },
            {
              NAME: '云梦县',
              NUM: '420923',
              children: []
            }
          ]
        },
        {
          NAME: '宜昌',
          NUM: '4205',
          children: [
            {
              NAME: '当阳市',
              NUM: '420582',
              children: []
            },
            {
              NAME: '点军区',
              NUM: '420504',
              children: []
            },
            {
              NAME: '五峰土家族自治县',
              NUM: '420529',
              children: []
            },
            {
              NAME: '伍家岗区',
              NUM: '420503',
              children: []
            },
            {
              NAME: '猇亭区',
              NUM: '420505',
              children: []
            },
            {
              NAME: '西陵区',
              NUM: '420502',
              children: []
            },
            {
              NAME: '兴山县',
              NUM: '420526',
              children: []
            },
            {
              NAME: '宜都市',
              NUM: '420581',
              children: []
            },
            {
              NAME: '夷陵区',
              NUM: '420506',
              children: []
            },
            {
              NAME: '远安县',
              NUM: '420525',
              children: []
            },
            {
              NAME: '长阳土家族自治县',
              NUM: '420528',
              children: []
            },
            {
              NAME: '枝江市',
              NUM: '420583',
              children: []
            },
            {
              NAME: '秭归县',
              NUM: '420527',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '湖南',
      NUM: '43',
      CODE: '',
      children: [
        {
          NAME: '常德',
          NUM: '4307',
          children: [
            {
              NAME: '安乡县',
              NUM: '430721',
              children: []
            },
            {
              NAME: '常德市西洞庭管理区',
              NUM: '430771',
              children: []
            },
            {
              NAME: '鼎城区',
              NUM: '430703',
              children: []
            },
            {
              NAME: '汉寿县',
              NUM: '430722',
              children: []
            },
            {
              NAME: '津市市',
              NUM: '430781',
              children: []
            },
            {
              NAME: '临澧县',
              NUM: '430724',
              children: []
            },
            {
              NAME: '澧县',
              NUM: '430723',
              children: []
            },
            {
              NAME: '石门县',
              NUM: '430726',
              children: []
            },
            {
              NAME: '桃源县',
              NUM: '430725',
              children: []
            },
            {
              NAME: '武陵区',
              NUM: '430702',
              children: []
            }
          ]
        },
        {
          NAME: '长沙',
          NUM: '4301',
          children: [
            {
              NAME: '长沙县',
              NUM: '430121',
              children: []
            },
            {
              NAME: '芙蓉区',
              NUM: '430102',
              children: []
            },
            {
              NAME: '开福区',
              NUM: '430105',
              children: []
            },
            {
              NAME: '浏阳市',
              NUM: '430181',
              children: []
            },
            {
              NAME: '宁乡市',
              NUM: '430182',
              children: []
            },
            {
              NAME: '天心区',
              NUM: '430103',
              children: []
            },
            {
              NAME: '望城区',
              NUM: '430112',
              children: []
            },
            {
              NAME: '岳麓区',
              NUM: '430104',
              children: []
            },
            {
              NAME: '雨花区',
              NUM: '430111',
              children: []
            }
          ]
        },
        {
          NAME: '郴州',
          NUM: '4310',
          children: [
            {
              NAME: '安仁县',
              NUM: '431028',
              children: []
            },
            {
              NAME: '北湖区',
              NUM: '431002',
              children: []
            },
            {
              NAME: '桂东县',
              NUM: '431027',
              children: []
            },
            {
              NAME: '桂阳县',
              NUM: '431021',
              children: []
            },
            {
              NAME: '嘉禾县',
              NUM: '431024',
              children: []
            },
            {
              NAME: '临武县',
              NUM: '431025',
              children: []
            },
            {
              NAME: '汝城县',
              NUM: '431026',
              children: []
            },
            {
              NAME: '苏仙区',
              NUM: '431003',
              children: []
            },
            {
              NAME: '宜章县',
              NUM: '431022',
              children: []
            },
            {
              NAME: '永兴县',
              NUM: '431023',
              children: []
            },
            {
              NAME: '资兴市',
              NUM: '431081',
              children: []
            }
          ]
        },
        {
          NAME: '衡阳',
          NUM: '4304',
          children: [
            {
              NAME: '常宁市',
              NUM: '430482',
              children: []
            },
            {
              NAME: '衡东县',
              NUM: '430424',
              children: []
            },
            {
              NAME: '衡南县',
              NUM: '430422',
              children: []
            },
            {
              NAME: '衡山县',
              NUM: '430423',
              children: []
            },
            {
              NAME: '衡阳县',
              NUM: '430421',
              children: []
            },
            {
              NAME: '湖南衡阳高新技术产业园区',
              NUM: '430476',
              children: []
            },
            {
              NAME: '湖南衡阳松木经济开发区',
              NUM: '430473',
              children: []
            },
            {
              NAME: '耒阳市',
              NUM: '430481',
              children: []
            },
            {
              NAME: '南岳区',
              NUM: '430412',
              children: []
            },
            {
              NAME: '祁东县',
              NUM: '430426',
              children: []
            },
            {
              NAME: '石鼓区',
              NUM: '430407',
              children: []
            },
            {
              NAME: '雁峰区',
              NUM: '430406',
              children: []
            },
            {
              NAME: '蒸湘区',
              NUM: '430408',
              children: []
            },
            {
              NAME: '珠晖区',
              NUM: '430405',
              children: []
            }
          ]
        },
        {
          NAME: '怀化',
          NUM: '4312',
          children: [
            {
              NAME: '辰溪县',
              NUM: '431223',
              children: []
            },
            {
              NAME: '鹤城区',
              NUM: '431202',
              children: []
            },
            {
              NAME: '洪江市',
              NUM: '431281',
              children: []
            },
            {
              NAME: '怀化市洪江管理区',
              NUM: '431271',
              children: []
            },
            {
              NAME: '会同县',
              NUM: '431225',
              children: []
            },
            {
              NAME: '靖州苗族侗族自治县',
              NUM: '431229',
              children: []
            },
            {
              NAME: '麻阳苗族自治县',
              NUM: '431226',
              children: []
            },
            {
              NAME: '通道侗族自治县',
              NUM: '431230',
              children: []
            },
            {
              NAME: '新晃侗族自治县',
              NUM: '431227',
              children: []
            },
            {
              NAME: '溆浦县',
              NUM: '431224',
              children: []
            },
            {
              NAME: '沅陵县',
              NUM: '431222',
              children: []
            },
            {
              NAME: '芷江侗族自治县',
              NUM: '431228',
              children: []
            },
            {
              NAME: '中方县',
              NUM: '431221',
              children: []
            }
          ]
        },
        {
          NAME: '娄底',
          NUM: '4313',
          children: [
            {
              NAME: '冷水江市',
              NUM: '431381',
              children: []
            },
            {
              NAME: '涟源市',
              NUM: '431382',
              children: []
            },
            {
              NAME: '娄星区',
              NUM: '431302',
              children: []
            },
            {
              NAME: '双峰县',
              NUM: '431321',
              children: []
            },
            {
              NAME: '新化县',
              NUM: '431322',
              children: []
            }
          ]
        },
        {
          NAME: '邵阳',
          NUM: '4305',
          children: [
            {
              NAME: '北塔区',
              NUM: '430511',
              children: []
            },
            {
              NAME: '城步苗族自治县',
              NUM: '430529',
              children: []
            },
            {
              NAME: '大祥区',
              NUM: '430503',
              children: []
            },
            {
              NAME: '洞口县',
              NUM: '430525',
              children: []
            },
            {
              NAME: '隆回县',
              NUM: '430524',
              children: []
            },
            {
              NAME: '邵东市',
              NUM: '430582',
              children: []
            },
            {
              NAME: '邵阳县',
              NUM: '430523',
              children: []
            },
            {
              NAME: '双清区',
              NUM: '430502',
              children: []
            },
            {
              NAME: '绥宁县',
              NUM: '430527',
              children: []
            },
            {
              NAME: '武冈市',
              NUM: '430581',
              children: []
            },
            {
              NAME: '新宁县',
              NUM: '430528',
              children: []
            },
            {
              NAME: '新邵县',
              NUM: '430522',
              children: []
            }
          ]
        },
        {
          NAME: '湘潭',
          NUM: '4303',
          children: [
            {
              NAME: '湖南湘潭高新技术产业园区',
              NUM: '430371',
              children: []
            },
            {
              NAME: '韶山市',
              NUM: '430382',
              children: []
            },
            {
              NAME: '湘潭九华示范区',
              NUM: '430373',
              children: []
            },
            {
              NAME: '湘潭县',
              NUM: '430321',
              children: []
            },
            {
              NAME: '湘潭昭山示范区',
              NUM: '430372',
              children: []
            },
            {
              NAME: '湘乡市',
              NUM: '430381',
              children: []
            },
            {
              NAME: '岳塘区',
              NUM: '430304',
              children: []
            },
            {
              NAME: '雨湖区',
              NUM: '430302',
              children: []
            }
          ]
        },
        {
          NAME: '湘西土家族苗族自治州',
          NUM: '4331',
          children: [
            {
              NAME: '保靖县',
              NUM: '433125',
              children: []
            },
            {
              NAME: '凤凰县',
              NUM: '433123',
              children: []
            },
            {
              NAME: '古丈县',
              NUM: '433126',
              children: []
            },
            {
              NAME: '花垣县',
              NUM: '433124',
              children: []
            },
            {
              NAME: '吉首市',
              NUM: '433101',
              children: []
            },
            {
              NAME: '龙山县',
              NUM: '433130',
              children: []
            },
            {
              NAME: '泸溪县',
              NUM: '433122',
              children: []
            },
            {
              NAME: '永顺县',
              NUM: '433127',
              children: []
            }
          ]
        },
        {
          NAME: '益阳',
          NUM: '4309',
          children: [
            {
              NAME: '安化县',
              NUM: '430923',
              children: []
            },
            {
              NAME: '赫山区',
              NUM: '430903',
              children: []
            },
            {
              NAME: '湖南益阳高新技术产业园区',
              NUM: '430972',
              children: []
            },
            {
              NAME: '南县',
              NUM: '430921',
              children: []
            },
            {
              NAME: '桃江县',
              NUM: '430922',
              children: []
            },
            {
              NAME: '益阳市大通湖管理区',
              NUM: '430971',
              children: []
            },
            {
              NAME: '沅江市',
              NUM: '430981',
              children: []
            },
            {
              NAME: '资阳区',
              NUM: '430902',
              children: []
            }
          ]
        },
        {
          NAME: '永州',
          NUM: '4311',
          children: [
            {
              NAME: '道县',
              NUM: '431124',
              children: []
            },
            {
              NAME: '东安县',
              NUM: '431122',
              children: []
            },
            {
              NAME: '江华瑶族自治县',
              NUM: '431129',
              children: []
            },
            {
              NAME: '江永县',
              NUM: '431125',
              children: []
            },
            {
              NAME: '蓝山县',
              NUM: '431127',
              children: []
            },
            {
              NAME: '冷水滩区',
              NUM: '431103',
              children: []
            },
            {
              NAME: '零陵区',
              NUM: '431102',
              children: []
            },
            {
              NAME: '宁远县',
              NUM: '431126',
              children: []
            },
            {
              NAME: '祁阳市',
              NUM: '431181',
              children: []
            },
            {
              NAME: '双牌县',
              NUM: '431123',
              children: []
            },
            {
              NAME: '新田县',
              NUM: '431128',
              children: []
            },
            {
              NAME: '永州经济技术开发区',
              NUM: '431171',
              children: []
            },
            {
              NAME: '永州市回龙圩管理区',
              NUM: '431173',
              children: []
            }
          ]
        },
        {
          NAME: '岳阳',
          NUM: '4306',
          children: [
            {
              NAME: '华容县',
              NUM: '430623',
              children: []
            },
            {
              NAME: '君山区',
              NUM: '430611',
              children: []
            },
            {
              NAME: '临湘市',
              NUM: '430682',
              children: []
            },
            {
              NAME: '汨罗市',
              NUM: '430681',
              children: []
            },
            {
              NAME: '平江县',
              NUM: '430626',
              children: []
            },
            {
              NAME: '湘阴县',
              NUM: '430624',
              children: []
            },
            {
              NAME: '岳阳楼区',
              NUM: '430602',
              children: []
            },
            {
              NAME: '岳阳市屈原管理区',
              NUM: '430671',
              children: []
            },
            {
              NAME: '岳阳县',
              NUM: '430621',
              children: []
            },
            {
              NAME: '云溪区',
              NUM: '430603',
              children: []
            }
          ]
        },
        {
          NAME: '张家界',
          NUM: '4308',
          children: [
            {
              NAME: '慈利县',
              NUM: '430821',
              children: []
            },
            {
              NAME: '桑植县',
              NUM: '430822',
              children: []
            },
            {
              NAME: '武陵源区',
              NUM: '430811',
              children: []
            },
            {
              NAME: '永定区',
              NUM: '430802',
              children: []
            }
          ]
        },
        {
          NAME: '株洲',
          NUM: '4302',
          children: [
            {
              NAME: '茶陵县',
              NUM: '430224',
              children: []
            },
            {
              NAME: '荷塘区',
              NUM: '430202',
              children: []
            },
            {
              NAME: '醴陵市',
              NUM: '430281',
              children: []
            },
            {
              NAME: '渌口区',
              NUM: '430212',
              children: []
            },
            {
              NAME: '芦淞区',
              NUM: '430203',
              children: []
            },
            {
              NAME: '石峰区',
              NUM: '430204',
              children: []
            },
            {
              NAME: '天元区',
              NUM: '430211',
              children: []
            },
            {
              NAME: '炎陵县',
              NUM: '430225',
              children: []
            },
            {
              NAME: '攸县',
              NUM: '430223',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '江苏',
      NUM: '32',
      CODE: 'J',
      children: [
        {
          NAME: '常州',
          NUM: '3204',
          children: [
            {
              NAME: '金坛区',
              NUM: '320413',
              children: []
            },
            {
              NAME: '溧阳市',
              NUM: '320481',
              children: []
            },
            {
              NAME: '天宁区',
              NUM: '320402',
              children: []
            },
            {
              NAME: '武进区',
              NUM: '320412',
              children: []
            },
            {
              NAME: '新北区',
              NUM: '320411',
              children: []
            },
            {
              NAME: '钟楼区',
              NUM: '320404',
              children: []
            }
          ]
        },
        {
          NAME: '淮安',
          NUM: '3208',
          children: [
            {
              NAME: '洪泽区',
              NUM: '320813',
              children: []
            },
            {
              NAME: '淮安经济技术开发区',
              NUM: '320871',
              children: []
            },
            {
              NAME: '淮安区',
              NUM: '320803',
              children: []
            },
            {
              NAME: '淮阴区',
              NUM: '320804',
              children: []
            },
            {
              NAME: '金湖县',
              NUM: '320831',
              children: []
            },
            {
              NAME: '涟水县',
              NUM: '320826',
              children: []
            },
            {
              NAME: '清江浦区',
              NUM: '320812',
              children: []
            },
            {
              NAME: '盱眙县',
              NUM: '320830',
              children: []
            }
          ]
        },
        {
          NAME: '连云港',
          NUM: '3207',
          children: [
            {
              NAME: '东海县',
              NUM: '320722',
              children: []
            },
            {
              NAME: '赣榆区',
              NUM: '320707',
              children: []
            },
            {
              NAME: '灌南县',
              NUM: '320724',
              children: []
            },
            {
              NAME: '灌云县',
              NUM: '320723',
              children: []
            },
            {
              NAME: '海州区',
              NUM: '320706',
              children: []
            },
            {
              NAME: '连云港经济技术开发区',
              NUM: '320771',
              children: []
            },
            {
              NAME: '连云区',
              NUM: '320703',
              children: []
            }
          ]
        },
        {
          NAME: '南京',
          NUM: '3201',
          children: [
            {
              NAME: '高淳区',
              NUM: '320118',
              children: []
            },
            {
              NAME: '鼓楼区',
              NUM: '320106',
              children: []
            },
            {
              NAME: '江宁区',
              NUM: '320115',
              children: []
            },
            {
              NAME: '建邺区',
              NUM: '320105',
              children: []
            },
            {
              NAME: '溧水区',
              NUM: '320117',
              children: []
            },
            {
              NAME: '六合区',
              NUM: '320116',
              children: []
            },
            {
              NAME: '浦口区',
              NUM: '320111',
              children: []
            },
            {
              NAME: '秦淮区',
              NUM: '320104',
              children: []
            },
            {
              NAME: '栖霞区',
              NUM: '320113',
              children: []
            },
            {
              NAME: '玄武区',
              NUM: '320102',
              children: []
            },
            {
              NAME: '雨花台区',
              NUM: '320114',
              children: []
            }
          ]
        },
        {
          NAME: '南通',
          NUM: '3206',
          children: [
            {
              NAME: '崇川区',
              NUM: '320613',
              children: []
            },
            {
              NAME: '海安市',
              NUM: '320685',
              children: []
            },
            {
              NAME: '海门区',
              NUM: '320614',
              children: []
            },
            {
              NAME: '南通经济技术开发区',
              NUM: '320671',
              children: []
            },
            {
              NAME: '启东市',
              NUM: '320681',
              children: []
            },
            {
              NAME: '如东县',
              NUM: '320623',
              children: []
            },
            {
              NAME: '如皋市',
              NUM: '320682',
              children: []
            },
            {
              NAME: '通州区',
              NUM: '320612',
              children: []
            }
          ]
        },
        {
          NAME: '宿迁',
          NUM: '3213',
          children: [
            {
              NAME: '沭阳县',
              NUM: '321322',
              children: []
            },
            {
              NAME: '泗洪县',
              NUM: '321324',
              children: []
            },
            {
              NAME: '泗阳县',
              NUM: '321323',
              children: []
            },
            {
              NAME: '宿城区',
              NUM: '321302',
              children: []
            },
            {
              NAME: '宿迁经济技术开发区',
              NUM: '321371',
              children: []
            },
            {
              NAME: '宿豫区',
              NUM: '321311',
              children: []
            }
          ]
        },
        {
          NAME: '苏州',
          NUM: '3205',
          children: [
            {
              NAME: '常熟市',
              NUM: '320581',
              children: []
            },
            {
              NAME: '姑苏区',
              NUM: '320508',
              children: []
            },
            {
              NAME: '虎丘区',
              NUM: '320505',
              children: []
            },
            {
              NAME: '昆山市',
              NUM: '320583',
              children: []
            },
            {
              NAME: '苏州工业园区',
              NUM: '320576',
              children: []
            },
            {
              NAME: '太仓市',
              NUM: '320585',
              children: []
            },
            {
              NAME: '吴江区',
              NUM: '320509',
              children: []
            },
            {
              NAME: '吴中区',
              NUM: '320506',
              children: []
            },
            {
              NAME: '相城区',
              NUM: '320507',
              children: []
            },
            {
              NAME: '张家港市',
              NUM: '320582',
              children: []
            }
          ]
        },
        {
          NAME: '泰州',
          NUM: '3212',
          children: [
            {
              NAME: '高港区',
              NUM: '321203',
              children: []
            },
            {
              NAME: '海陵区',
              NUM: '321202',
              children: []
            },
            {
              NAME: '姜堰区',
              NUM: '321204',
              children: []
            },
            {
              NAME: '靖江市',
              NUM: '321282',
              children: []
            },
            {
              NAME: '泰兴市',
              NUM: '321283',
              children: []
            },
            {
              NAME: '兴化市',
              NUM: '321281',
              children: []
            }
          ]
        },
        {
          NAME: '无锡',
          NUM: '3202',
          children: [
            {
              NAME: '滨湖区',
              NUM: '320211',
              children: []
            },
            {
              NAME: '惠山区',
              NUM: '320206',
              children: []
            },
            {
              NAME: '江阴市',
              NUM: '320281',
              children: []
            },
            {
              NAME: '梁溪区',
              NUM: '320213',
              children: []
            },
            {
              NAME: '新吴区',
              NUM: '320214',
              children: []
            },
            {
              NAME: '锡山区',
              NUM: '320205',
              children: []
            },
            {
              NAME: '宜兴市',
              NUM: '320282',
              children: []
            }
          ]
        },
        {
          NAME: '徐州',
          NUM: '3203',
          children: [
            {
              NAME: '丰县',
              NUM: '320321',
              children: []
            },
            {
              NAME: '鼓楼区',
              NUM: '320302',
              children: []
            },
            {
              NAME: '贾汪区',
              NUM: '320305',
              children: []
            },
            {
              NAME: '沛县',
              NUM: '320322',
              children: []
            },
            {
              NAME: '邳州市',
              NUM: '320382',
              children: []
            },
            {
              NAME: '泉山区',
              NUM: '320311',
              children: []
            },
            {
              NAME: '睢宁县',
              NUM: '320324',
              children: []
            },
            {
              NAME: '铜山区',
              NUM: '320312',
              children: []
            },
            {
              NAME: '新沂市',
              NUM: '320381',
              children: []
            },
            {
              NAME: '徐州经济技术开发区',
              NUM: '320371',
              children: []
            },
            {
              NAME: '云龙区',
              NUM: '320303',
              children: []
            }
          ]
        },
        {
          NAME: '盐城',
          NUM: '3209',
          children: [
            {
              NAME: '滨海县',
              NUM: '320922',
              children: []
            },
            {
              NAME: '大丰区',
              NUM: '320904',
              children: []
            },
            {
              NAME: '东台市',
              NUM: '320981',
              children: []
            },
            {
              NAME: '阜宁县',
              NUM: '320923',
              children: []
            },
            {
              NAME: '建湖县',
              NUM: '320925',
              children: []
            },
            {
              NAME: '射阳县',
              NUM: '320924',
              children: []
            },
            {
              NAME: '亭湖区',
              NUM: '320902',
              children: []
            },
            {
              NAME: '响水县',
              NUM: '320921',
              children: []
            },
            {
              NAME: '盐城经济技术开发区',
              NUM: '320971',
              children: []
            },
            {
              NAME: '盐都区',
              NUM: '320903',
              children: []
            }
          ]
        },
        {
          NAME: '扬州',
          NUM: '3210',
          children: [
            {
              NAME: '宝应县',
              NUM: '321023',
              children: []
            },
            {
              NAME: '高邮市',
              NUM: '321084',
              children: []
            },
            {
              NAME: '广陵区',
              NUM: '321002',
              children: []
            },
            {
              NAME: '邗江区',
              NUM: '321003',
              children: []
            },
            {
              NAME: '江都区',
              NUM: '321012',
              children: []
            },
            {
              NAME: '扬州经济技术开发区',
              NUM: '321071',
              children: []
            },
            {
              NAME: '仪征市',
              NUM: '321081',
              children: []
            }
          ]
        },
        {
          NAME: '镇江',
          NUM: '3211',
          children: [
            {
              NAME: '丹徒区',
              NUM: '321112',
              children: []
            },
            {
              NAME: '丹阳市',
              NUM: '321181',
              children: []
            },
            {
              NAME: '京口区',
              NUM: '321102',
              children: []
            },
            {
              NAME: '句容市',
              NUM: '321183',
              children: []
            },
            {
              NAME: '润州区',
              NUM: '321111',
              children: []
            },
            {
              NAME: '扬中市',
              NUM: '321182',
              children: []
            },
            {
              NAME: '镇江新区',
              NUM: '321171',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '江西',
      NUM: '36',
      CODE: '',
      children: [
        {
          NAME: '抚州',
          NUM: '3610',
          children: [
            {
              NAME: '崇仁县',
              NUM: '361024',
              children: []
            },
            {
              NAME: '东乡区',
              NUM: '361003',
              children: []
            },
            {
              NAME: '广昌县',
              NUM: '361030',
              children: []
            },
            {
              NAME: '金溪县',
              NUM: '361027',
              children: []
            },
            {
              NAME: '乐安县',
              NUM: '361025',
              children: []
            },
            {
              NAME: '黎川县',
              NUM: '361022',
              children: []
            },
            {
              NAME: '临川区',
              NUM: '361002',
              children: []
            },
            {
              NAME: '南城县',
              NUM: '361021',
              children: []
            },
            {
              NAME: '南丰县',
              NUM: '361023',
              children: []
            },
            {
              NAME: '宜黄县',
              NUM: '361026',
              children: []
            },
            {
              NAME: '资溪县',
              NUM: '361028',
              children: []
            }
          ]
        },
        {
          NAME: '赣州',
          NUM: '3607',
          children: [
            {
              NAME: '安远县',
              NUM: '360726',
              children: []
            },
            {
              NAME: '崇义县',
              NUM: '360725',
              children: []
            },
            {
              NAME: '大余县',
              NUM: '360723',
              children: []
            },
            {
              NAME: '定南县',
              NUM: '360728',
              children: []
            },
            {
              NAME: '赣县区',
              NUM: '360704',
              children: []
            },
            {
              NAME: '会昌县',
              NUM: '360733',
              children: []
            },
            {
              NAME: '龙南市',
              NUM: '360783',
              children: []
            },
            {
              NAME: '南康区',
              NUM: '360703',
              children: []
            },
            {
              NAME: '宁都县',
              NUM: '360730',
              children: []
            },
            {
              NAME: '全南县',
              NUM: '360729',
              children: []
            },
            {
              NAME: '瑞金市',
              NUM: '360781',
              children: []
            },
            {
              NAME: '上犹县',
              NUM: '360724',
              children: []
            },
            {
              NAME: '石城县',
              NUM: '360735',
              children: []
            },
            {
              NAME: '信丰县',
              NUM: '360722',
              children: []
            },
            {
              NAME: '兴国县',
              NUM: '360732',
              children: []
            },
            {
              NAME: '寻乌县',
              NUM: '360734',
              children: []
            },
            {
              NAME: '于都县',
              NUM: '360731',
              children: []
            },
            {
              NAME: '章贡区',
              NUM: '360702',
              children: []
            }
          ]
        },
        {
          NAME: '吉安',
          NUM: '3608',
          children: [
            {
              NAME: '安福县',
              NUM: '360829',
              children: []
            },
            {
              NAME: '吉安县',
              NUM: '360821',
              children: []
            },
            {
              NAME: '井冈山市',
              NUM: '360881',
              children: []
            },
            {
              NAME: '吉水县',
              NUM: '360822',
              children: []
            },
            {
              NAME: '吉州区',
              NUM: '360802',
              children: []
            },
            {
              NAME: '青原区',
              NUM: '360803',
              children: []
            },
            {
              NAME: '遂川县',
              NUM: '360827',
              children: []
            },
            {
              NAME: '泰和县',
              NUM: '360826',
              children: []
            },
            {
              NAME: '万安县',
              NUM: '360828',
              children: []
            },
            {
              NAME: '峡江县',
              NUM: '360823',
              children: []
            },
            {
              NAME: '新干县',
              NUM: '360824',
              children: []
            },
            {
              NAME: '永丰县',
              NUM: '360825',
              children: []
            },
            {
              NAME: '永新县',
              NUM: '360830',
              children: []
            }
          ]
        },
        {
          NAME: '景德镇',
          NUM: '3602',
          children: [
            {
              NAME: '昌江区',
              NUM: '360202',
              children: []
            },
            {
              NAME: '浮梁县',
              NUM: '360222',
              children: []
            },
            {
              NAME: '乐平市',
              NUM: '360281',
              children: []
            },
            {
              NAME: '珠山区',
              NUM: '360203',
              children: []
            }
          ]
        },
        {
          NAME: '九江',
          NUM: '3604',
          children: [
            {
              NAME: '柴桑区',
              NUM: '360404',
              children: []
            },
            {
              NAME: '德安县',
              NUM: '360426',
              children: []
            },
            {
              NAME: '都昌县',
              NUM: '360428',
              children: []
            },
            {
              NAME: '共青城市',
              NUM: '360482',
              children: []
            },
            {
              NAME: '湖口县',
              NUM: '360429',
              children: []
            },
            {
              NAME: '濂溪区',
              NUM: '360402',
              children: []
            },
            {
              NAME: '庐山市',
              NUM: '360483',
              children: []
            },
            {
              NAME: '彭泽县',
              NUM: '360430',
              children: []
            },
            {
              NAME: '瑞昌市',
              NUM: '360481',
              children: []
            },
            {
              NAME: '武宁县',
              NUM: '360423',
              children: []
            },
            {
              NAME: '修水县',
              NUM: '360424',
              children: []
            },
            {
              NAME: '浔阳区',
              NUM: '360403',
              children: []
            },
            {
              NAME: '永修县',
              NUM: '360425',
              children: []
            }
          ]
        },
        {
          NAME: '南昌',
          NUM: '3601',
          children: [
            {
              NAME: '安义县',
              NUM: '360123',
              children: []
            },
            {
              NAME: '东湖区',
              NUM: '360102',
              children: []
            },
            {
              NAME: '红谷滩区',
              NUM: '360113',
              children: []
            },
            {
              NAME: '进贤县',
              NUM: '360124',
              children: []
            },
            {
              NAME: '南昌县',
              NUM: '360121',
              children: []
            },
            {
              NAME: '青山湖区',
              NUM: '360111',
              children: []
            },
            {
              NAME: '青云谱区',
              NUM: '360104',
              children: []
            },
            {
              NAME: '西湖区',
              NUM: '360103',
              children: []
            },
            {
              NAME: '新建区',
              NUM: '360112',
              children: []
            }
          ]
        },
        {
          NAME: '萍乡',
          NUM: '3603',
          children: [
            {
              NAME: '安源区',
              NUM: '360302',
              children: []
            },
            {
              NAME: '莲花县',
              NUM: '360321',
              children: []
            },
            {
              NAME: '芦溪县',
              NUM: '360323',
              children: []
            },
            {
              NAME: '上栗县',
              NUM: '360322',
              children: []
            },
            {
              NAME: '湘东区',
              NUM: '360313',
              children: []
            }
          ]
        },
        {
          NAME: '上饶',
          NUM: '3611',
          children: [
            {
              NAME: '德兴市',
              NUM: '361181',
              children: []
            },
            {
              NAME: '广丰区',
              NUM: '361103',
              children: []
            },
            {
              NAME: '广信区',
              NUM: '361104',
              children: []
            },
            {
              NAME: '横峰县',
              NUM: '361125',
              children: []
            },
            {
              NAME: '鄱阳县',
              NUM: '361128',
              children: []
            },
            {
              NAME: '万年县',
              NUM: '361129',
              children: []
            },
            {
              NAME: '婺源县',
              NUM: '361130',
              children: []
            },
            {
              NAME: '信州区',
              NUM: '361102',
              children: []
            },
            {
              NAME: '铅山县',
              NUM: '361124',
              children: []
            },
            {
              NAME: '弋阳县',
              NUM: '361126',
              children: []
            },
            {
              NAME: '余干县',
              NUM: '361127',
              children: []
            },
            {
              NAME: '玉山县',
              NUM: '361123',
              children: []
            }
          ]
        },
        {
          NAME: '新余',
          NUM: '3605',
          children: [
            {
              NAME: '分宜县',
              NUM: '360521',
              children: []
            },
            {
              NAME: '渝水区',
              NUM: '360502',
              children: []
            }
          ]
        },
        {
          NAME: '宜春',
          NUM: '3609',
          children: [
            {
              NAME: '丰城市',
              NUM: '360981',
              children: []
            },
            {
              NAME: '奉新县',
              NUM: '360921',
              children: []
            },
            {
              NAME: '高安市',
              NUM: '360983',
              children: []
            },
            {
              NAME: '靖安县',
              NUM: '360925',
              children: []
            },
            {
              NAME: '上高县',
              NUM: '360923',
              children: []
            },
            {
              NAME: '铜鼓县',
              NUM: '360926',
              children: []
            },
            {
              NAME: '万载县',
              NUM: '360922',
              children: []
            },
            {
              NAME: '宜丰县',
              NUM: '360924',
              children: []
            },
            {
              NAME: '袁州区',
              NUM: '360902',
              children: []
            },
            {
              NAME: '樟树市',
              NUM: '360982',
              children: []
            }
          ]
        },
        {
          NAME: '鹰潭',
          NUM: '3606',
          children: [
            {
              NAME: '贵溪市',
              NUM: '360681',
              children: []
            },
            {
              NAME: '月湖区',
              NUM: '360602',
              children: []
            },
            {
              NAME: '余江区',
              NUM: '360603',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '吉林',
      NUM: '22',
      CODE: '',
      children: [
        {
          NAME: '白城',
          NUM: '2208',
          children: [
            {
              NAME: '大安市',
              NUM: '220882',
              children: []
            },
            {
              NAME: '吉林白城经济开发区',
              NUM: '220871',
              children: []
            },
            {
              NAME: '洮北区',
              NUM: '220802',
              children: []
            },
            {
              NAME: '洮南市',
              NUM: '220881',
              children: []
            },
            {
              NAME: '通榆县',
              NUM: '220822',
              children: []
            },
            {
              NAME: '镇赉县',
              NUM: '220821',
              children: []
            }
          ]
        },
        {
          NAME: '白山',
          NUM: '2206',
          children: [
            {
              NAME: '抚松县',
              NUM: '220621',
              children: []
            },
            {
              NAME: '浑江区',
              NUM: '220602',
              children: []
            },
            {
              NAME: '江源区',
              NUM: '220605',
              children: []
            },
            {
              NAME: '靖宇县',
              NUM: '220622',
              children: []
            },
            {
              NAME: '临江市',
              NUM: '220681',
              children: []
            },
            {
              NAME: '长白朝鲜族自治县',
              NUM: '220623',
              children: []
            }
          ]
        },
        {
          NAME: '长春',
          NUM: '2201',
          children: [
            {
              NAME: '长春高新技术产业开发区',
              NUM: '220173',
              children: []
            },
            {
              NAME: '长春经济技术开发区',
              NUM: '220171',
              children: []
            },
            {
              NAME: '长春净月高新技术产业开发区',
              NUM: '220172',
              children: []
            },
            {
              NAME: '长春汽车经济技术开发区',
              NUM: '220174',
              children: []
            },
            {
              NAME: '朝阳区',
              NUM: '220104',
              children: []
            },
            {
              NAME: '德惠市',
              NUM: '220183',
              children: []
            },
            {
              NAME: '二道区',
              NUM: '220105',
              children: []
            },
            {
              NAME: '公主岭市',
              NUM: '220184',
              children: []
            },
            {
              NAME: '九台区',
              NUM: '220113',
              children: []
            },
            {
              NAME: '宽城区',
              NUM: '220103',
              children: []
            },
            {
              NAME: '绿园区',
              NUM: '220106',
              children: []
            },
            {
              NAME: '南关区',
              NUM: '220102',
              children: []
            },
            {
              NAME: '农安县',
              NUM: '220122',
              children: []
            },
            {
              NAME: '双阳区',
              NUM: '220112',
              children: []
            },
            {
              NAME: '榆树市',
              NUM: '220182',
              children: []
            }
          ]
        },
        {
          NAME: '吉林',
          NUM: '2202',
          children: [
            {
              NAME: '昌邑区',
              NUM: '220202',
              children: []
            },
            {
              NAME: '船营区',
              NUM: '220204',
              children: []
            },
            {
              NAME: '丰满区',
              NUM: '220211',
              children: []
            },
            {
              NAME: '桦甸市',
              NUM: '220282',
              children: []
            },
            {
              NAME: '蛟河市',
              NUM: '220281',
              children: []
            },
            {
              NAME: '吉林高新技术产业开发区',
              NUM: '220272',
              children: []
            },
            {
              NAME: '吉林经济开发区',
              NUM: '220271',
              children: []
            },
            {
              NAME: '吉林中国新加坡食品区',
              NUM: '220273',
              children: []
            },
            {
              NAME: '龙潭区',
              NUM: '220203',
              children: []
            },
            {
              NAME: '磐石市',
              NUM: '220284',
              children: []
            },
            {
              NAME: '舒兰市',
              NUM: '220283',
              children: []
            },
            {
              NAME: '永吉县',
              NUM: '220221',
              children: []
            }
          ]
        },
        {
          NAME: '辽源',
          NUM: '2204',
          children: [
            {
              NAME: '东丰县',
              NUM: '220421',
              children: []
            },
            {
              NAME: '东辽县',
              NUM: '220422',
              children: []
            },
            {
              NAME: '龙山区',
              NUM: '220402',
              children: []
            },
            {
              NAME: '西安区',
              NUM: '220403',
              children: []
            }
          ]
        },
        {
          NAME: '四平',
          NUM: '2203',
          children: [
            {
              NAME: '梨树县',
              NUM: '220322',
              children: []
            },
            {
              NAME: '双辽市',
              NUM: '220382',
              children: []
            },
            {
              NAME: '铁东区',
              NUM: '220303',
              children: []
            },
            {
              NAME: '铁西区',
              NUM: '220302',
              children: []
            },
            {
              NAME: '伊通满族自治县',
              NUM: '220323',
              children: []
            }
          ]
        },
        {
          NAME: '松原',
          NUM: '2207',
          children: [
            {
              NAME: '扶余市',
              NUM: '220781',
              children: []
            },
            {
              NAME: '吉林松原经济开发区',
              NUM: '220771',
              children: []
            },
            {
              NAME: '宁江区',
              NUM: '220702',
              children: []
            },
            {
              NAME: '乾安县',
              NUM: '220723',
              children: []
            },
            {
              NAME: '前郭尔罗斯蒙古族自治县',
              NUM: '220721',
              children: []
            },
            {
              NAME: '长岭县',
              NUM: '220722',
              children: []
            }
          ]
        },
        {
          NAME: '通化',
          NUM: '2205',
          children: [
            {
              NAME: '东昌区',
              NUM: '220502',
              children: []
            },
            {
              NAME: '二道江区',
              NUM: '220503',
              children: []
            },
            {
              NAME: '辉南县',
              NUM: '220523',
              children: []
            },
            {
              NAME: '集安市',
              NUM: '220582',
              children: []
            },
            {
              NAME: '柳河县',
              NUM: '220524',
              children: []
            },
            {
              NAME: '梅河口市',
              NUM: '220581',
              children: []
            },
            {
              NAME: '通化县',
              NUM: '220521',
              children: []
            }
          ]
        },
        {
          NAME: '延边朝鲜族自治州',
          NUM: '2224',
          children: [
            {
              NAME: '安图县',
              NUM: '222426',
              children: []
            },
            {
              NAME: '敦化市',
              NUM: '222403',
              children: []
            },
            {
              NAME: '和龙市',
              NUM: '222406',
              children: []
            },
            {
              NAME: '珲春市',
              NUM: '222404',
              children: []
            },
            {
              NAME: '龙井市',
              NUM: '222405',
              children: []
            },
            {
              NAME: '图们市',
              NUM: '222402',
              children: []
            },
            {
              NAME: '汪清县',
              NUM: '222424',
              children: []
            },
            {
              NAME: '延吉市',
              NUM: '222401',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '辽宁',
      NUM: '21',
      CODE: 'L',
      children: [
        {
          NAME: '鞍山',
          NUM: '2103',
          children: [
            {
              NAME: '海城市',
              NUM: '210381',
              children: []
            },
            {
              NAME: '立山区',
              NUM: '210304',
              children: []
            },
            {
              NAME: '千山区',
              NUM: '210311',
              children: []
            },
            {
              NAME: '台安县',
              NUM: '210321',
              children: []
            },
            {
              NAME: '铁东区',
              NUM: '210302',
              children: []
            },
            {
              NAME: '铁西区',
              NUM: '210303',
              children: []
            },
            {
              NAME: '岫岩满族自治县',
              NUM: '210323',
              children: []
            }
          ]
        },
        {
          NAME: '本溪',
          NUM: '2105',
          children: [
            {
              NAME: '本溪满族自治县',
              NUM: '210521',
              children: []
            },
            {
              NAME: '桓仁满族自治县',
              NUM: '210522',
              children: []
            },
            {
              NAME: '明山区',
              NUM: '210504',
              children: []
            },
            {
              NAME: '南芬区',
              NUM: '210505',
              children: []
            },
            {
              NAME: '平山区',
              NUM: '210502',
              children: []
            },
            {
              NAME: '溪湖区',
              NUM: '210503',
              children: []
            }
          ]
        },
        {
          NAME: '大连',
          NUM: '2102',
          children: [
            {
              NAME: '甘井子区',
              NUM: '210211',
              children: []
            },
            {
              NAME: '金州区',
              NUM: '210213',
              children: []
            },
            {
              NAME: '旅顺口区',
              NUM: '210212',
              children: []
            },
            {
              NAME: '普兰店区',
              NUM: '210214',
              children: []
            },
            {
              NAME: '沙河口区',
              NUM: '210204',
              children: []
            },
            {
              NAME: '瓦房店市',
              NUM: '210281',
              children: []
            },
            {
              NAME: '西岗区',
              NUM: '210203',
              children: []
            },
            {
              NAME: '长海县',
              NUM: '210224',
              children: []
            },
            {
              NAME: '中山区',
              NUM: '210202',
              children: []
            },
            {
              NAME: '庄河市',
              NUM: '210283',
              children: []
            }
          ]
        },
        {
          NAME: '丹东',
          NUM: '2106',
          children: [
            {
              NAME: '东港市',
              NUM: '210681',
              children: []
            },
            {
              NAME: '凤城市',
              NUM: '210682',
              children: []
            },
            {
              NAME: '宽甸满族自治县',
              NUM: '210624',
              children: []
            },
            {
              NAME: '元宝区',
              NUM: '210602',
              children: []
            },
            {
              NAME: '振安区',
              NUM: '210604',
              children: []
            },
            {
              NAME: '振兴区',
              NUM: '210603',
              children: []
            }
          ]
        },
        {
          NAME: '抚顺',
          NUM: '2104',
          children: [
            {
              NAME: '东洲区',
              NUM: '210403',
              children: []
            },
            {
              NAME: '抚顺县',
              NUM: '210421',
              children: []
            },
            {
              NAME: '清原满族自治县',
              NUM: '210423',
              children: []
            },
            {
              NAME: '顺城区',
              NUM: '210411',
              children: []
            },
            {
              NAME: '望花区',
              NUM: '210404',
              children: []
            },
            {
              NAME: '新宾满族自治县',
              NUM: '210422',
              children: []
            },
            {
              NAME: '新抚区',
              NUM: '210402',
              children: []
            }
          ]
        },
        {
          NAME: '阜新',
          NUM: '2109',
          children: [
            {
              NAME: '阜新蒙古族自治县',
              NUM: '210921',
              children: []
            },
            {
              NAME: '海州区',
              NUM: '210902',
              children: []
            },
            {
              NAME: '清河门区',
              NUM: '210905',
              children: []
            },
            {
              NAME: '太平区',
              NUM: '210904',
              children: []
            },
            {
              NAME: '细河区',
              NUM: '210911',
              children: []
            },
            {
              NAME: '新邱区',
              NUM: '210903',
              children: []
            },
            {
              NAME: '彰武县',
              NUM: '210922',
              children: []
            }
          ]
        },
        {
          NAME: '葫芦岛',
          NUM: '2114',
          children: [
            {
              NAME: '建昌县',
              NUM: '211422',
              children: []
            },
            {
              NAME: '连山区',
              NUM: '211402',
              children: []
            },
            {
              NAME: '龙港区',
              NUM: '211403',
              children: []
            },
            {
              NAME: '南票区',
              NUM: '211404',
              children: []
            },
            {
              NAME: '绥中县',
              NUM: '211421',
              children: []
            },
            {
              NAME: '兴城市',
              NUM: '211481',
              children: []
            }
          ]
        },
        {
          NAME: '锦州',
          NUM: '2107',
          children: [
            {
              NAME: '北镇市',
              NUM: '210782',
              children: []
            },
            {
              NAME: '古塔区',
              NUM: '210702',
              children: []
            },
            {
              NAME: '黑山县',
              NUM: '210726',
              children: []
            },
            {
              NAME: '凌海市',
              NUM: '210781',
              children: []
            },
            {
              NAME: '凌河区',
              NUM: '210703',
              children: []
            },
            {
              NAME: '太和区',
              NUM: '210711',
              children: []
            },
            {
              NAME: '义县',
              NUM: '210727',
              children: []
            }
          ]
        },
        {
          NAME: '辽阳',
          NUM: '2110',
          children: [
            {
              NAME: '白塔区',
              NUM: '211002',
              children: []
            },
            {
              NAME: '灯塔市',
              NUM: '211081',
              children: []
            },
            {
              NAME: '弓长岭区',
              NUM: '211005',
              children: []
            },
            {
              NAME: '宏伟区',
              NUM: '211004',
              children: []
            },
            {
              NAME: '辽阳县',
              NUM: '211021',
              children: []
            },
            {
              NAME: '太子河区',
              NUM: '211011',
              children: []
            },
            {
              NAME: '文圣区',
              NUM: '211003',
              children: []
            }
          ]
        },
        {
          NAME: '盘锦',
          NUM: '2111',
          children: [
            {
              NAME: '大洼区',
              NUM: '211104',
              children: []
            },
            {
              NAME: '盘山县',
              NUM: '211122',
              children: []
            },
            {
              NAME: '双台子区',
              NUM: '211102',
              children: []
            },
            {
              NAME: '兴隆台区',
              NUM: '211103',
              children: []
            }
          ]
        },
        {
          NAME: '沈抚改革创新示范区',
          NUM: '2115',
          children: []
        },
        {
          NAME: '沈阳',
          NUM: '2101',
          children: [
            {
              NAME: '大东区',
              NUM: '210104',
              children: []
            },
            {
              NAME: '法库县',
              NUM: '210124',
              children: []
            },
            {
              NAME: '和平区',
              NUM: '210102',
              children: []
            },
            {
              NAME: '皇姑区',
              NUM: '210105',
              children: []
            },
            {
              NAME: '浑南区',
              NUM: '210112',
              children: []
            },
            {
              NAME: '康平县',
              NUM: '210123',
              children: []
            },
            {
              NAME: '辽中区',
              NUM: '210115',
              children: []
            },
            {
              NAME: '沈北新区',
              NUM: '210113',
              children: []
            },
            {
              NAME: '沈河区',
              NUM: '210103',
              children: []
            },
            {
              NAME: '苏家屯区',
              NUM: '210111',
              children: []
            },
            {
              NAME: '铁西区',
              NUM: '210106',
              children: []
            },
            {
              NAME: '新民市',
              NUM: '210181',
              children: []
            },
            {
              NAME: '于洪区',
              NUM: '210114',
              children: []
            }
          ]
        },
        {
          NAME: '铁岭',
          NUM: '2112',
          children: [
            {
              NAME: '昌图县',
              NUM: '211224',
              children: []
            },
            {
              NAME: '调兵山市',
              NUM: '211281',
              children: []
            },
            {
              NAME: '开原市',
              NUM: '211282',
              children: []
            },
            {
              NAME: '清河区',
              NUM: '211204',
              children: []
            },
            {
              NAME: '铁岭县',
              NUM: '211221',
              children: []
            },
            {
              NAME: '西丰县',
              NUM: '211223',
              children: []
            },
            {
              NAME: '银州区',
              NUM: '211202',
              children: []
            }
          ]
        },
        {
          NAME: '营口',
          NUM: '2108',
          children: [
            {
              NAME: '鲅鱼圈区',
              NUM: '210804',
              children: []
            },
            {
              NAME: '大石桥市',
              NUM: '210882',
              children: []
            },
            {
              NAME: '盖州市',
              NUM: '210881',
              children: []
            },
            {
              NAME: '老边区',
              NUM: '210811',
              children: []
            },
            {
              NAME: '西市区',
              NUM: '210803',
              children: []
            },
            {
              NAME: '站前区',
              NUM: '210802',
              children: []
            }
          ]
        },
        {
          NAME: '朝阳',
          NUM: '2113',
          children: [
            {
              NAME: '北票市',
              NUM: '211381',
              children: []
            },
            {
              NAME: '建平县',
              NUM: '211322',
              children: []
            },
            {
              NAME: '喀喇沁左翼蒙古族自治县',
              NUM: '211324',
              children: []
            },
            {
              NAME: '凌源市',
              NUM: '211382',
              children: []
            },
            {
              NAME: '龙城区',
              NUM: '211303',
              children: []
            },
            {
              NAME: '双塔区',
              NUM: '211302',
              children: []
            },
            {
              NAME: '朝阳县',
              NUM: '211321',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '内蒙古',
      NUM: '15',
      CODE: 'N',
      children: [
        {
          NAME: '阿拉善盟',
          NUM: '1529',
          children: [
            {
              NAME: '阿拉善右旗',
              NUM: '152922',
              children: []
            },
            {
              NAME: '阿拉善左旗',
              NUM: '152921',
              children: []
            },
            {
              NAME: '额济纳旗',
              NUM: '152923',
              children: []
            },
            {
              NAME: '内蒙古阿拉善高新技术产业开发区',
              NUM: '152971',
              children: []
            }
          ]
        },
        {
          NAME: '包头',
          NUM: '1502',
          children: [
            {
              NAME: '白云鄂博矿区',
              NUM: '150206',
              children: []
            },
            {
              NAME: '包头稀土高新技术产业开发区',
              NUM: '150271',
              children: []
            },
            {
              NAME: '达尔罕茂明安联合旗',
              NUM: '150223',
              children: []
            },
            {
              NAME: '东河区',
              NUM: '150202',
              children: []
            },
            {
              NAME: '固阳县',
              NUM: '150222',
              children: []
            },
            {
              NAME: '九原区',
              NUM: '150207',
              children: []
            },
            {
              NAME: '昆都仑区',
              NUM: '150203',
              children: []
            },
            {
              NAME: '青山区',
              NUM: '150204',
              children: []
            },
            {
              NAME: '石拐区',
              NUM: '150205',
              children: []
            },
            {
              NAME: '土默特右旗',
              NUM: '150221',
              children: []
            }
          ]
        },
        {
          NAME: '巴彦淖尔',
          NUM: '1508',
          children: [
            {
              NAME: '磴口县',
              NUM: '150822',
              children: []
            },
            {
              NAME: '杭锦后旗',
              NUM: '150826',
              children: []
            },
            {
              NAME: '临河区',
              NUM: '150802',
              children: []
            },
            {
              NAME: '乌拉特后旗',
              NUM: '150825',
              children: []
            },
            {
              NAME: '乌拉特前旗',
              NUM: '150823',
              children: []
            },
            {
              NAME: '乌拉特中旗',
              NUM: '150824',
              children: []
            },
            {
              NAME: '五原县',
              NUM: '150821',
              children: []
            }
          ]
        },
        {
          NAME: '赤峰',
          NUM: '1504',
          children: [
            {
              NAME: '阿鲁科尔沁旗',
              NUM: '150421',
              children: []
            },
            {
              NAME: '敖汉旗',
              NUM: '150430',
              children: []
            },
            {
              NAME: '巴林右旗',
              NUM: '150423',
              children: []
            },
            {
              NAME: '巴林左旗',
              NUM: '150422',
              children: []
            },
            {
              NAME: '红山区',
              NUM: '150402',
              children: []
            },
            {
              NAME: '喀喇沁旗',
              NUM: '150428',
              children: []
            },
            {
              NAME: '克什克腾旗',
              NUM: '150425',
              children: []
            },
            {
              NAME: '林西县',
              NUM: '150424',
              children: []
            },
            {
              NAME: '宁城县',
              NUM: '150429',
              children: []
            },
            {
              NAME: '松山区',
              NUM: '150404',
              children: []
            },
            {
              NAME: '翁牛特旗',
              NUM: '150426',
              children: []
            },
            {
              NAME: '元宝山区',
              NUM: '150403',
              children: []
            }
          ]
        },
        {
          NAME: '鄂尔多斯',
          NUM: '1506',
          children: [
            {
              NAME: '达拉特旗',
              NUM: '150621',
              children: []
            },
            {
              NAME: '东胜区',
              NUM: '150602',
              children: []
            },
            {
              NAME: '鄂托克旗',
              NUM: '150624',
              children: []
            },
            {
              NAME: '鄂托克前旗',
              NUM: '150623',
              children: []
            },
            {
              NAME: '杭锦旗',
              NUM: '150625',
              children: []
            },
            {
              NAME: '康巴什区',
              NUM: '150603',
              children: []
            },
            {
              NAME: '乌审旗',
              NUM: '150626',
              children: []
            },
            {
              NAME: '伊金霍洛旗',
              NUM: '150627',
              children: []
            },
            {
              NAME: '准格尔旗',
              NUM: '150622',
              children: []
            }
          ]
        },
        {
          NAME: '呼和浩特',
          NUM: '1501',
          children: [
            {
              NAME: '和林格尔县',
              NUM: '150123',
              children: []
            },
            {
              NAME: '呼和浩特经济技术开发区',
              NUM: '150172',
              children: []
            },
            {
              NAME: '回民区',
              NUM: '150103',
              children: []
            },
            {
              NAME: '清水河县',
              NUM: '150124',
              children: []
            },
            {
              NAME: '赛罕区',
              NUM: '150105',
              children: []
            },
            {
              NAME: '土默特左旗',
              NUM: '150121',
              children: []
            },
            {
              NAME: '托克托县',
              NUM: '150122',
              children: []
            },
            {
              NAME: '武川县',
              NUM: '150125',
              children: []
            },
            {
              NAME: '新城区',
              NUM: '150102',
              children: []
            },
            {
              NAME: '玉泉区',
              NUM: '150104',
              children: []
            }
          ]
        },
        {
          NAME: '呼伦贝尔',
          NUM: '1507',
          children: [
            {
              NAME: '阿荣旗',
              NUM: '150721',
              children: []
            },
            {
              NAME: '陈巴尔虎旗',
              NUM: '150725',
              children: []
            },
            {
              NAME: '额尔古纳市',
              NUM: '150784',
              children: []
            },
            {
              NAME: '鄂伦春自治旗',
              NUM: '150723',
              children: []
            },
            {
              NAME: '鄂温克族自治旗',
              NUM: '150724',
              children: []
            },
            {
              NAME: '根河市',
              NUM: '150785',
              children: []
            },
            {
              NAME: '海拉尔区',
              NUM: '150702',
              children: []
            },
            {
              NAME: '满洲里市',
              NUM: '150781',
              children: []
            },
            {
              NAME: '莫力达瓦达斡尔族自治旗',
              NUM: '150722',
              children: []
            },
            {
              NAME: '新巴尔虎右旗',
              NUM: '150727',
              children: []
            },
            {
              NAME: '新巴尔虎左旗',
              NUM: '150726',
              children: []
            },
            {
              NAME: '牙克石市',
              NUM: '150782',
              children: []
            },
            {
              NAME: '扎赉诺尔区',
              NUM: '150703',
              children: []
            },
            {
              NAME: '扎兰屯市',
              NUM: '150783',
              children: []
            }
          ]
        },
        {
          NAME: '通辽',
          NUM: '1505',
          children: [
            {
              NAME: '霍林郭勒市',
              NUM: '150581',
              children: []
            },
            {
              NAME: '开鲁县',
              NUM: '150523',
              children: []
            },
            {
              NAME: '科尔沁区',
              NUM: '150502',
              children: []
            },
            {
              NAME: '科尔沁左翼后旗',
              NUM: '150522',
              children: []
            },
            {
              NAME: '科尔沁左翼中旗',
              NUM: '150521',
              children: []
            },
            {
              NAME: '库伦旗',
              NUM: '150524',
              children: []
            },
            {
              NAME: '奈曼旗',
              NUM: '150525',
              children: []
            },
            {
              NAME: '通辽经济技术开发区',
              NUM: '150571',
              children: []
            },
            {
              NAME: '扎鲁特旗',
              NUM: '150526',
              children: []
            }
          ]
        },
        {
          NAME: '乌海',
          NUM: '1503',
          children: [
            {
              NAME: '海勃湾区',
              NUM: '150302',
              children: []
            },
            {
              NAME: '海南区',
              NUM: '150303',
              children: []
            },
            {
              NAME: '乌达区',
              NUM: '150304',
              children: []
            }
          ]
        },
        {
          NAME: '乌兰察布',
          NUM: '1509',
          children: [
            {
              NAME: '察哈尔右翼后旗',
              NUM: '150928',
              children: []
            },
            {
              NAME: '察哈尔右翼前旗',
              NUM: '150926',
              children: []
            },
            {
              NAME: '察哈尔右翼中旗',
              NUM: '150927',
              children: []
            },
            {
              NAME: '丰镇市',
              NUM: '150981',
              children: []
            },
            {
              NAME: '化德县',
              NUM: '150922',
              children: []
            },
            {
              NAME: '集宁区',
              NUM: '150902',
              children: []
            },
            {
              NAME: '凉城县',
              NUM: '150925',
              children: []
            },
            {
              NAME: '商都县',
              NUM: '150923',
              children: []
            },
            {
              NAME: '四子王旗',
              NUM: '150929',
              children: []
            },
            {
              NAME: '兴和县',
              NUM: '150924',
              children: []
            },
            {
              NAME: '卓资县',
              NUM: '150921',
              children: []
            }
          ]
        },
        {
          NAME: '锡林郭勒盟',
          NUM: '1525',
          children: [
            {
              NAME: '阿巴嘎旗',
              NUM: '152522',
              children: []
            },
            {
              NAME: '东乌珠穆沁旗',
              NUM: '152525',
              children: []
            },
            {
              NAME: '多伦县',
              NUM: '152531',
              children: []
            },
            {
              NAME: '二连浩特市',
              NUM: '152501',
              children: []
            },
            {
              NAME: '苏尼特右旗',
              NUM: '152524',
              children: []
            },
            {
              NAME: '苏尼特左旗',
              NUM: '152523',
              children: []
            },
            {
              NAME: '太仆寺旗',
              NUM: '152527',
              children: []
            },
            {
              NAME: '乌拉盖管理区管委会',
              NUM: '152571',
              children: []
            },
            {
              NAME: '镶黄旗',
              NUM: '152528',
              children: []
            },
            {
              NAME: '锡林浩特市',
              NUM: '152502',
              children: []
            },
            {
              NAME: '西乌珠穆沁旗',
              NUM: '152526',
              children: []
            },
            {
              NAME: '正蓝旗',
              NUM: '152530',
              children: []
            },
            {
              NAME: '正镶白旗',
              NUM: '152529',
              children: []
            }
          ]
        },
        {
          NAME: '兴安盟',
          NUM: '1522',
          children: [
            {
              NAME: '阿尔山市',
              NUM: '152202',
              children: []
            },
            {
              NAME: '科尔沁右翼前旗',
              NUM: '152221',
              children: []
            },
            {
              NAME: '科尔沁右翼中旗',
              NUM: '152222',
              children: []
            },
            {
              NAME: '突泉县',
              NUM: '152224',
              children: []
            },
            {
              NAME: '乌兰浩特市',
              NUM: '152201',
              children: []
            },
            {
              NAME: '扎赉特旗',
              NUM: '152223',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '宁夏',
      NUM: '64',
      CODE: '',
      children: [
        {
          NAME: '固原',
          NUM: '6404',
          children: [
            {
              NAME: '泾源县',
              NUM: '640424',
              children: []
            },
            {
              NAME: '隆德县',
              NUM: '640423',
              children: []
            },
            {
              NAME: '彭阳县',
              NUM: '640425',
              children: []
            },
            {
              NAME: '西吉县',
              NUM: '640422',
              children: []
            },
            {
              NAME: '原州区',
              NUM: '640402',
              children: []
            }
          ]
        },
        {
          NAME: '石嘴山',
          NUM: '6402',
          children: [
            {
              NAME: '大武口区',
              NUM: '640202',
              children: []
            },
            {
              NAME: '惠农区',
              NUM: '640205',
              children: []
            },
            {
              NAME: '平罗县',
              NUM: '640221',
              children: []
            }
          ]
        },
        {
          NAME: '吴忠',
          NUM: '6403',
          children: [
            {
              NAME: '红寺堡区',
              NUM: '640303',
              children: []
            },
            {
              NAME: '利通区',
              NUM: '640302',
              children: []
            },
            {
              NAME: '青铜峡市',
              NUM: '640381',
              children: []
            },
            {
              NAME: '同心县',
              NUM: '640324',
              children: []
            },
            {
              NAME: '盐池县',
              NUM: '640323',
              children: []
            }
          ]
        },
        {
          NAME: '银川',
          NUM: '6401',
          children: [
            {
              NAME: '贺兰县',
              NUM: '640122',
              children: []
            },
            {
              NAME: '金凤区',
              NUM: '640106',
              children: []
            },
            {
              NAME: '灵武市',
              NUM: '640181',
              children: []
            },
            {
              NAME: '兴庆区',
              NUM: '640104',
              children: []
            },
            {
              NAME: '西夏区',
              NUM: '640105',
              children: []
            },
            {
              NAME: '永宁县',
              NUM: '640121',
              children: []
            }
          ]
        },
        {
          NAME: '中卫',
          NUM: '6405',
          children: [
            {
              NAME: '海原县',
              NUM: '640522',
              children: []
            },
            {
              NAME: '沙坡头区',
              NUM: '640502',
              children: []
            },
            {
              NAME: '中宁县',
              NUM: '640521',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '青海',
      NUM: '63',
      CODE: 'Q',
      children: [
        {
          NAME: '果洛藏族自治州',
          NUM: '6326',
          children: [
            {
              NAME: '班玛县',
              NUM: '632622',
              children: []
            },
            {
              NAME: '达日县',
              NUM: '632624',
              children: []
            },
            {
              NAME: '甘德县',
              NUM: '632623',
              children: []
            },
            {
              NAME: '久治县',
              NUM: '632625',
              children: []
            },
            {
              NAME: '玛多县',
              NUM: '632626',
              children: []
            },
            {
              NAME: '玛沁县',
              NUM: '632621',
              children: []
            }
          ]
        },
        {
          NAME: '海北藏族自治州',
          NUM: '6322',
          children: [
            {
              NAME: '刚察县',
              NUM: '632224',
              children: []
            },
            {
              NAME: '海晏县',
              NUM: '632223',
              children: []
            },
            {
              NAME: '门源回族自治县',
              NUM: '632221',
              children: []
            },
            {
              NAME: '祁连县',
              NUM: '632222',
              children: []
            }
          ]
        },
        {
          NAME: '海东',
          NUM: '6302',
          children: [
            {
              NAME: '化隆回族自治县',
              NUM: '630224',
              children: []
            },
            {
              NAME: '互助土族自治县',
              NUM: '630223',
              children: []
            },
            {
              NAME: '乐都区',
              NUM: '630202',
              children: []
            },
            {
              NAME: '民和回族土族自治县',
              NUM: '630222',
              children: []
            },
            {
              NAME: '平安区',
              NUM: '630203',
              children: []
            },
            {
              NAME: '循化撒拉族自治县',
              NUM: '630225',
              children: []
            }
          ]
        },
        {
          NAME: '海南藏族自治州',
          NUM: '6325',
          children: [
            {
              NAME: '共和县',
              NUM: '632521',
              children: []
            },
            {
              NAME: '贵德县',
              NUM: '632523',
              children: []
            },
            {
              NAME: '贵南县',
              NUM: '632525',
              children: []
            },
            {
              NAME: '同德县',
              NUM: '632522',
              children: []
            },
            {
              NAME: '兴海县',
              NUM: '632524',
              children: []
            }
          ]
        },
        {
          NAME: '海西蒙古族藏族自治州',
          NUM: '6328',
          children: [
            {
              NAME: '大柴旦行政委员会',
              NUM: '632857',
              children: []
            },
            {
              NAME: '德令哈市',
              NUM: '632802',
              children: []
            },
            {
              NAME: '都兰县',
              NUM: '632822',
              children: []
            },
            {
              NAME: '格尔木市',
              NUM: '632801',
              children: []
            },
            {
              NAME: '茫崖市',
              NUM: '632803',
              children: []
            },
            {
              NAME: '天峻县',
              NUM: '632823',
              children: []
            },
            {
              NAME: '乌兰县',
              NUM: '632821',
              children: []
            }
          ]
        },
        {
          NAME: '黄南藏族自治州',
          NUM: '6323',
          children: [
            {
              NAME: '河南蒙古族自治县',
              NUM: '632324',
              children: []
            },
            {
              NAME: '尖扎县',
              NUM: '632322',
              children: []
            },
            {
              NAME: '同仁市',
              NUM: '632301',
              children: []
            },
            {
              NAME: '泽库县',
              NUM: '632323',
              children: []
            }
          ]
        },
        {
          NAME: '西宁',
          NUM: '6301',
          children: [
            {
              NAME: '城北区',
              NUM: '630105',
              children: []
            },
            {
              NAME: '城东区',
              NUM: '630102',
              children: []
            },
            {
              NAME: '城西区',
              NUM: '630104',
              children: []
            },
            {
              NAME: '城中区',
              NUM: '630103',
              children: []
            },
            {
              NAME: '大通回族土族自治县',
              NUM: '630121',
              children: []
            },
            {
              NAME: '湟源县',
              NUM: '630123',
              children: []
            },
            {
              NAME: '湟中区',
              NUM: '630106',
              children: []
            }
          ]
        },
        {
          NAME: '玉树藏族自治州',
          NUM: '6327',
          children: [
            {
              NAME: '称多县',
              NUM: '632723',
              children: []
            },
            {
              NAME: '囊谦县',
              NUM: '632725',
              children: []
            },
            {
              NAME: '曲麻莱县',
              NUM: '632726',
              children: []
            },
            {
              NAME: '玉树市',
              NUM: '632701',
              children: []
            },
            {
              NAME: '杂多县',
              NUM: '632722',
              children: []
            },
            {
              NAME: '治多县',
              NUM: '632724',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '山东',
      NUM: '37',
      CODE: 'S',
      children: [
        {
          NAME: '滨州',
          NUM: '3716',
          children: [
            {
              NAME: '滨城区',
              NUM: '371602',
              children: []
            },
            {
              NAME: '博兴县',
              NUM: '371625',
              children: []
            },
            {
              NAME: '惠民县',
              NUM: '371621',
              children: []
            },
            {
              NAME: '无棣县',
              NUM: '371623',
              children: []
            },
            {
              NAME: '阳信县',
              NUM: '371622',
              children: []
            },
            {
              NAME: '沾化区',
              NUM: '371603',
              children: []
            },
            {
              NAME: '邹平市',
              NUM: '371681',
              children: []
            }
          ]
        },
        {
          NAME: '德州',
          NUM: '3714',
          children: [
            {
              NAME: '德城区',
              NUM: '371402',
              children: []
            },
            {
              NAME: '德州天衢新区',
              NUM: '371471',
              children: []
            },
            {
              NAME: '乐陵市',
              NUM: '371481',
              children: []
            },
            {
              NAME: '陵城区',
              NUM: '371403',
              children: []
            },
            {
              NAME: '临邑县',
              NUM: '371424',
              children: []
            },
            {
              NAME: '宁津县',
              NUM: '371422',
              children: []
            },
            {
              NAME: '平原县',
              NUM: '371426',
              children: []
            },
            {
              NAME: '齐河县',
              NUM: '371425',
              children: []
            },
            {
              NAME: '庆云县',
              NUM: '371423',
              children: []
            },
            {
              NAME: '武城县',
              NUM: '371428',
              children: []
            },
            {
              NAME: '夏津县',
              NUM: '371427',
              children: []
            },
            {
              NAME: '禹城市',
              NUM: '371482',
              children: []
            }
          ]
        },
        {
          NAME: '东营',
          NUM: '3705',
          children: [
            {
              NAME: '东营港经济开发区',
              NUM: '370572',
              children: []
            },
            {
              NAME: '东营经济技术开发区',
              NUM: '370571',
              children: []
            },
            {
              NAME: '东营区',
              NUM: '370502',
              children: []
            },
            {
              NAME: '广饶县',
              NUM: '370523',
              children: []
            },
            {
              NAME: '河口区',
              NUM: '370503',
              children: []
            },
            {
              NAME: '垦利区',
              NUM: '370505',
              children: []
            },
            {
              NAME: '利津县',
              NUM: '370522',
              children: []
            }
          ]
        },
        {
          NAME: '菏泽',
          NUM: '3717',
          children: [
            {
              NAME: '曹县',
              NUM: '371721',
              children: []
            },
            {
              NAME: '成武县',
              NUM: '371723',
              children: []
            },
            {
              NAME: '单县',
              NUM: '371722',
              children: []
            },
            {
              NAME: '定陶区',
              NUM: '371703',
              children: []
            },
            {
              NAME: '东明县',
              NUM: '371728',
              children: []
            },
            {
              NAME: '菏泽高新技术开发区',
              NUM: '371772',
              children: []
            },
            {
              NAME: '菏泽经济技术开发区',
              NUM: '371771',
              children: []
            },
            {
              NAME: '鄄城县',
              NUM: '371726',
              children: []
            },
            {
              NAME: '巨野县',
              NUM: '371724',
              children: []
            },
            {
              NAME: '牡丹区',
              NUM: '371702',
              children: []
            },
            {
              NAME: '郓城县',
              NUM: '371725',
              children: []
            }
          ]
        },
        {
          NAME: '济南',
          NUM: '3701',
          children: [
            {
              NAME: '钢城区',
              NUM: '370117',
              children: []
            },
            {
              NAME: '槐荫区',
              NUM: '370104',
              children: []
            },
            {
              NAME: '济南高新技术产业开发区',
              NUM: '370176',
              children: []
            },
            {
              NAME: '济阳区',
              NUM: '370115',
              children: []
            },
            {
              NAME: '莱芜区',
              NUM: '370116',
              children: []
            },
            {
              NAME: '历城区',
              NUM: '370112',
              children: []
            },
            {
              NAME: '历下区',
              NUM: '370102',
              children: []
            },
            {
              NAME: '平阴县',
              NUM: '370124',
              children: []
            },
            {
              NAME: '商河县',
              NUM: '370126',
              children: []
            },
            {
              NAME: '市中区',
              NUM: '370103',
              children: []
            },
            {
              NAME: '天桥区',
              NUM: '370105',
              children: []
            },
            {
              NAME: '长清区',
              NUM: '370113',
              children: []
            },
            {
              NAME: '章丘区',
              NUM: '370114',
              children: []
            }
          ]
        },
        {
          NAME: '济宁',
          NUM: '3708',
          children: [
            {
              NAME: '嘉祥县',
              NUM: '370829',
              children: []
            },
            {
              NAME: '济宁高新技术产业开发区',
              NUM: '370871',
              children: []
            },
            {
              NAME: '金乡县',
              NUM: '370828',
              children: []
            },
            {
              NAME: '梁山县',
              NUM: '370832',
              children: []
            },
            {
              NAME: '曲阜市',
              NUM: '370881',
              children: []
            },
            {
              NAME: '任城区',
              NUM: '370811',
              children: []
            },
            {
              NAME: '泗水县',
              NUM: '370831',
              children: []
            },
            {
              NAME: '微山县',
              NUM: '370826',
              children: []
            },
            {
              NAME: '汶上县',
              NUM: '370830',
              children: []
            },
            {
              NAME: '兖州区',
              NUM: '370812',
              children: []
            },
            {
              NAME: '鱼台县',
              NUM: '370827',
              children: []
            },
            {
              NAME: '邹城市',
              NUM: '370883',
              children: []
            }
          ]
        },
        {
          NAME: '聊城',
          NUM: '3715',
          children: [
            {
              NAME: '茌平区',
              NUM: '371503',
              children: []
            },
            {
              NAME: '东昌府区',
              NUM: '371502',
              children: []
            },
            {
              NAME: '东阿县',
              NUM: '371524',
              children: []
            },
            {
              NAME: '高唐县',
              NUM: '371526',
              children: []
            },
            {
              NAME: '冠县',
              NUM: '371525',
              children: []
            },
            {
              NAME: '临清市',
              NUM: '371581',
              children: []
            },
            {
              NAME: '莘县',
              NUM: '371522',
              children: []
            },
            {
              NAME: '阳谷县',
              NUM: '371521',
              children: []
            }
          ]
        },
        {
          NAME: '临沂',
          NUM: '3713',
          children: [
            {
              NAME: '费县',
              NUM: '371325',
              children: []
            },
            {
              NAME: '河东区',
              NUM: '371312',
              children: []
            },
            {
              NAME: '莒南县',
              NUM: '371327',
              children: []
            },
            {
              NAME: '兰陵县',
              NUM: '371324',
              children: []
            },
            {
              NAME: '兰山区',
              NUM: '371302',
              children: []
            },
            {
              NAME: '临沭县',
              NUM: '371329',
              children: []
            },
            {
              NAME: '临沂高新技术产业开发区',
              NUM: '371371',
              children: []
            },
            {
              NAME: '罗庄区',
              NUM: '371311',
              children: []
            },
            {
              NAME: '蒙阴县',
              NUM: '371328',
              children: []
            },
            {
              NAME: '平邑县',
              NUM: '371326',
              children: []
            },
            {
              NAME: '郯城县',
              NUM: '371322',
              children: []
            },
            {
              NAME: '沂南县',
              NUM: '371321',
              children: []
            },
            {
              NAME: '沂水县',
              NUM: '371323',
              children: []
            }
          ]
        },
        {
          NAME: '青岛',
          NUM: '3702',
          children: [
            {
              NAME: '城阳区',
              NUM: '370214',
              children: []
            },
            {
              NAME: '黄岛区',
              NUM: '370211',
              children: []
            },
            {
              NAME: '胶州市',
              NUM: '370281',
              children: []
            },
            {
              NAME: '即墨区',
              NUM: '370215',
              children: []
            },
            {
              NAME: '莱西市',
              NUM: '370285',
              children: []
            },
            {
              NAME: '崂山区',
              NUM: '370212',
              children: []
            },
            {
              NAME: '李沧区',
              NUM: '370213',
              children: []
            },
            {
              NAME: '平度市',
              NUM: '370283',
              children: []
            },
            {
              NAME: '市北区',
              NUM: '370203',
              children: []
            },
            {
              NAME: '市南区',
              NUM: '370202',
              children: []
            }
          ]
        },
        {
          NAME: '日照',
          NUM: '3711',
          children: [
            {
              NAME: '东港区',
              NUM: '371102',
              children: []
            },
            {
              NAME: '莒县',
              NUM: '371122',
              children: []
            },
            {
              NAME: '岚山区',
              NUM: '371103',
              children: []
            },
            {
              NAME: '日照经济技术开发区',
              NUM: '371171',
              children: []
            },
            {
              NAME: '五莲县',
              NUM: '371121',
              children: []
            }
          ]
        },
        {
          NAME: '泰安',
          NUM: '3709',
          children: [
            {
              NAME: '岱岳区',
              NUM: '370911',
              children: []
            },
            {
              NAME: '东平县',
              NUM: '370923',
              children: []
            },
            {
              NAME: '肥城市',
              NUM: '370983',
              children: []
            },
            {
              NAME: '宁阳县',
              NUM: '370921',
              children: []
            },
            {
              NAME: '泰山区',
              NUM: '370902',
              children: []
            },
            {
              NAME: '新泰市',
              NUM: '370982',
              children: []
            }
          ]
        },
        {
          NAME: '潍坊',
          NUM: '3707',
          children: [
            {
              NAME: '安丘市',
              NUM: '370784',
              children: []
            },
            {
              NAME: '昌乐县',
              NUM: '370725',
              children: []
            },
            {
              NAME: '昌邑市',
              NUM: '370786',
              children: []
            },
            {
              NAME: '坊子区',
              NUM: '370704',
              children: []
            },
            {
              NAME: '高密市',
              NUM: '370785',
              children: []
            },
            {
              NAME: '寒亭区',
              NUM: '370703',
              children: []
            },
            {
              NAME: '奎文区',
              NUM: '370705',
              children: []
            },
            {
              NAME: '临朐县',
              NUM: '370724',
              children: []
            },
            {
              NAME: '青州市',
              NUM: '370781',
              children: []
            },
            {
              NAME: '寿光市',
              NUM: '370783',
              children: []
            },
            {
              NAME: '潍城区',
              NUM: '370702',
              children: []
            },
            {
              NAME: '潍坊滨海经济技术开发区',
              NUM: '370772',
              children: []
            },
            {
              NAME: '诸城市',
              NUM: '370782',
              children: []
            }
          ]
        },
        {
          NAME: '威海',
          NUM: '3710',
          children: [
            {
              NAME: '环翠区',
              NUM: '371002',
              children: []
            },
            {
              NAME: '荣成市',
              NUM: '371082',
              children: []
            },
            {
              NAME: '乳山市',
              NUM: '371083',
              children: []
            },
            {
              NAME: '威海火炬高技术产业开发区',
              NUM: '371071',
              children: []
            },
            {
              NAME: '威海经济技术开发区',
              NUM: '371072',
              children: []
            },
            {
              NAME: '威海临港经济技术开发区',
              NUM: '371073',
              children: []
            },
            {
              NAME: '文登区',
              NUM: '371003',
              children: []
            }
          ]
        },
        {
          NAME: '烟台',
          NUM: '3706',
          children: [
            {
              NAME: '福山区',
              NUM: '370611',
              children: []
            },
            {
              NAME: '海阳市',
              NUM: '370687',
              children: []
            },
            {
              NAME: '莱山区',
              NUM: '370613',
              children: []
            },
            {
              NAME: '莱阳市',
              NUM: '370682',
              children: []
            },
            {
              NAME: '莱州市',
              NUM: '370683',
              children: []
            },
            {
              NAME: '龙口市',
              NUM: '370681',
              children: []
            },
            {
              NAME: '牟平区',
              NUM: '370612',
              children: []
            },
            {
              NAME: '蓬莱区',
              NUM: '370614',
              children: []
            },
            {
              NAME: '栖霞市',
              NUM: '370686',
              children: []
            },
            {
              NAME: '烟台高新技术产业开发区',
              NUM: '370671',
              children: []
            },
            {
              NAME: '烟台经济技术开发区',
              NUM: '370676',
              children: []
            },
            {
              NAME: '招远市',
              NUM: '370685',
              children: []
            },
            {
              NAME: '芝罘区',
              NUM: '370602',
              children: []
            }
          ]
        },
        {
          NAME: '枣庄',
          NUM: '3704',
          children: [
            {
              NAME: '山亭区',
              NUM: '370406',
              children: []
            },
            {
              NAME: '市中区',
              NUM: '370402',
              children: []
            },
            {
              NAME: '台儿庄区',
              NUM: '370405',
              children: []
            },
            {
              NAME: '滕州市',
              NUM: '370481',
              children: []
            },
            {
              NAME: '薛城区',
              NUM: '370403',
              children: []
            },
            {
              NAME: '峄城区',
              NUM: '370404',
              children: []
            }
          ]
        },
        {
          NAME: '淄博',
          NUM: '3703',
          children: [
            {
              NAME: '博山区',
              NUM: '370304',
              children: []
            },
            {
              NAME: '高青县',
              NUM: '370322',
              children: []
            },
            {
              NAME: '桓台县',
              NUM: '370321',
              children: []
            },
            {
              NAME: '临淄区',
              NUM: '370305',
              children: []
            },
            {
              NAME: '沂源县',
              NUM: '370323',
              children: []
            },
            {
              NAME: '张店区',
              NUM: '370303',
              children: []
            },
            {
              NAME: '周村区',
              NUM: '370306',
              children: []
            },
            {
              NAME: '淄川区',
              NUM: '370302',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '上海',
      NUM: '31',
      CODE: '',
      children: [
        {
          NAME: '上海',
          NUM: '3101',
          children: [
            {
              NAME: '宝山区',
              NUM: '310113',
              children: []
            },
            {
              NAME: '崇明区',
              NUM: '310151',
              children: []
            },
            {
              NAME: '奉贤区',
              NUM: '310120',
              children: []
            },
            {
              NAME: '虹口区',
              NUM: '310109',
              children: []
            },
            {
              NAME: '黄浦区',
              NUM: '310101',
              children: []
            },
            {
              NAME: '嘉定区',
              NUM: '310114',
              children: []
            },
            {
              NAME: '静安区',
              NUM: '310106',
              children: []
            },
            {
              NAME: '金山区',
              NUM: '310116',
              children: []
            },
            {
              NAME: '闵行区',
              NUM: '310112',
              children: []
            },
            {
              NAME: '浦东新区',
              NUM: '310115',
              children: []
            },
            {
              NAME: '普陀区',
              NUM: '310107',
              children: []
            },
            {
              NAME: '青浦区',
              NUM: '310118',
              children: []
            },
            {
              NAME: '松江区',
              NUM: '310117',
              children: []
            },
            {
              NAME: '徐汇区',
              NUM: '310104',
              children: []
            },
            {
              NAME: '杨浦区',
              NUM: '310110',
              children: []
            },
            {
              NAME: '长宁区',
              NUM: '310105',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '陕西',
      NUM: '61',
      CODE: '',
      children: [
        {
          NAME: '安康',
          NUM: '6109',
          children: [
            {
              NAME: '白河县',
              NUM: '610929',
              children: []
            },
            {
              NAME: '汉滨区',
              NUM: '610902',
              children: []
            },
            {
              NAME: '汉阴县',
              NUM: '610921',
              children: []
            },
            {
              NAME: '岚皋县',
              NUM: '610925',
              children: []
            },
            {
              NAME: '宁陕县',
              NUM: '610923',
              children: []
            },
            {
              NAME: '平利县',
              NUM: '610926',
              children: []
            },
            {
              NAME: '石泉县',
              NUM: '610922',
              children: []
            },
            {
              NAME: '旬阳市',
              NUM: '610981',
              children: []
            },
            {
              NAME: '镇坪县',
              NUM: '610927',
              children: []
            },
            {
              NAME: '紫阳县',
              NUM: '610924',
              children: []
            }
          ]
        },
        {
          NAME: '宝鸡',
          NUM: '6103',
          children: [
            {
              NAME: '陈仓区',
              NUM: '610304',
              children: []
            },
            {
              NAME: '凤县',
              NUM: '610330',
              children: []
            },
            {
              NAME: '凤翔区',
              NUM: '610305',
              children: []
            },
            {
              NAME: '扶风县',
              NUM: '610324',
              children: []
            },
            {
              NAME: '金台区',
              NUM: '610303',
              children: []
            },
            {
              NAME: '麟游县',
              NUM: '610329',
              children: []
            },
            {
              NAME: '陇县',
              NUM: '610327',
              children: []
            },
            {
              NAME: '眉县',
              NUM: '610326',
              children: []
            },
            {
              NAME: '千阳县',
              NUM: '610328',
              children: []
            },
            {
              NAME: '岐山县',
              NUM: '610323',
              children: []
            },
            {
              NAME: '太白县',
              NUM: '610331',
              children: []
            },
            {
              NAME: '渭滨区',
              NUM: '610302',
              children: []
            }
          ]
        },
        {
          NAME: '汉中',
          NUM: '6107',
          children: [
            {
              NAME: '城固县',
              NUM: '610722',
              children: []
            },
            {
              NAME: '佛坪县',
              NUM: '610730',
              children: []
            },
            {
              NAME: '汉台区',
              NUM: '610702',
              children: []
            },
            {
              NAME: '留坝县',
              NUM: '610729',
              children: []
            },
            {
              NAME: '略阳县',
              NUM: '610727',
              children: []
            },
            {
              NAME: '勉县',
              NUM: '610725',
              children: []
            },
            {
              NAME: '南郑区',
              NUM: '610703',
              children: []
            },
            {
              NAME: '宁强县',
              NUM: '610726',
              children: []
            },
            {
              NAME: '西乡县',
              NUM: '610724',
              children: []
            },
            {
              NAME: '洋县',
              NUM: '610723',
              children: []
            },
            {
              NAME: '镇巴县',
              NUM: '610728',
              children: []
            }
          ]
        },
        {
          NAME: '商洛',
          NUM: '6110',
          children: [
            {
              NAME: '丹凤县',
              NUM: '611022',
              children: []
            },
            {
              NAME: '洛南县',
              NUM: '611021',
              children: []
            },
            {
              NAME: '商南县',
              NUM: '611023',
              children: []
            },
            {
              NAME: '商州区',
              NUM: '611002',
              children: []
            },
            {
              NAME: '山阳县',
              NUM: '611024',
              children: []
            },
            {
              NAME: '柞水县',
              NUM: '611026',
              children: []
            },
            {
              NAME: '镇安县',
              NUM: '611025',
              children: []
            }
          ]
        },
        {
          NAME: '铜川',
          NUM: '6102',
          children: [
            {
              NAME: '王益区',
              NUM: '610202',
              children: []
            },
            {
              NAME: '耀州区',
              NUM: '610204',
              children: []
            },
            {
              NAME: '宜君县',
              NUM: '610222',
              children: []
            },
            {
              NAME: '印台区',
              NUM: '610203',
              children: []
            }
          ]
        },
        {
          NAME: '渭南',
          NUM: '6105',
          children: [
            {
              NAME: '白水县',
              NUM: '610527',
              children: []
            },
            {
              NAME: '澄城县',
              NUM: '610525',
              children: []
            },
            {
              NAME: '大荔县',
              NUM: '610523',
              children: []
            },
            {
              NAME: '富平县',
              NUM: '610528',
              children: []
            },
            {
              NAME: '韩城市',
              NUM: '610581',
              children: []
            },
            {
              NAME: '合阳县',
              NUM: '610524',
              children: []
            },
            {
              NAME: '华阴市',
              NUM: '610582',
              children: []
            },
            {
              NAME: '华州区',
              NUM: '610503',
              children: []
            },
            {
              NAME: '临渭区',
              NUM: '610502',
              children: []
            },
            {
              NAME: '蒲城县',
              NUM: '610526',
              children: []
            },
            {
              NAME: '潼关县',
              NUM: '610522',
              children: []
            }
          ]
        },
        {
          NAME: '西安',
          NUM: '6101',
          children: [
            {
              NAME: '灞桥区',
              NUM: '610111',
              children: []
            },
            {
              NAME: '碑林区',
              NUM: '610103',
              children: []
            },
            {
              NAME: '长安区',
              NUM: '610116',
              children: []
            },
            {
              NAME: '高陵区',
              NUM: '610117',
              children: []
            },
            {
              NAME: '鄠邑区',
              NUM: '610118',
              children: []
            },
            {
              NAME: '蓝田县',
              NUM: '610122',
              children: []
            },
            {
              NAME: '莲湖区',
              NUM: '610104',
              children: []
            },
            {
              NAME: '临潼区',
              NUM: '610115',
              children: []
            },
            {
              NAME: '未央区',
              NUM: '610112',
              children: []
            },
            {
              NAME: '新城区',
              NUM: '610102',
              children: []
            },
            {
              NAME: '阎良区',
              NUM: '610114',
              children: []
            },
            {
              NAME: '雁塔区',
              NUM: '610113',
              children: []
            },
            {
              NAME: '周至县',
              NUM: '610124',
              children: []
            }
          ]
        },
        {
          NAME: '咸阳',
          NUM: '6104',
          children: [
            {
              NAME: '彬州市',
              NUM: '610482',
              children: []
            },
            {
              NAME: '淳化县',
              NUM: '610430',
              children: []
            },
            {
              NAME: '泾阳县',
              NUM: '610423',
              children: []
            },
            {
              NAME: '礼泉县',
              NUM: '610425',
              children: []
            },
            {
              NAME: '乾县',
              NUM: '610424',
              children: []
            },
            {
              NAME: '秦都区',
              NUM: '610402',
              children: []
            },
            {
              NAME: '三原县',
              NUM: '610422',
              children: []
            },
            {
              NAME: '渭城区',
              NUM: '610404',
              children: []
            },
            {
              NAME: '武功县',
              NUM: '610431',
              children: []
            },
            {
              NAME: '兴平市',
              NUM: '610481',
              children: []
            },
            {
              NAME: '旬邑县',
              NUM: '610429',
              children: []
            },
            {
              NAME: '杨陵区',
              NUM: '610403',
              children: []
            },
            {
              NAME: '永寿县',
              NUM: '610426',
              children: []
            },
            {
              NAME: '长武县',
              NUM: '610428',
              children: []
            }
          ]
        },
        {
          NAME: '西咸新区',
          NUM: '6111',
          children: [
            {
              NAME: '沣东新城',
              NUM: '611105',
              children: []
            },
            {
              NAME: '沣西新城',
              NUM: '611104',
              children: []
            },
            {
              NAME: '泾河新城',
              NUM: '611102',
              children: []
            },
            {
              NAME: '空港新城',
              NUM: '611101',
              children: []
            },
            {
              NAME: '秦汉新城',
              NUM: '611103',
              children: []
            }
          ]
        },
        {
          NAME: '延安',
          NUM: '6106',
          children: [
            {
              NAME: '安塞区',
              NUM: '610603',
              children: []
            },
            {
              NAME: '宝塔区',
              NUM: '610602',
              children: []
            },
            {
              NAME: '富县',
              NUM: '610628',
              children: []
            },
            {
              NAME: '甘泉县',
              NUM: '610627',
              children: []
            },
            {
              NAME: '黄陵县',
              NUM: '610632',
              children: []
            },
            {
              NAME: '黄龙县',
              NUM: '610631',
              children: []
            },
            {
              NAME: '洛川县',
              NUM: '610629',
              children: []
            },
            {
              NAME: '吴起县',
              NUM: '610626',
              children: []
            },
            {
              NAME: '延长县',
              NUM: '610621',
              children: []
            },
            {
              NAME: '延川县',
              NUM: '610622',
              children: []
            },
            {
              NAME: '宜川县',
              NUM: '610630',
              children: []
            },
            {
              NAME: '志丹县',
              NUM: '610625',
              children: []
            },
            {
              NAME: '子长市',
              NUM: '610681',
              children: []
            }
          ]
        },
        {
          NAME: '榆林',
          NUM: '6108',
          children: [
            {
              NAME: '定边县',
              NUM: '610825',
              children: []
            },
            {
              NAME: '府谷县',
              NUM: '610822',
              children: []
            },
            {
              NAME: '横山区',
              NUM: '610803',
              children: []
            },
            {
              NAME: '佳县',
              NUM: '610828',
              children: []
            },
            {
              NAME: '靖边县',
              NUM: '610824',
              children: []
            },
            {
              NAME: '米脂县',
              NUM: '610827',
              children: []
            },
            {
              NAME: '清涧县',
              NUM: '610830',
              children: []
            },
            {
              NAME: '神木市',
              NUM: '610881',
              children: []
            },
            {
              NAME: '绥德县',
              NUM: '610826',
              children: []
            },
            {
              NAME: '吴堡县',
              NUM: '610829',
              children: []
            },
            {
              NAME: '榆阳区',
              NUM: '610802',
              children: []
            },
            {
              NAME: '子洲县',
              NUM: '610831',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '山西',
      NUM: '14',
      CODE: '',
      children: [
        {
          NAME: '大同',
          NUM: '1402',
          children: [
            {
              NAME: '广灵县',
              NUM: '140223',
              children: []
            },
            {
              NAME: '浑源县',
              NUM: '140225',
              children: []
            },
            {
              NAME: '灵丘县',
              NUM: '140224',
              children: []
            },
            {
              NAME: '平城区',
              NUM: '140213',
              children: []
            },
            {
              NAME: '山西大同经济开发区',
              NUM: '140271',
              children: []
            },
            {
              NAME: '天镇县',
              NUM: '140222',
              children: []
            },
            {
              NAME: '新荣区',
              NUM: '140212',
              children: []
            },
            {
              NAME: '阳高县',
              NUM: '140221',
              children: []
            },
            {
              NAME: '云冈区',
              NUM: '140214',
              children: []
            },
            {
              NAME: '云州区',
              NUM: '140215',
              children: []
            },
            {
              NAME: '左云县',
              NUM: '140226',
              children: []
            }
          ]
        },
        {
          NAME: '晋城',
          NUM: '1405',
          children: [
            {
              NAME: '城区',
              NUM: '140502',
              children: []
            },
            {
              NAME: '高平市',
              NUM: '140581',
              children: []
            },
            {
              NAME: '陵川县',
              NUM: '140524',
              children: []
            },
            {
              NAME: '沁水县',
              NUM: '140521',
              children: []
            },
            {
              NAME: '阳城县',
              NUM: '140522',
              children: []
            },
            {
              NAME: '泽州县',
              NUM: '140525',
              children: []
            }
          ]
        },
        {
          NAME: '晋中',
          NUM: '1407',
          children: [
            {
              NAME: '和顺县',
              NUM: '140723',
              children: []
            },
            {
              NAME: '介休市',
              NUM: '140781',
              children: []
            },
            {
              NAME: '灵石县',
              NUM: '140729',
              children: []
            },
            {
              NAME: '平遥县',
              NUM: '140728',
              children: []
            },
            {
              NAME: '祁县',
              NUM: '140727',
              children: []
            },
            {
              NAME: '寿阳县',
              NUM: '140725',
              children: []
            },
            {
              NAME: '太谷区',
              NUM: '140703',
              children: []
            },
            {
              NAME: '昔阳县',
              NUM: '140724',
              children: []
            },
            {
              NAME: '榆次区',
              NUM: '140702',
              children: []
            },
            {
              NAME: '榆社县',
              NUM: '140721',
              children: []
            },
            {
              NAME: '左权县',
              NUM: '140722',
              children: []
            }
          ]
        },
        {
          NAME: '临汾',
          NUM: '1410',
          children: [
            {
              NAME: '安泽县',
              NUM: '141026',
              children: []
            },
            {
              NAME: '大宁县',
              NUM: '141030',
              children: []
            },
            {
              NAME: '汾西县',
              NUM: '141034',
              children: []
            },
            {
              NAME: '浮山县',
              NUM: '141027',
              children: []
            },
            {
              NAME: '古县',
              NUM: '141025',
              children: []
            },
            {
              NAME: '洪洞县',
              NUM: '141024',
              children: []
            },
            {
              NAME: '侯马市',
              NUM: '141081',
              children: []
            },
            {
              NAME: '霍州市',
              NUM: '141082',
              children: []
            },
            {
              NAME: '吉县',
              NUM: '141028',
              children: []
            },
            {
              NAME: '蒲县',
              NUM: '141033',
              children: []
            },
            {
              NAME: '曲沃县',
              NUM: '141021',
              children: []
            },
            {
              NAME: '襄汾县',
              NUM: '141023',
              children: []
            },
            {
              NAME: '乡宁县',
              NUM: '141029',
              children: []
            },
            {
              NAME: '隰县',
              NUM: '141031',
              children: []
            },
            {
              NAME: '尧都区',
              NUM: '141002',
              children: []
            },
            {
              NAME: '翼城县',
              NUM: '141022',
              children: []
            },
            {
              NAME: '永和县',
              NUM: '141032',
              children: []
            }
          ]
        },
        {
          NAME: '吕梁',
          NUM: '1411',
          children: [
            {
              NAME: '方山县',
              NUM: '141128',
              children: []
            },
            {
              NAME: '汾阳市',
              NUM: '141182',
              children: []
            },
            {
              NAME: '交城县',
              NUM: '141122',
              children: []
            },
            {
              NAME: '交口县',
              NUM: '141130',
              children: []
            },
            {
              NAME: '岚县',
              NUM: '141127',
              children: []
            },
            {
              NAME: '临县',
              NUM: '141124',
              children: []
            },
            {
              NAME: '离石区',
              NUM: '141102',
              children: []
            },
            {
              NAME: '柳林县',
              NUM: '141125',
              children: []
            },
            {
              NAME: '石楼县',
              NUM: '141126',
              children: []
            },
            {
              NAME: '文水县',
              NUM: '141121',
              children: []
            },
            {
              NAME: '孝义市',
              NUM: '141181',
              children: []
            },
            {
              NAME: '兴县',
              NUM: '141123',
              children: []
            },
            {
              NAME: '中阳县',
              NUM: '141129',
              children: []
            }
          ]
        },
        {
          NAME: '朔州',
          NUM: '1406',
          children: [
            {
              NAME: '怀仁市',
              NUM: '140681',
              children: []
            },
            {
              NAME: '平鲁区',
              NUM: '140603',
              children: []
            },
            {
              NAME: '山西朔州经济开发区',
              NUM: '140671',
              children: []
            },
            {
              NAME: '山阴县',
              NUM: '140621',
              children: []
            },
            {
              NAME: '朔城区',
              NUM: '140602',
              children: []
            },
            {
              NAME: '应县',
              NUM: '140622',
              children: []
            },
            {
              NAME: '右玉县',
              NUM: '140623',
              children: []
            }
          ]
        },
        {
          NAME: '太原',
          NUM: '1401',
          children: [
            {
              NAME: '古交市',
              NUM: '140181',
              children: []
            },
            {
              NAME: '尖草坪区',
              NUM: '140108',
              children: []
            },
            {
              NAME: '晋源区',
              NUM: '140110',
              children: []
            },
            {
              NAME: '娄烦县',
              NUM: '140123',
              children: []
            },
            {
              NAME: '清徐县',
              NUM: '140121',
              children: []
            },
            {
              NAME: '山西转型综合改革示范区',
              NUM: '140171',
              children: []
            },
            {
              NAME: '万柏林区',
              NUM: '140109',
              children: []
            },
            {
              NAME: '小店区',
              NUM: '140105',
              children: []
            },
            {
              NAME: '杏花岭区',
              NUM: '140107',
              children: []
            },
            {
              NAME: '阳曲县',
              NUM: '140122',
              children: []
            },
            {
              NAME: '迎泽区',
              NUM: '140106',
              children: []
            }
          ]
        },
        {
          NAME: '忻州',
          NUM: '1409',
          children: [
            {
              NAME: '保德县',
              NUM: '140931',
              children: []
            },
            {
              NAME: '代县',
              NUM: '140923',
              children: []
            },
            {
              NAME: '定襄县',
              NUM: '140921',
              children: []
            },
            {
              NAME: '繁峙县',
              NUM: '140924',
              children: []
            },
            {
              NAME: '河曲县',
              NUM: '140930',
              children: []
            },
            {
              NAME: '静乐县',
              NUM: '140926',
              children: []
            },
            {
              NAME: '岢岚县',
              NUM: '140929',
              children: []
            },
            {
              NAME: '宁武县',
              NUM: '140925',
              children: []
            },
            {
              NAME: '偏关县',
              NUM: '140932',
              children: []
            },
            {
              NAME: '神池县',
              NUM: '140927',
              children: []
            },
            {
              NAME: '五台山风景名胜区',
              NUM: '140971',
              children: []
            },
            {
              NAME: '五台县',
              NUM: '140922',
              children: []
            },
            {
              NAME: '五寨县',
              NUM: '140928',
              children: []
            },
            {
              NAME: '忻府区',
              NUM: '140902',
              children: []
            },
            {
              NAME: '原平市',
              NUM: '140981',
              children: []
            }
          ]
        },
        {
          NAME: '阳泉',
          NUM: '1403',
          children: [
            {
              NAME: '城区',
              NUM: '140302',
              children: []
            },
            {
              NAME: '郊区',
              NUM: '140311',
              children: []
            },
            {
              NAME: '矿区',
              NUM: '140303',
              children: []
            },
            {
              NAME: '平定县',
              NUM: '140321',
              children: []
            },
            {
              NAME: '盂县',
              NUM: '140322',
              children: []
            }
          ]
        },
        {
          NAME: '运城',
          NUM: '1408',
          children: [
            {
              NAME: '河津市',
              NUM: '140882',
              children: []
            },
            {
              NAME: '绛县',
              NUM: '140826',
              children: []
            },
            {
              NAME: '稷山县',
              NUM: '140824',
              children: []
            },
            {
              NAME: '临猗县',
              NUM: '140821',
              children: []
            },
            {
              NAME: '平陆县',
              NUM: '140829',
              children: []
            },
            {
              NAME: '芮城县',
              NUM: '140830',
              children: []
            },
            {
              NAME: '万荣县',
              NUM: '140822',
              children: []
            },
            {
              NAME: '闻喜县',
              NUM: '140823',
              children: []
            },
            {
              NAME: '夏县',
              NUM: '140828',
              children: []
            },
            {
              NAME: '新绛县',
              NUM: '140825',
              children: []
            },
            {
              NAME: '盐湖区',
              NUM: '140802',
              children: []
            },
            {
              NAME: '永济市',
              NUM: '140881',
              children: []
            },
            {
              NAME: '垣曲县',
              NUM: '140827',
              children: []
            }
          ]
        },
        {
          NAME: '长治',
          NUM: '1404',
          children: [
            {
              NAME: '壶关县',
              NUM: '140427',
              children: []
            },
            {
              NAME: '黎城县',
              NUM: '140426',
              children: []
            },
            {
              NAME: '潞城区',
              NUM: '140406',
              children: []
            },
            {
              NAME: '潞州区',
              NUM: '140403',
              children: []
            },
            {
              NAME: '平顺县',
              NUM: '140425',
              children: []
            },
            {
              NAME: '沁县',
              NUM: '140430',
              children: []
            },
            {
              NAME: '沁源县',
              NUM: '140431',
              children: []
            },
            {
              NAME: '上党区',
              NUM: '140404',
              children: []
            },
            {
              NAME: '屯留区',
              NUM: '140405',
              children: []
            },
            {
              NAME: '武乡县',
              NUM: '140429',
              children: []
            },
            {
              NAME: '襄垣县',
              NUM: '140423',
              children: []
            },
            {
              NAME: '长子县',
              NUM: '140428',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '四川',
      NUM: '51',
      CODE: '',
      children: [
        {
          NAME: '阿坝藏族羌族自治州',
          NUM: '5132',
          children: [
            {
              NAME: '阿坝县',
              NUM: '513231',
              children: []
            },
            {
              NAME: '黑水县',
              NUM: '513228',
              children: []
            },
            {
              NAME: '红原县',
              NUM: '513233',
              children: []
            },
            {
              NAME: '金川县',
              NUM: '513226',
              children: []
            },
            {
              NAME: '九寨沟县',
              NUM: '513225',
              children: []
            },
            {
              NAME: '理县',
              NUM: '513222',
              children: []
            },
            {
              NAME: '马尔康市',
              NUM: '513201',
              children: []
            },
            {
              NAME: '茂县',
              NUM: '513223',
              children: []
            },
            {
              NAME: '壤塘县',
              NUM: '513230',
              children: []
            },
            {
              NAME: '若尔盖县',
              NUM: '513232',
              children: []
            },
            {
              NAME: '松潘县',
              NUM: '513224',
              children: []
            },
            {
              NAME: '汶川县',
              NUM: '513221',
              children: []
            },
            {
              NAME: '小金县',
              NUM: '513227',
              children: []
            }
          ]
        },
        {
          NAME: '巴中',
          NUM: '5119',
          children: [
            {
              NAME: '巴州区',
              NUM: '511902',
              children: []
            },
            {
              NAME: '恩阳区',
              NUM: '511903',
              children: []
            },
            {
              NAME: '南江县',
              NUM: '511922',
              children: []
            },
            {
              NAME: '平昌县',
              NUM: '511923',
              children: []
            },
            {
              NAME: '通江县',
              NUM: '511921',
              children: []
            }
          ]
        },
        {
          NAME: '成都',
          NUM: '5101',
          children: [
            {
              NAME: '成华区',
              NUM: '510108',
              children: []
            },
            {
              NAME: '崇州市',
              NUM: '510184',
              children: []
            },
            {
              NAME: '大邑县',
              NUM: '510129',
              children: []
            },
            {
              NAME: '都江堰市',
              NUM: '510181',
              children: []
            },
            {
              NAME: '简阳市',
              NUM: '510185',
              children: []
            },
            {
              NAME: '锦江区',
              NUM: '510104',
              children: []
            },
            {
              NAME: '金牛区',
              NUM: '510106',
              children: []
            },
            {
              NAME: '金堂县',
              NUM: '510121',
              children: []
            },
            {
              NAME: '龙泉驿区',
              NUM: '510112',
              children: []
            },
            {
              NAME: '彭州市',
              NUM: '510182',
              children: []
            },
            {
              NAME: '郫都区',
              NUM: '510117',
              children: []
            },
            {
              NAME: '蒲江县',
              NUM: '510131',
              children: []
            },
            {
              NAME: '青白江区',
              NUM: '510113',
              children: []
            },
            {
              NAME: '青羊区',
              NUM: '510105',
              children: []
            },
            {
              NAME: '邛崃市',
              NUM: '510183',
              children: []
            },
            {
              NAME: '双流区',
              NUM: '510116',
              children: []
            },
            {
              NAME: '温江区',
              NUM: '510115',
              children: []
            },
            {
              NAME: '武侯区',
              NUM: '510107',
              children: []
            },
            {
              NAME: '新都区',
              NUM: '510114',
              children: []
            },
            {
              NAME: '新津区',
              NUM: '510118',
              children: []
            }
          ]
        },
        {
          NAME: '达州',
          NUM: '5117',
          children: [
            {
              NAME: '达川区',
              NUM: '511703',
              children: []
            },
            {
              NAME: '大竹县',
              NUM: '511724',
              children: []
            },
            {
              NAME: '开江县',
              NUM: '511723',
              children: []
            },
            {
              NAME: '渠县',
              NUM: '511725',
              children: []
            },
            {
              NAME: '通川区',
              NUM: '511702',
              children: []
            },
            {
              NAME: '万源市',
              NUM: '511781',
              children: []
            },
            {
              NAME: '宣汉县',
              NUM: '511722',
              children: []
            }
          ]
        },
        {
          NAME: '德阳',
          NUM: '5106',
          children: [
            {
              NAME: '广汉市',
              NUM: '510681',
              children: []
            },
            {
              NAME: '旌阳区',
              NUM: '510603',
              children: []
            },
            {
              NAME: '罗江区',
              NUM: '510604',
              children: []
            },
            {
              NAME: '绵竹市',
              NUM: '510683',
              children: []
            },
            {
              NAME: '什邡市',
              NUM: '510682',
              children: []
            },
            {
              NAME: '中江县',
              NUM: '510623',
              children: []
            }
          ]
        },
        {
          NAME: '甘孜藏族自治州',
          NUM: '5133',
          children: [
            {
              NAME: '白玉县',
              NUM: '513331',
              children: []
            },
            {
              NAME: '巴塘县',
              NUM: '513335',
              children: []
            },
            {
              NAME: '丹巴县',
              NUM: '513323',
              children: []
            },
            {
              NAME: '稻城县',
              NUM: '513337',
              children: []
            },
            {
              NAME: '道孚县',
              NUM: '513326',
              children: []
            },
            {
              NAME: '德格县',
              NUM: '513330',
              children: []
            },
            {
              NAME: '得荣县',
              NUM: '513338',
              children: []
            },
            {
              NAME: '甘孜县',
              NUM: '513328',
              children: []
            },
            {
              NAME: '九龙县',
              NUM: '513324',
              children: []
            },
            {
              NAME: '康定市',
              NUM: '513301',
              children: []
            },
            {
              NAME: '理塘县',
              NUM: '513334',
              children: []
            },
            {
              NAME: '泸定县',
              NUM: '513322',
              children: []
            },
            {
              NAME: '炉霍县',
              NUM: '513327',
              children: []
            },
            {
              NAME: '色达县',
              NUM: '513333',
              children: []
            },
            {
              NAME: '石渠县',
              NUM: '513332',
              children: []
            },
            {
              NAME: '乡城县',
              NUM: '513336',
              children: []
            },
            {
              NAME: '新龙县',
              NUM: '513329',
              children: []
            },
            {
              NAME: '雅江县',
              NUM: '513325',
              children: []
            }
          ]
        },
        {
          NAME: '广安',
          NUM: '5116',
          children: [
            {
              NAME: '广安区',
              NUM: '511602',
              children: []
            },
            {
              NAME: '华蓥市',
              NUM: '511681',
              children: []
            },
            {
              NAME: '邻水县',
              NUM: '511623',
              children: []
            },
            {
              NAME: '前锋区',
              NUM: '511603',
              children: []
            },
            {
              NAME: '武胜县',
              NUM: '511622',
              children: []
            },
            {
              NAME: '岳池县',
              NUM: '511621',
              children: []
            }
          ]
        },
        {
          NAME: '广元',
          NUM: '5108',
          children: [
            {
              NAME: '苍溪县',
              NUM: '510824',
              children: []
            },
            {
              NAME: '朝天区',
              NUM: '510812',
              children: []
            },
            {
              NAME: '剑阁县',
              NUM: '510823',
              children: []
            },
            {
              NAME: '利州区',
              NUM: '510802',
              children: []
            },
            {
              NAME: '青川县',
              NUM: '510822',
              children: []
            },
            {
              NAME: '旺苍县',
              NUM: '510821',
              children: []
            },
            {
              NAME: '昭化区',
              NUM: '510811',
              children: []
            }
          ]
        },
        {
          NAME: '乐山',
          NUM: '5111',
          children: [
            {
              NAME: '峨边彝族自治县',
              NUM: '511132',
              children: []
            },
            {
              NAME: '峨眉山市',
              NUM: '511181',
              children: []
            },
            {
              NAME: '夹江县',
              NUM: '511126',
              children: []
            },
            {
              NAME: '井研县',
              NUM: '511124',
              children: []
            },
            {
              NAME: '金口河区',
              NUM: '511113',
              children: []
            },
            {
              NAME: '马边彝族自治县',
              NUM: '511133',
              children: []
            },
            {
              NAME: '沐川县',
              NUM: '511129',
              children: []
            },
            {
              NAME: '犍为县',
              NUM: '511123',
              children: []
            },
            {
              NAME: '沙湾区',
              NUM: '511111',
              children: []
            },
            {
              NAME: '市中区',
              NUM: '511102',
              children: []
            },
            {
              NAME: '五通桥区',
              NUM: '511112',
              children: []
            }
          ]
        },
        {
          NAME: '凉山彝族自治州',
          NUM: '5134',
          children: [
            {
              NAME: '布拖县',
              NUM: '513429',
              children: []
            },
            {
              NAME: '德昌县',
              NUM: '513424',
              children: []
            },
            {
              NAME: '甘洛县',
              NUM: '513435',
              children: []
            },
            {
              NAME: '会东县',
              NUM: '513426',
              children: []
            },
            {
              NAME: '会理市',
              NUM: '513402',
              children: []
            },
            {
              NAME: '金阳县',
              NUM: '513430',
              children: []
            },
            {
              NAME: '雷波县',
              NUM: '513437',
              children: []
            },
            {
              NAME: '美姑县',
              NUM: '513436',
              children: []
            },
            {
              NAME: '冕宁县',
              NUM: '513433',
              children: []
            },
            {
              NAME: '木里藏族自治县',
              NUM: '513422',
              children: []
            },
            {
              NAME: '宁南县',
              NUM: '513427',
              children: []
            },
            {
              NAME: '普格县',
              NUM: '513428',
              children: []
            },
            {
              NAME: '西昌市',
              NUM: '513401',
              children: []
            },
            {
              NAME: '喜德县',
              NUM: '513432',
              children: []
            },
            {
              NAME: '盐源县',
              NUM: '513423',
              children: []
            },
            {
              NAME: '越西县',
              NUM: '513434',
              children: []
            },
            {
              NAME: '昭觉县',
              NUM: '513431',
              children: []
            }
          ]
        },
        {
          NAME: '泸州',
          NUM: '5105',
          children: [
            {
              NAME: '古蔺县',
              NUM: '510525',
              children: []
            },
            {
              NAME: '合江县',
              NUM: '510522',
              children: []
            },
            {
              NAME: '江阳区',
              NUM: '510502',
              children: []
            },
            {
              NAME: '龙马潭区',
              NUM: '510504',
              children: []
            },
            {
              NAME: '泸县',
              NUM: '510521',
              children: []
            },
            {
              NAME: '纳溪区',
              NUM: '510503',
              children: []
            },
            {
              NAME: '叙永县',
              NUM: '510524',
              children: []
            }
          ]
        },
        {
          NAME: '眉山',
          NUM: '5114',
          children: [
            {
              NAME: '丹棱县',
              NUM: '511424',
              children: []
            },
            {
              NAME: '东坡区',
              NUM: '511402',
              children: []
            },
            {
              NAME: '洪雅县',
              NUM: '511423',
              children: []
            },
            {
              NAME: '彭山区',
              NUM: '511403',
              children: []
            },
            {
              NAME: '青神县',
              NUM: '511425',
              children: []
            },
            {
              NAME: '仁寿县',
              NUM: '511421',
              children: []
            }
          ]
        },
        {
          NAME: '绵阳',
          NUM: '5107',
          children: [
            {
              NAME: '安州区',
              NUM: '510705',
              children: []
            },
            {
              NAME: '北川羌族自治县',
              NUM: '510726',
              children: []
            },
            {
              NAME: '涪城区',
              NUM: '510703',
              children: []
            },
            {
              NAME: '江油市',
              NUM: '510781',
              children: []
            },
            {
              NAME: '平武县',
              NUM: '510727',
              children: []
            },
            {
              NAME: '三台县',
              NUM: '510722',
              children: []
            },
            {
              NAME: '盐亭县',
              NUM: '510723',
              children: []
            },
            {
              NAME: '游仙区',
              NUM: '510704',
              children: []
            },
            {
              NAME: '梓潼县',
              NUM: '510725',
              children: []
            }
          ]
        },
        {
          NAME: '南充',
          NUM: '5113',
          children: [
            {
              NAME: '高坪区',
              NUM: '511303',
              children: []
            },
            {
              NAME: '嘉陵区',
              NUM: '511304',
              children: []
            },
            {
              NAME: '阆中市',
              NUM: '511381',
              children: []
            },
            {
              NAME: '南部县',
              NUM: '511321',
              children: []
            },
            {
              NAME: '蓬安县',
              NUM: '511323',
              children: []
            },
            {
              NAME: '顺庆区',
              NUM: '511302',
              children: []
            },
            {
              NAME: '西充县',
              NUM: '511325',
              children: []
            },
            {
              NAME: '仪陇县',
              NUM: '511324',
              children: []
            },
            {
              NAME: '营山县',
              NUM: '511322',
              children: []
            }
          ]
        },
        {
          NAME: '内江',
          NUM: '5110',
          children: [
            {
              NAME: '东兴区',
              NUM: '511011',
              children: []
            },
            {
              NAME: '隆昌市',
              NUM: '511083',
              children: []
            },
            {
              NAME: '市中区',
              NUM: '511002',
              children: []
            },
            {
              NAME: '威远县',
              NUM: '511024',
              children: []
            },
            {
              NAME: '资中县',
              NUM: '511025',
              children: []
            }
          ]
        },
        {
          NAME: '攀枝花',
          NUM: '5104',
          children: [
            {
              NAME: '东区',
              NUM: '510402',
              children: []
            },
            {
              NAME: '米易县',
              NUM: '510421',
              children: []
            },
            {
              NAME: '仁和区',
              NUM: '510411',
              children: []
            },
            {
              NAME: '西区',
              NUM: '510403',
              children: []
            },
            {
              NAME: '盐边县',
              NUM: '510422',
              children: []
            }
          ]
        },
        {
          NAME: '遂宁',
          NUM: '5109',
          children: [
            {
              NAME: '安居区',
              NUM: '510904',
              children: []
            },
            {
              NAME: '船山区',
              NUM: '510903',
              children: []
            },
            {
              NAME: '大英县',
              NUM: '510923',
              children: []
            },
            {
              NAME: '蓬溪县',
              NUM: '510921',
              children: []
            },
            {
              NAME: '射洪市',
              NUM: '510981',
              children: []
            }
          ]
        },
        {
          NAME: '雅安',
          NUM: '5118',
          children: [
            {
              NAME: '宝兴县',
              NUM: '511827',
              children: []
            },
            {
              NAME: '汉源县',
              NUM: '511823',
              children: []
            },
            {
              NAME: '芦山县',
              NUM: '511826',
              children: []
            },
            {
              NAME: '名山区',
              NUM: '511803',
              children: []
            },
            {
              NAME: '石棉县',
              NUM: '511824',
              children: []
            },
            {
              NAME: '天全县',
              NUM: '511825',
              children: []
            },
            {
              NAME: '荥经县',
              NUM: '511822',
              children: []
            },
            {
              NAME: '雨城区',
              NUM: '511802',
              children: []
            }
          ]
        },
        {
          NAME: '宜宾',
          NUM: '5115',
          children: [
            {
              NAME: '翠屏区',
              NUM: '511502',
              children: []
            },
            {
              NAME: '高县',
              NUM: '511525',
              children: []
            },
            {
              NAME: '珙县',
              NUM: '511526',
              children: []
            },
            {
              NAME: '江安县',
              NUM: '511523',
              children: []
            },
            {
              NAME: '南溪区',
              NUM: '511503',
              children: []
            },
            {
              NAME: '屏山县',
              NUM: '511529',
              children: []
            },
            {
              NAME: '兴文县',
              NUM: '511528',
              children: []
            },
            {
              NAME: '叙州区',
              NUM: '511504',
              children: []
            },
            {
              NAME: '筠连县',
              NUM: '511527',
              children: []
            },
            {
              NAME: '长宁县',
              NUM: '511524',
              children: []
            }
          ]
        },
        {
          NAME: '自贡',
          NUM: '5103',
          children: [
            {
              NAME: '大安区',
              NUM: '510304',
              children: []
            },
            {
              NAME: '富顺县',
              NUM: '510322',
              children: []
            },
            {
              NAME: '贡井区',
              NUM: '510303',
              children: []
            },
            {
              NAME: '荣县',
              NUM: '510321',
              children: []
            },
            {
              NAME: '沿滩区',
              NUM: '510311',
              children: []
            },
            {
              NAME: '自流井区',
              NUM: '510302',
              children: []
            }
          ]
        },
        {
          NAME: '资阳',
          NUM: '5120',
          children: [
            {
              NAME: '安岳县',
              NUM: '512021',
              children: []
            },
            {
              NAME: '乐至县',
              NUM: '512022',
              children: []
            },
            {
              NAME: '雁江区',
              NUM: '512002',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '天津',
      NUM: '12',
      CODE: 'T',
      children: [
        {
          NAME: '天津',
          NUM: '1201',
          children: [
            {
              NAME: '宝坻区',
              NUM: '120115',
              children: []
            },
            {
              NAME: '北辰区',
              NUM: '120113',
              children: []
            },
            {
              NAME: '滨海新区',
              NUM: '120116',
              children: []
            },
            {
              NAME: '东丽区',
              NUM: '120110',
              children: []
            },
            {
              NAME: '河北区',
              NUM: '120105',
              children: []
            },
            {
              NAME: '河东区',
              NUM: '120102',
              children: []
            },
            {
              NAME: '和平区',
              NUM: '120101',
              children: []
            },
            {
              NAME: '河西区',
              NUM: '120103',
              children: []
            },
            {
              NAME: '红桥区',
              NUM: '120106',
              children: []
            },
            {
              NAME: '静海区',
              NUM: '120118',
              children: []
            },
            {
              NAME: '津南区',
              NUM: '120112',
              children: []
            },
            {
              NAME: '蓟州区',
              NUM: '120119',
              children: []
            },
            {
              NAME: '南开区',
              NUM: '120104',
              children: []
            },
            {
              NAME: '宁河区',
              NUM: '120117',
              children: []
            },
            {
              NAME: '武清区',
              NUM: '120114',
              children: []
            },
            {
              NAME: '西青区',
              NUM: '120111',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '新疆',
      NUM: '65',
      CODE: 'X',
      children: [
        {
          NAME: '阿克苏地区',
          NUM: '6529',
          children: [
            {
              NAME: '阿克苏市',
              NUM: '652901',
              children: []
            },
            {
              NAME: '阿瓦提县',
              NUM: '652928',
              children: []
            },
            {
              NAME: '拜城县',
              NUM: '652926',
              children: []
            },
            {
              NAME: '柯坪县',
              NUM: '652929',
              children: []
            },
            {
              NAME: '库车市',
              NUM: '652902',
              children: []
            },
            {
              NAME: '沙雅县',
              NUM: '652924',
              children: []
            },
            {
              NAME: '温宿县',
              NUM: '652922',
              children: []
            },
            {
              NAME: '乌什县',
              NUM: '652927',
              children: []
            },
            {
              NAME: '新和县',
              NUM: '652925',
              children: []
            }
          ]
        },
        {
          NAME: '阿拉尔',
          NUM: '659002',
          children: []
        },
        {
          NAME: '阿勒泰地区',
          NUM: '6543',
          children: [
            {
              NAME: '阿勒泰市',
              NUM: '654301',
              children: []
            },
            {
              NAME: '布尔津县',
              NUM: '654321',
              children: []
            },
            {
              NAME: '福海县',
              NUM: '654323',
              children: []
            },
            {
              NAME: '富蕴县',
              NUM: '654322',
              children: []
            },
            {
              NAME: '哈巴河县',
              NUM: '654324',
              children: []
            },
            {
              NAME: '吉木乃县',
              NUM: '654326',
              children: []
            },
            {
              NAME: '青河县',
              NUM: '654325',
              children: []
            }
          ]
        },
        {
          NAME: '白杨市',
          NUM: '659012',
          children: []
        },
        {
          NAME: '巴音郭楞蒙古自治州',
          NUM: '6528',
          children: [
            {
              NAME: '博湖县',
              NUM: '652829',
              children: []
            },
            {
              NAME: '和静县',
              NUM: '652827',
              children: []
            },
            {
              NAME: '和硕县',
              NUM: '652828',
              children: []
            },
            {
              NAME: '库尔勒市',
              NUM: '652801',
              children: []
            },
            {
              NAME: '轮台县',
              NUM: '652822',
              children: []
            },
            {
              NAME: '且末县',
              NUM: '652825',
              children: []
            },
            {
              NAME: '若羌县',
              NUM: '652824',
              children: []
            },
            {
              NAME: '焉耆回族自治县',
              NUM: '652826',
              children: []
            },
            {
              NAME: '尉犁县',
              NUM: '652823',
              children: []
            }
          ]
        },
        {
          NAME: '北屯',
          NUM: '659005',
          children: []
        },
        {
          NAME: '博尔塔拉蒙古自治州',
          NUM: '6527',
          children: [
            {
              NAME: '阿拉山口市',
              NUM: '652702',
              children: []
            },
            {
              NAME: '博乐市',
              NUM: '652701',
              children: []
            },
            {
              NAME: '精河县',
              NUM: '652722',
              children: []
            },
            {
              NAME: '温泉县',
              NUM: '652723',
              children: []
            }
          ]
        },
        {
          NAME: '昌吉回族自治州',
          NUM: '6523',
          children: [
            {
              NAME: '昌吉市',
              NUM: '652301',
              children: []
            },
            {
              NAME: '阜康市',
              NUM: '652302',
              children: []
            },
            {
              NAME: '呼图壁县',
              NUM: '652323',
              children: []
            },
            {
              NAME: '吉木萨尔县',
              NUM: '652327',
              children: []
            },
            {
              NAME: '玛纳斯县',
              NUM: '652324',
              children: []
            },
            {
              NAME: '木垒哈萨克自治县',
              NUM: '652328',
              children: []
            },
            {
              NAME: '奇台县',
              NUM: '652325',
              children: []
            }
          ]
        },
        {
          NAME: '哈密',
          NUM: '6505',
          children: [
            {
              NAME: '巴里坤哈萨克自治县',
              NUM: '650521',
              children: []
            },
            {
              NAME: '伊吾县',
              NUM: '650522',
              children: []
            },
            {
              NAME: '伊州区',
              NUM: '650502',
              children: []
            }
          ]
        },
        {
          NAME: '和田地区',
          NUM: '6532',
          children: [
            {
              NAME: '策勒县',
              NUM: '653225',
              children: []
            },
            {
              NAME: '和田市',
              NUM: '653201',
              children: []
            },
            {
              NAME: '和田县',
              NUM: '653221',
              children: []
            },
            {
              NAME: '洛浦县',
              NUM: '653224',
              children: []
            },
            {
              NAME: '民丰县',
              NUM: '653227',
              children: []
            },
            {
              NAME: '墨玉县',
              NUM: '653222',
              children: []
            },
            {
              NAME: '皮山县',
              NUM: '653223',
              children: []
            },
            {
              NAME: '于田县',
              NUM: '653226',
              children: []
            }
          ]
        },
        {
          NAME: '胡杨河',
          NUM: '659010',
          children: []
        },
        {
          NAME: '喀什地区',
          NUM: '6531',
          children: [
            {
              NAME: '巴楚县',
              NUM: '653130',
              children: []
            },
            {
              NAME: '伽师县',
              NUM: '653129',
              children: []
            },
            {
              NAME: '喀什市',
              NUM: '653101',
              children: []
            },
            {
              NAME: '麦盖提县',
              NUM: '653127',
              children: []
            },
            {
              NAME: '莎车县',
              NUM: '653125',
              children: []
            },
            {
              NAME: '疏附县',
              NUM: '653121',
              children: []
            },
            {
              NAME: '疏勒县',
              NUM: '653122',
              children: []
            },
            {
              NAME: '塔什库尔干塔吉克自治县',
              NUM: '653131',
              children: []
            },
            {
              NAME: '叶城县',
              NUM: '653126',
              children: []
            },
            {
              NAME: '英吉沙县',
              NUM: '653123',
              children: []
            },
            {
              NAME: '岳普湖县',
              NUM: '653128',
              children: []
            },
            {
              NAME: '泽普县',
              NUM: '653124',
              children: []
            }
          ]
        },
        {
          NAME: '可克达拉',
          NUM: '659008',
          children: []
        },
        {
          NAME: '克拉玛依',
          NUM: '6502',
          children: [
            {
              NAME: '白碱滩区',
              NUM: '650204',
              children: []
            },
            {
              NAME: '独山子区',
              NUM: '650202',
              children: []
            },
            {
              NAME: '克拉玛依区',
              NUM: '650203',
              children: []
            },
            {
              NAME: '乌尔禾区',
              NUM: '650205',
              children: []
            }
          ]
        },
        {
          NAME: '克孜勒苏柯尔克孜自治州',
          NUM: '6530',
          children: [
            {
              NAME: '阿合奇县',
              NUM: '653023',
              children: []
            },
            {
              NAME: '阿克陶县',
              NUM: '653022',
              children: []
            },
            {
              NAME: '阿图什市',
              NUM: '653001',
              children: []
            },
            {
              NAME: '乌恰县',
              NUM: '653024',
              children: []
            }
          ]
        },
        {
          NAME: '昆玉',
          NUM: '659009',
          children: []
        },
        {
          NAME: '石河子',
          NUM: '659001',
          children: []
        },
        {
          NAME: '双河',
          NUM: '659007',
          children: []
        },
        {
          NAME: '塔城地区',
          NUM: '6542',
          children: [
            {
              NAME: '额敏县',
              NUM: '654221',
              children: []
            },
            {
              NAME: '和布克赛尔蒙古自治县',
              NUM: '654226',
              children: []
            },
            {
              NAME: '沙湾市',
              NUM: '654203',
              children: []
            },
            {
              NAME: '塔城市',
              NUM: '654201',
              children: []
            },
            {
              NAME: '托里县',
              NUM: '654224',
              children: []
            },
            {
              NAME: '乌苏市',
              NUM: '654202',
              children: []
            },
            {
              NAME: '裕民县',
              NUM: '654225',
              children: []
            }
          ]
        },
        {
          NAME: '铁门关',
          NUM: '659006',
          children: []
        },
        {
          NAME: '吐鲁番',
          NUM: '6504',
          children: [
            {
              NAME: '高昌区',
              NUM: '650402',
              children: []
            },
            {
              NAME: '鄯善县',
              NUM: '650421',
              children: []
            },
            {
              NAME: '托克逊县',
              NUM: '650422',
              children: []
            }
          ]
        },
        {
          NAME: '图木舒克',
          NUM: '659003',
          children: []
        },
        {
          NAME: '五家渠',
          NUM: '659004',
          children: []
        },
        {
          NAME: '乌鲁木齐',
          NUM: '6501',
          children: [
            {
              NAME: '达坂城区',
              NUM: '650107',
              children: []
            },
            {
              NAME: '米东区',
              NUM: '650109',
              children: []
            },
            {
              NAME: '沙依巴克区',
              NUM: '650103',
              children: []
            },
            {
              NAME: '水磨沟区',
              NUM: '650105',
              children: []
            },
            {
              NAME: '天山区',
              NUM: '650102',
              children: []
            },
            {
              NAME: '头屯河区',
              NUM: '650106',
              children: []
            },
            {
              NAME: '乌鲁木齐县',
              NUM: '650121',
              children: []
            },
            {
              NAME: '新市区',
              NUM: '650104',
              children: []
            }
          ]
        },
        {
          NAME: '新星',
          NUM: '659011',
          children: []
        },
        {
          NAME: '伊犁哈萨克自治州',
          NUM: '6540',
          children: [
            {
              NAME: '察布查尔锡伯自治县',
              NUM: '654022',
              children: []
            },
            {
              NAME: '巩留县',
              NUM: '654024',
              children: []
            },
            {
              NAME: '霍城县',
              NUM: '654023',
              children: []
            },
            {
              NAME: '霍尔果斯市',
              NUM: '654004',
              children: []
            },
            {
              NAME: '奎屯市',
              NUM: '654003',
              children: []
            },
            {
              NAME: '尼勒克县',
              NUM: '654028',
              children: []
            },
            {
              NAME: '特克斯县',
              NUM: '654027',
              children: []
            },
            {
              NAME: '新源县',
              NUM: '654025',
              children: []
            },
            {
              NAME: '伊宁市',
              NUM: '654002',
              children: []
            },
            {
              NAME: '伊宁县',
              NUM: '654021',
              children: []
            },
            {
              NAME: '昭苏县',
              NUM: '654026',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '西藏',
      NUM: '54',
      CODE: '',
      children: [
        {
          NAME: '阿里地区',
          NUM: '5425',
          children: [
            {
              NAME: '措勤县',
              NUM: '542527',
              children: []
            },
            {
              NAME: '噶尔县',
              NUM: '542523',
              children: []
            },
            {
              NAME: '改则县',
              NUM: '542526',
              children: []
            },
            {
              NAME: '革吉县',
              NUM: '542525',
              children: []
            },
            {
              NAME: '普兰县',
              NUM: '542521',
              children: []
            },
            {
              NAME: '日土县',
              NUM: '542524',
              children: []
            },
            {
              NAME: '札达县',
              NUM: '542522',
              children: []
            }
          ]
        },
        {
          NAME: '昌都',
          NUM: '5403',
          children: [
            {
              NAME: '八宿县',
              NUM: '540326',
              children: []
            },
            {
              NAME: '边坝县',
              NUM: '540330',
              children: []
            },
            {
              NAME: '察雅县',
              NUM: '540325',
              children: []
            },
            {
              NAME: '丁青县',
              NUM: '540324',
              children: []
            },
            {
              NAME: '贡觉县',
              NUM: '540322',
              children: []
            },
            {
              NAME: '江达县',
              NUM: '540321',
              children: []
            },
            {
              NAME: '卡若区',
              NUM: '540302',
              children: []
            },
            {
              NAME: '类乌齐县',
              NUM: '540323',
              children: []
            },
            {
              NAME: '洛隆县',
              NUM: '540329',
              children: []
            },
            {
              NAME: '芒康县',
              NUM: '540328',
              children: []
            },
            {
              NAME: '左贡县',
              NUM: '540327',
              children: []
            }
          ]
        },
        {
          NAME: '拉萨',
          NUM: '5401',
          children: [
            {
              NAME: '城关区',
              NUM: '540102',
              children: []
            },
            {
              NAME: '当雄县',
              NUM: '540122',
              children: []
            },
            {
              NAME: '达孜工业园区',
              NUM: '540174',
              children: []
            },
            {
              NAME: '达孜区',
              NUM: '540104',
              children: []
            },
            {
              NAME: '堆龙德庆区',
              NUM: '540103',
              children: []
            },
            {
              NAME: '格尔木藏青工业园区',
              NUM: '540171',
              children: []
            },
            {
              NAME: '拉萨经济技术开发区',
              NUM: '540172',
              children: []
            },
            {
              NAME: '林周县',
              NUM: '540121',
              children: []
            },
            {
              NAME: '墨竹工卡县',
              NUM: '540127',
              children: []
            },
            {
              NAME: '尼木县',
              NUM: '540123',
              children: []
            },
            {
              NAME: '曲水县',
              NUM: '540124',
              children: []
            },
            {
              NAME: '西藏文化旅游创意园区',
              NUM: '540173',
              children: []
            }
          ]
        },
        {
          NAME: '林芝',
          NUM: '5404',
          children: [
            {
              NAME: '巴宜区',
              NUM: '540402',
              children: []
            },
            {
              NAME: '波密县',
              NUM: '540424',
              children: []
            },
            {
              NAME: '察隅县',
              NUM: '540425',
              children: []
            },
            {
              NAME: '工布江达县',
              NUM: '540421',
              children: []
            },
            {
              NAME: '朗县',
              NUM: '540426',
              children: []
            },
            {
              NAME: '米林市',
              NUM: '540481',
              children: []
            },
            {
              NAME: '墨脱县',
              NUM: '540423',
              children: []
            }
          ]
        },
        {
          NAME: '那曲',
          NUM: '5406',
          children: [
            {
              NAME: '安多县',
              NUM: '540624',
              children: []
            },
            {
              NAME: '班戈县',
              NUM: '540627',
              children: []
            },
            {
              NAME: '巴青县',
              NUM: '540628',
              children: []
            },
            {
              NAME: '比如县',
              NUM: '540622',
              children: []
            },
            {
              NAME: '嘉黎县',
              NUM: '540621',
              children: []
            },
            {
              NAME: '聂荣县',
              NUM: '540623',
              children: []
            },
            {
              NAME: '尼玛县',
              NUM: '540629',
              children: []
            },
            {
              NAME: '色尼区',
              NUM: '540602',
              children: []
            },
            {
              NAME: '申扎县',
              NUM: '540625',
              children: []
            },
            {
              NAME: '双湖县',
              NUM: '540630',
              children: []
            },
            {
              NAME: '索县',
              NUM: '540626',
              children: []
            }
          ]
        },
        {
          NAME: '日喀则',
          NUM: '5402',
          children: [
            {
              NAME: '昂仁县',
              NUM: '540226',
              children: []
            },
            {
              NAME: '白朗县',
              NUM: '540228',
              children: []
            },
            {
              NAME: '定结县',
              NUM: '540231',
              children: []
            },
            {
              NAME: '定日县',
              NUM: '540223',
              children: []
            },
            {
              NAME: '岗巴县',
              NUM: '540237',
              children: []
            },
            {
              NAME: '江孜县',
              NUM: '540222',
              children: []
            },
            {
              NAME: '吉隆县',
              NUM: '540234',
              children: []
            },
            {
              NAME: '康马县',
              NUM: '540230',
              children: []
            },
            {
              NAME: '拉孜县',
              NUM: '540225',
              children: []
            },
            {
              NAME: '南木林县',
              NUM: '540221',
              children: []
            },
            {
              NAME: '聂拉木县',
              NUM: '540235',
              children: []
            },
            {
              NAME: '仁布县',
              NUM: '540229',
              children: []
            },
            {
              NAME: '萨嘎县',
              NUM: '540236',
              children: []
            },
            {
              NAME: '萨迦县',
              NUM: '540224',
              children: []
            },
            {
              NAME: '桑珠孜区',
              NUM: '540202',
              children: []
            },
            {
              NAME: '谢通门县',
              NUM: '540227',
              children: []
            },
            {
              NAME: '亚东县',
              NUM: '540233',
              children: []
            },
            {
              NAME: '仲巴县',
              NUM: '540232',
              children: []
            }
          ]
        },
        {
          NAME: '山南',
          NUM: '5405',
          children: [
            {
              NAME: '措美县',
              NUM: '540526',
              children: []
            },
            {
              NAME: '错那市',
              NUM: '540581',
              children: []
            },
            {
              NAME: '贡嘎县',
              NUM: '540522',
              children: []
            },
            {
              NAME: '加查县',
              NUM: '540528',
              children: []
            },
            {
              NAME: '浪卡子县',
              NUM: '540531',
              children: []
            },
            {
              NAME: '隆子县',
              NUM: '540529',
              children: []
            },
            {
              NAME: '洛扎县',
              NUM: '540527',
              children: []
            },
            {
              NAME: '乃东区',
              NUM: '540502',
              children: []
            },
            {
              NAME: '琼结县',
              NUM: '540524',
              children: []
            },
            {
              NAME: '曲松县',
              NUM: '540525',
              children: []
            },
            {
              NAME: '桑日县',
              NUM: '540523',
              children: []
            },
            {
              NAME: '扎囊县',
              NUM: '540521',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '云南',
      NUM: '53',
      CODE: 'Y',
      children: [
        {
          NAME: '保山',
          NUM: '5305',
          children: [
            {
              NAME: '昌宁县',
              NUM: '530524',
              children: []
            },
            {
              NAME: '龙陵县',
              NUM: '530523',
              children: []
            },
            {
              NAME: '隆阳区',
              NUM: '530502',
              children: []
            },
            {
              NAME: '施甸县',
              NUM: '530521',
              children: []
            },
            {
              NAME: '腾冲市',
              NUM: '530581',
              children: []
            }
          ]
        },
        {
          NAME: '楚雄彝族自治州',
          NUM: '5323',
          children: [
            {
              NAME: '楚雄市',
              NUM: '532301',
              children: []
            },
            {
              NAME: '大姚县',
              NUM: '532326',
              children: []
            },
            {
              NAME: '禄丰市',
              NUM: '532302',
              children: []
            },
            {
              NAME: '牟定县',
              NUM: '532323',
              children: []
            },
            {
              NAME: '南华县',
              NUM: '532324',
              children: []
            },
            {
              NAME: '双柏县',
              NUM: '532322',
              children: []
            },
            {
              NAME: '武定县',
              NUM: '532329',
              children: []
            },
            {
              NAME: '姚安县',
              NUM: '532325',
              children: []
            },
            {
              NAME: '永仁县',
              NUM: '532327',
              children: []
            },
            {
              NAME: '元谋县',
              NUM: '532328',
              children: []
            }
          ]
        },
        {
          NAME: '大理白族自治州',
          NUM: '5329',
          children: [
            {
              NAME: '宾川县',
              NUM: '532924',
              children: []
            },
            {
              NAME: '大理市',
              NUM: '532901',
              children: []
            },
            {
              NAME: '洱源县',
              NUM: '532930',
              children: []
            },
            {
              NAME: '鹤庆县',
              NUM: '532932',
              children: []
            },
            {
              NAME: '剑川县',
              NUM: '532931',
              children: []
            },
            {
              NAME: '弥渡县',
              NUM: '532925',
              children: []
            },
            {
              NAME: '南涧彝族自治县',
              NUM: '532926',
              children: []
            },
            {
              NAME: '巍山彝族回族自治县',
              NUM: '532927',
              children: []
            },
            {
              NAME: '祥云县',
              NUM: '532923',
              children: []
            },
            {
              NAME: '漾濞彝族自治县',
              NUM: '532922',
              children: []
            },
            {
              NAME: '永平县',
              NUM: '532928',
              children: []
            },
            {
              NAME: '云龙县',
              NUM: '532929',
              children: []
            }
          ]
        },
        {
          NAME: '德宏傣族景颇族自治州',
          NUM: '5331',
          children: [
            {
              NAME: '梁河县',
              NUM: '533122',
              children: []
            },
            {
              NAME: '陇川县',
              NUM: '533124',
              children: []
            },
            {
              NAME: '芒市',
              NUM: '533103',
              children: []
            },
            {
              NAME: '瑞丽市',
              NUM: '533102',
              children: []
            },
            {
              NAME: '盈江县',
              NUM: '533123',
              children: []
            }
          ]
        },
        {
          NAME: '迪庆藏族自治州',
          NUM: '5334',
          children: [
            {
              NAME: '德钦县',
              NUM: '533422',
              children: []
            },
            {
              NAME: '维西傈僳族自治县',
              NUM: '533423',
              children: []
            },
            {
              NAME: '香格里拉市',
              NUM: '533401',
              children: []
            }
          ]
        },
        {
          NAME: '红河哈尼族彝族自治州',
          NUM: '5325',
          children: [
            {
              NAME: '个旧市',
              NUM: '532501',
              children: []
            },
            {
              NAME: '河口瑶族自治县',
              NUM: '532532',
              children: []
            },
            {
              NAME: '红河县',
              NUM: '532529',
              children: []
            },
            {
              NAME: '建水县',
              NUM: '532524',
              children: []
            },
            {
              NAME: '金平苗族瑶族傣族自治县',
              NUM: '532530',
              children: []
            },
            {
              NAME: '开远市',
              NUM: '532502',
              children: []
            },
            {
              NAME: '泸西县',
              NUM: '532527',
              children: []
            },
            {
              NAME: '绿春县',
              NUM: '532531',
              children: []
            },
            {
              NAME: '蒙自市',
              NUM: '532503',
              children: []
            },
            {
              NAME: '弥勒市',
              NUM: '532504',
              children: []
            },
            {
              NAME: '屏边苗族自治县',
              NUM: '532523',
              children: []
            },
            {
              NAME: '石屏县',
              NUM: '532525',
              children: []
            },
            {
              NAME: '元阳县',
              NUM: '532528',
              children: []
            }
          ]
        },
        {
          NAME: '昆明',
          NUM: '5301',
          children: [
            {
              NAME: '安宁市',
              NUM: '530181',
              children: []
            },
            {
              NAME: '呈贡区',
              NUM: '530114',
              children: []
            },
            {
              NAME: '东川区',
              NUM: '530113',
              children: []
            },
            {
              NAME: '富民县',
              NUM: '530124',
              children: []
            },
            {
              NAME: '官渡区',
              NUM: '530111',
              children: []
            },
            {
              NAME: '晋宁区',
              NUM: '530115',
              children: []
            },
            {
              NAME: '禄劝彝族苗族自治县',
              NUM: '530128',
              children: []
            },
            {
              NAME: '盘龙区',
              NUM: '530103',
              children: []
            },
            {
              NAME: '石林彝族自治县',
              NUM: '530126',
              children: []
            },
            {
              NAME: '嵩明县',
              NUM: '530127',
              children: []
            },
            {
              NAME: '五华区',
              NUM: '530102',
              children: []
            },
            {
              NAME: '西山区',
              NUM: '530112',
              children: []
            },
            {
              NAME: '寻甸回族彝族自治县',
              NUM: '530129',
              children: []
            },
            {
              NAME: '宜良县',
              NUM: '530125',
              children: []
            }
          ]
        },
        {
          NAME: '丽江',
          NUM: '5307',
          children: [
            {
              NAME: '古城区',
              NUM: '530702',
              children: []
            },
            {
              NAME: '华坪县',
              NUM: '530723',
              children: []
            },
            {
              NAME: '宁蒗彝族自治县',
              NUM: '530724',
              children: []
            },
            {
              NAME: '永胜县',
              NUM: '530722',
              children: []
            },
            {
              NAME: '玉龙纳西族自治县',
              NUM: '530721',
              children: []
            }
          ]
        },
        {
          NAME: '临沧',
          NUM: '5309',
          children: [
            {
              NAME: '沧源佤族自治县',
              NUM: '530927',
              children: []
            },
            {
              NAME: '凤庆县',
              NUM: '530921',
              children: []
            },
            {
              NAME: '耿马傣族佤族自治县',
              NUM: '530926',
              children: []
            },
            {
              NAME: '临翔区',
              NUM: '530902',
              children: []
            },
            {
              NAME: '双江拉祜族佤族布朗族傣族自治县',
              NUM: '530925',
              children: []
            },
            {
              NAME: '永德县',
              NUM: '530923',
              children: []
            },
            {
              NAME: '云县',
              NUM: '530922',
              children: []
            },
            {
              NAME: '镇康县',
              NUM: '530924',
              children: []
            }
          ]
        },
        {
          NAME: '怒江傈僳族自治州',
          NUM: '5333',
          children: [
            {
              NAME: '福贡县',
              NUM: '533323',
              children: []
            },
            {
              NAME: '贡山独龙族怒族自治县',
              NUM: '533324',
              children: []
            },
            {
              NAME: '兰坪白族普米族自治县',
              NUM: '533325',
              children: []
            },
            {
              NAME: '泸水市',
              NUM: '533301',
              children: []
            }
          ]
        },
        {
          NAME: '普洱',
          NUM: '5308',
          children: [
            {
              NAME: '江城哈尼族彝族自治县',
              NUM: '530826',
              children: []
            },
            {
              NAME: '景东彝族自治县',
              NUM: '530823',
              children: []
            },
            {
              NAME: '景谷傣族彝族自治县',
              NUM: '530824',
              children: []
            },
            {
              NAME: '澜沧拉祜族自治县',
              NUM: '530828',
              children: []
            },
            {
              NAME: '孟连傣族拉祜族佤族自治县',
              NUM: '530827',
              children: []
            },
            {
              NAME: '墨江哈尼族自治县',
              NUM: '530822',
              children: []
            },
            {
              NAME: '宁洱哈尼族彝族自治县',
              NUM: '530821',
              children: []
            },
            {
              NAME: '思茅区',
              NUM: '530802',
              children: []
            },
            {
              NAME: '西盟佤族自治县',
              NUM: '530829',
              children: []
            },
            {
              NAME: '镇沅彝族哈尼族拉祜族自治县',
              NUM: '530825',
              children: []
            }
          ]
        },
        {
          NAME: '曲靖',
          NUM: '5303',
          children: [
            {
              NAME: '富源县',
              NUM: '530325',
              children: []
            },
            {
              NAME: '会泽县',
              NUM: '530326',
              children: []
            },
            {
              NAME: '陆良县',
              NUM: '530322',
              children: []
            },
            {
              NAME: '罗平县',
              NUM: '530324',
              children: []
            },
            {
              NAME: '马龙区',
              NUM: '530304',
              children: []
            },
            {
              NAME: '麒麟区',
              NUM: '530302',
              children: []
            },
            {
              NAME: '师宗县',
              NUM: '530323',
              children: []
            },
            {
              NAME: '宣威市',
              NUM: '530381',
              children: []
            },
            {
              NAME: '沾益区',
              NUM: '530303',
              children: []
            }
          ]
        },
        {
          NAME: '文山壮族苗族自治州',
          NUM: '5326',
          children: [
            {
              NAME: '富宁县',
              NUM: '532628',
              children: []
            },
            {
              NAME: '广南县',
              NUM: '532627',
              children: []
            },
            {
              NAME: '马关县',
              NUM: '532625',
              children: []
            },
            {
              NAME: '麻栗坡县',
              NUM: '532624',
              children: []
            },
            {
              NAME: '丘北县',
              NUM: '532626',
              children: []
            },
            {
              NAME: '文山市',
              NUM: '532601',
              children: []
            },
            {
              NAME: '西畴县',
              NUM: '532623',
              children: []
            },
            {
              NAME: '砚山县',
              NUM: '532622',
              children: []
            }
          ]
        },
        {
          NAME: '西双版纳傣族自治州',
          NUM: '5328',
          children: [
            {
              NAME: '景洪市',
              NUM: '532801',
              children: []
            },
            {
              NAME: '勐海县',
              NUM: '532822',
              children: []
            },
            {
              NAME: '勐腊县',
              NUM: '532823',
              children: []
            }
          ]
        },
        {
          NAME: '玉溪',
          NUM: '5304',
          children: [
            {
              NAME: '澄江市',
              NUM: '530481',
              children: []
            },
            {
              NAME: '峨山彝族自治县',
              NUM: '530426',
              children: []
            },
            {
              NAME: '红塔区',
              NUM: '530402',
              children: []
            },
            {
              NAME: '华宁县',
              NUM: '530424',
              children: []
            },
            {
              NAME: '江川区',
              NUM: '530403',
              children: []
            },
            {
              NAME: '通海县',
              NUM: '530423',
              children: []
            },
            {
              NAME: '新平彝族傣族自治县',
              NUM: '530427',
              children: []
            },
            {
              NAME: '易门县',
              NUM: '530425',
              children: []
            },
            {
              NAME: '元江哈尼族彝族傣族自治县',
              NUM: '530428',
              children: []
            }
          ]
        },
        {
          NAME: '昭通',
          NUM: '5306',
          children: [
            {
              NAME: '大关县',
              NUM: '530624',
              children: []
            },
            {
              NAME: '鲁甸县',
              NUM: '530621',
              children: []
            },
            {
              NAME: '巧家县',
              NUM: '530622',
              children: []
            },
            {
              NAME: '水富市',
              NUM: '530681',
              children: []
            },
            {
              NAME: '绥江县',
              NUM: '530626',
              children: []
            },
            {
              NAME: '威信县',
              NUM: '530629',
              children: []
            },
            {
              NAME: '盐津县',
              NUM: '530623',
              children: []
            },
            {
              NAME: '彝良县',
              NUM: '530628',
              children: []
            },
            {
              NAME: '永善县',
              NUM: '530625',
              children: []
            },
            {
              NAME: '昭阳区',
              NUM: '530602',
              children: []
            },
            {
              NAME: '镇雄县',
              NUM: '530627',
              children: []
            }
          ]
        }
      ]
    },
    {
      NAME: '浙江',
      NUM: '33',
      CODE: 'Z',
      children: [
        {
          NAME: '杭州',
          NUM: '3301',
          children: [
            {
              NAME: '滨江区',
              NUM: '330108',
              children: []
            },
            {
              NAME: '淳安县',
              NUM: '330127',
              children: []
            },
            {
              NAME: '富阳区',
              NUM: '330111',
              children: []
            },
            {
              NAME: '拱墅区',
              NUM: '330105',
              children: []
            },
            {
              NAME: '建德市',
              NUM: '330182',
              children: []
            },
            {
              NAME: '临安区',
              NUM: '330112',
              children: []
            },
            {
              NAME: '临平区',
              NUM: '330113',
              children: []
            },
            {
              NAME: '钱塘区',
              NUM: '330114',
              children: []
            },
            {
              NAME: '上城区',
              NUM: '330102',
              children: []
            },
            {
              NAME: '桐庐县',
              NUM: '330122',
              children: []
            },
            {
              NAME: '萧山区',
              NUM: '330109',
              children: []
            },
            {
              NAME: '西湖区',
              NUM: '330106',
              children: []
            },
            {
              NAME: '余杭区',
              NUM: '330110',
              children: []
            }
          ]
        },
        {
          NAME: '湖州',
          NUM: '3305',
          children: [
            {
              NAME: '安吉县',
              NUM: '330523',
              children: []
            },
            {
              NAME: '长兴县',
              NUM: '330522',
              children: []
            },
            {
              NAME: '德清县',
              NUM: '330521',
              children: []
            },
            {
              NAME: '南浔区',
              NUM: '330503',
              children: []
            },
            {
              NAME: '吴兴区',
              NUM: '330502',
              children: []
            }
          ]
        },
        {
          NAME: '嘉兴',
          NUM: '3304',
          children: [
            {
              NAME: '海宁市',
              NUM: '330481',
              children: []
            },
            {
              NAME: '海盐县',
              NUM: '330424',
              children: []
            },
            {
              NAME: '嘉善县',
              NUM: '330421',
              children: []
            },
            {
              NAME: '南湖区',
              NUM: '330402',
              children: []
            },
            {
              NAME: '平湖市',
              NUM: '330482',
              children: []
            },
            {
              NAME: '桐乡市',
              NUM: '330483',
              children: []
            },
            {
              NAME: '秀洲区',
              NUM: '330411',
              children: []
            }
          ]
        },
        {
          NAME: '金华',
          NUM: '3307',
          children: [
            {
              NAME: '东阳市',
              NUM: '330783',
              children: []
            },
            {
              NAME: '金东区',
              NUM: '330703',
              children: []
            },
            {
              NAME: '兰溪市',
              NUM: '330781',
              children: []
            },
            {
              NAME: '磐安县',
              NUM: '330727',
              children: []
            },
            {
              NAME: '浦江县',
              NUM: '330726',
              children: []
            },
            {
              NAME: '婺城区',
              NUM: '330702',
              children: []
            },
            {
              NAME: '武义县',
              NUM: '330723',
              children: []
            },
            {
              NAME: '义乌市',
              NUM: '330782',
              children: []
            },
            {
              NAME: '永康市',
              NUM: '330784',
              children: []
            }
          ]
        },
        {
          NAME: '丽水',
          NUM: '3311',
          children: [
            {
              NAME: '景宁畲族自治县',
              NUM: '331127',
              children: []
            },
            {
              NAME: '缙云县',
              NUM: '331122',
              children: []
            },
            {
              NAME: '莲都区',
              NUM: '331102',
              children: []
            },
            {
              NAME: '龙泉市',
              NUM: '331181',
              children: []
            },
            {
              NAME: '青田县',
              NUM: '331121',
              children: []
            },
            {
              NAME: '庆元县',
              NUM: '331126',
              children: []
            },
            {
              NAME: '松阳县',
              NUM: '331124',
              children: []
            },
            {
              NAME: '遂昌县',
              NUM: '331123',
              children: []
            },
            {
              NAME: '云和县',
              NUM: '331125',
              children: []
            }
          ]
        },
        {
          NAME: '宁波',
          NUM: '3302',
          children: [
            {
              NAME: '北仑区',
              NUM: '330206',
              children: []
            },
            {
              NAME: '慈溪市',
              NUM: '330282',
              children: []
            },
            {
              NAME: '奉化区',
              NUM: '330213',
              children: []
            },
            {
              NAME: '海曙区',
              NUM: '330203',
              children: []
            },
            {
              NAME: '江北区',
              NUM: '330205',
              children: []
            },
            {
              NAME: '宁海县',
              NUM: '330226',
              children: []
            },
            {
              NAME: '象山县',
              NUM: '330225',
              children: []
            },
            {
              NAME: '鄞州区',
              NUM: '330212',
              children: []
            },
            {
              NAME: '余姚市',
              NUM: '330281',
              children: []
            },
            {
              NAME: '镇海区',
              NUM: '330211',
              children: []
            }
          ]
        },
        {
          NAME: '衢州',
          NUM: '3308',
          children: [
            {
              NAME: '常山县',
              NUM: '330822',
              children: []
            },
            {
              NAME: '江山市',
              NUM: '330881',
              children: []
            },
            {
              NAME: '开化县',
              NUM: '330824',
              children: []
            },
            {
              NAME: '柯城区',
              NUM: '330802',
              children: []
            },
            {
              NAME: '龙游县',
              NUM: '330825',
              children: []
            },
            {
              NAME: '衢江区',
              NUM: '330803',
              children: []
            }
          ]
        },
        {
          NAME: '绍兴',
          NUM: '3306',
          children: [
            {
              NAME: '柯桥区',
              NUM: '330603',
              children: []
            },
            {
              NAME: '上虞区',
              NUM: '330604',
              children: []
            },
            {
              NAME: '嵊州市',
              NUM: '330683',
              children: []
            },
            {
              NAME: '新昌县',
              NUM: '330624',
              children: []
            },
            {
              NAME: '越城区',
              NUM: '330602',
              children: []
            },
            {
              NAME: '诸暨市',
              NUM: '330681',
              children: []
            }
          ]
        },
        {
          NAME: '台州',
          NUM: '3310',
          children: [
            {
              NAME: '黄岩区',
              NUM: '331003',
              children: []
            },
            {
              NAME: '椒江区',
              NUM: '331002',
              children: []
            },
            {
              NAME: '临海市',
              NUM: '331082',
              children: []
            },
            {
              NAME: '路桥区',
              NUM: '331004',
              children: []
            },
            {
              NAME: '三门县',
              NUM: '331022',
              children: []
            },
            {
              NAME: '天台县',
              NUM: '331023',
              children: []
            },
            {
              NAME: '温岭市',
              NUM: '331081',
              children: []
            },
            {
              NAME: '仙居县',
              NUM: '331024',
              children: []
            },
            {
              NAME: '玉环市',
              NUM: '331083',
              children: []
            }
          ]
        },
        {
          NAME: '温州',
          NUM: '3303',
          children: [
            {
              NAME: '苍南县',
              NUM: '330327',
              children: []
            },
            {
              NAME: '洞头区',
              NUM: '330305',
              children: []
            },
            {
              NAME: '龙港市',
              NUM: '330383',
              children: []
            },
            {
              NAME: '龙湾区',
              NUM: '330303',
              children: []
            },
            {
              NAME: '鹿城区',
              NUM: '330302',
              children: []
            },
            {
              NAME: '瓯海区',
              NUM: '330304',
              children: []
            },
            {
              NAME: '平阳县',
              NUM: '330326',
              children: []
            },
            {
              NAME: '瑞安市',
              NUM: '330381',
              children: []
            },
            {
              NAME: '泰顺县',
              NUM: '330329',
              children: []
            },
            {
              NAME: '文成县',
              NUM: '330328',
              children: []
            },
            {
              NAME: '永嘉县',
              NUM: '330324',
              children: []
            },
            {
              NAME: '乐清市',
              NUM: '330382',
              children: []
            }
          ]
        },
        {
          NAME: '舟山',
          NUM: '3309',
          children: [
            {
              NAME: '岱山县',
              NUM: '330921',
              children: []
            },
            {
              NAME: '定海区',
              NUM: '330902',
              children: []
            },
            {
              NAME: '普陀区',
              NUM: '330903',
              children: []
            },
            {
              NAME: '嵊泗县',
              NUM: '330922',
              children: []
            }
          ]
        }
      ]
    }
  ]
};

export const municipality = [
  '4420',
  '4419',
  '6202',
  '5209',
  '1331',
  '2115',
  '659012',
  '429005',
  '429006',
  '429021',
  '429004',
  '419001',
  '469007',
  '469028',
  '469006',
  '469029',
  '469022',
  '469021',
  '4604',
  '469024',
  '469027',
  '469030',
  '469002',
  '469005',
  '469025',
  '469023',
  '469001',
  '469026',
  '659010',
  '659007',
  '659003',
  '659005',
  '659001',
  '659006',
  '659008',
  '659002',
  '659011',
  '659004',
  '659009'
];

// 层级结构的区域转成map结构
export const flattenAdministrativeAreas = (function() {
  let result = {};
  walk(administrativeAreas.normal, null);
  return result;

  function walk(list, parent) {
    list.forEach(item => {
      item.parent = parent;
      result[item.NUM] = item;
      item.children && walk(item.children, item);
    });
  }
})();



// WEBPACK FOOTER //
// ./src/common/administrativeAreas.js